module.exports = {
	"全國不分區": {
		"": [
			{
				"w": 9,
				"name": "尤美女",
				"ename": "Yu Mei Nu",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly11115a@ly.gov.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學法律學研究所碩士",
				"profession": "",
				"experience": "第8屆立委\n 台北律師公會前理事長\n 台灣婦女團體全國聯合會創會理事長\n 婦女新知基金會前董事長\n 總統府前人權諮詢委員",
				"allTel": "國會研究室：02-2358-8112",
				"labTel": "02-2358-8112",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8113",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90007.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0402室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0402室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/yumeinu/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%B0%A4%E7%BE%8E%E5%A5%B3",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "王育敏",
				"ename": "Wang Yu Min",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly11113a@ly.gov.tw",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "東海大學社會工作學系碩士\n ;東海大學社會工作學系學士",
				"profession": "",
				"experience": "第8屆立法委員\n \n 總統府人權諮詢小組委員\n \n 內政部兒少福利委員會委員\n \n 兒童福利聯盟基金會執行長",
				"allTel": "國會研究室：02-2358-8261",
				"labTel": "02-2358-8261",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8265",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90002.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3401室",
				"labAddr": "10051臺北市中正區青島東路1-3號3401室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/LYWYM/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E8%82%B2%E6%95%8F",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "王金平",
				"ename": "Wang Jin Pyng",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly10022a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣省立師範大學數學系畢業",
				"profession": "外交及國防委員會",
				"experience": "立法院院長、副院長\n 中國國民黨副主席\n 國家生技醫療產業策進會會長",
				"allTel": "國會研究室：02-2358-8681;高雄服務處：07-607-5509",
				"labTel": "02-2358-8681",
				"serviceTel1": "高雄服務處：07-607-5509",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8685;高雄服務處：07-607-5669",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90001.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區鎮江街2號1樓;高雄服務處：高雄市路竹區甲南村大仁路369巷7號",
				"labAddr": "10051臺北市中正區鎮江街2號1樓",
				"serviceAdd1": "高雄服務處：高雄市路竹區甲南村大仁路369巷7號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%8E%8B%E9%87%91%E5%B9%B3-173927656287650/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E9%87%91%E5%B9%B3",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "王榮璋",
				"ename": "Wang Jung Chang",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "jung3636@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立岡山高中畢業",
				"profession": "財政委員會",
				"experience": "中華民國身心障礙聯盟秘書長\n 台灣社會心理復健協會理事長\n 台灣社會福利總盟常務理事\n 伊甸社會福利基金會顧問\n 蘋果日報慈善基金會常務董事\n 新境界文教基金會董事\n 臺灣少年權益及福利促進聯盟顧問\n 第6屆立法委員",
				"allTel": "國會研究室：02-2358-8258",
				"labTel": "02-2358-8258",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8260",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90005.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2101室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2101室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E6%A6%AE%E7%92%8B",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "余宛如",
				"ename": "Yu Wan Ju",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "service@yuwanju.cc",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "倫敦大學亞非學院飲食人類學碩士\n ;臺灣大學經濟系學士",
				"profession": "財政委員會",
				"experience": "生態綠(股)公司創辦人、董事長\n \n Fairtrade Taiwan臺灣公平貿易推廣協會理事長\n \n 社會企業發展聯盟理事\n \n 綠色電商聯盟副理事長",
				"allTel": "國會研究室：02-2358-8011",
				"labTel": "02-2358-8011",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8015",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90011.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路10號3503室",
				"labAddr": "10051臺北市中正區青島東路10號3503室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/Yuwanju/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E4%BD%99%E5%AE%9B%E5%A6%82",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "吳玉琴",
				"ename": "Wu Yu Chin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly2115wu@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "東海大學社會工作碩士;政治大學社會學系學士;嘉義女中",
				"profession": "",
				"experience": "中華民國老人福利推動聯盟秘書長\n 臺灣社會福利總盟理事長\n 衛福部老人福利推動小組委員\n 衛福部全民健康保險會委員\n 實踐大學社會工作學系講師",
				"allTel": "國會研究室：02-2358-6046",
				"labTel": "02-2358-6046",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6050",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90012.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2115室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2115室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/ly2115",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%90%B3%E7%8E%89%E7%90%B4",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "吳志揚",
				"ename": "Wu John Chih Yang",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly11005a@ly.gov.tw",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "哈佛大學法學碩士\n ;臺灣大學法律研究所碩士\n ;臺灣大學法律系畢業",
				"profession": "教育及文化委員會",
				"experience": "中華職業棒球大聯盟會長\n \n 桃園縣長\n \n 第6、7屆立法委員\n \n 中原大學、台灣警專榮譽教授\n \n 執業律師",
				"allTel": "國會研究室：02-2358-6411",
				"labTel": "02-2358-6411",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6415",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90013.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2117室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2117室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/johnwu28/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%90%B3%E5%BF%97%E6%8F%9A_(%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "吳焜裕",
				"ename": "Wu Kuen Yuh",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "legislatoroffoodsanitation@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國北卡蘿萊納大學教堂山分校環境工程科博士(毒理);美國北卡蘿萊納大學教堂山分校碩士(環境工程科學);國立陽明大學醫學工程碩士;國立清華大學化學工程系學士;嘉義高中;嘉義市民生國中;嘉義市志航國小",
				"profession": "",
				"experience": "臺灣大學職業醫學與工業衛生研究所教授\n 國家衛生研究院環境衛生與職業醫學組副研究員\n 中國醫藥大學職業安全與衛生學系助理教授\n 臺灣風險分析學會理事長\n 中華民國環境保護學會常務理事\n 環保團體看守臺灣協會理事長\n 臺灣環保聯盟副會長",
				"allTel": "國會研究室：02-2358-6222",
				"labTel": "02-2358-6222",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6225",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90016.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3309室",
				"labAddr": "10051臺北市中正區青島東路1-3號3309室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%A3%9F%E5%AE%89%E7%AB%8B%E5%A7%94-%E5%90%B3%E7%84%9C%E8%A3%95-154149124966399/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%90%B3%E7%84%9C%E8%A3%95",
				"LineID": ""
			},
			{
				"w": "離職",
				"name": "李應元",
				"ename": "Lee Ying Yuan",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly11120a@ly.gov.tw",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國北卡羅來納大學哲學博士\n ;台大公共衛生學研究所碩士\n ;台大公共衛生學系學士",
				"profession": "",
				"experience": "第3、4、8屆立法委員\n \n 行政院秘書長\n \n 駐美副代表 \n \n 勞工委員會主任委員",
				"allTel": "國會研究室：02-2358-8156;虎尾服務處：05-636-5296;05-636-5396",
				"labTel": "02-2358-8156",
				"serviceTel1": "虎尾服務處：05-636-5296",
				"serviceTel2": "05-636-5396",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8160",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90023.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0701室;虎尾服務處：雲林縣虎尾鎮光復路505號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0701室",
				"serviceAdd1": "虎尾服務處：雲林縣虎尾鎮光復路505號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/LeeYingYuan\nhttps://www.facebook.com/LoveYingYuan/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9D%8E%E6%87%89%E5%85%83",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "李鴻鈞",
				"ename": "Lee Hung Chun",
				"sex": "男",
				"party": "親民黨",
				"partyGroup": "親民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly53198@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "日本大學結構工程學博士;黎明工專畢業",
				"profession": "交通委員會",
				"experience": "第5、6、7、8屆立法委員\n 立法院台日交流聯誼會會長\n 淡江大學建築所兼任副教授\n 中華民國紅十字會總會理事\n 台灣民主基金會董事",
				"allTel": "國會研究室：02-2358-6236;新莊服務處：02-2992-9199;泰山服務處：02-2297-7093",
				"labTel": "02-2358-6236",
				"serviceTel1": "新莊服務處：02-2992-9199",
				"serviceTel2": "泰山服務處：02-2297-7093",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6240;新莊服務處：02-2992-9818;泰山服務處：02-2900-0833",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90024.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1108室;新莊服務處：新北市新莊區公園路36號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1108室",
				"serviceAdd1": "新莊服務處：新北市新莊區公園路36號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/taipeihjlee?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9D%8E%E9%B4%BB%E9%88%9E_(%E7%AB%8B%E5%A7%94)",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "谷辣斯．尤達卡Kolas Yotaka",
				"ename": "Kolas Yotaka",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "kolas@kolas.com.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺中女中\n ;東海大學外國語文學系\n ;東海大學社會學系研究所碩士",
				"profession": "內政委員會",
				"experience": "桃園市政府原住民族行政局長\n \n 原住民族電視台新聞部副理兼採訪中心組長、主播\n \n biz互動英語執行主編\n \n 民視新聞部記者\n \n 公共電視執行製作",
				"allTel": "國會研究室：02-2358-6031;樂合服務處：03-888-6527",
				"labTel": "02-2358-6031",
				"serviceTel1": "樂合服務處：03-888-6527",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6035;樂合服務處：03-888-6446",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90025.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0201室;樂合服務處：89147花蓮縣玉里鎮樂合里12鄰39號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0201室",
				"serviceAdd1": "樂合服務處：89147花蓮縣玉里鎮樂合里12鄰39號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kolasyotaka.tw/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B0%B7%E8%BE%A3%E6%96%AF%C2%B7%E5%B0%A4%E9%81%94%E5%8D%A1",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "周春米",
				"ename": "Chou Chun Mi",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "rice.chou@msa.hinet.net",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學法律學系畢業",
				"profession": "",
				"experience": "執業律師\n 現任屏東律師公會理事長\n 曾任台灣高雄、屏東地方法院法官",
				"allTel": "國會研究室：02-2358-8181",
				"labTel": "02-2358-8181",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8185",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90026.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0603室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0603室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%91%A8%E6%98%A5%E7%B1%B3",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "周陳秀霞",
				"ename": "Chou Chen Hsiu Hsia",
				"sex": "女",
				"party": "親民黨",
				"partyGroup": "親民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly11171d@ly.gov.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺南縣立官田國民中學畢業",
				"profession": "",
				"experience": "中華民國婦女聯合會主任委員13年\n \n 臺南市議會議長李全教辦公室主任\n \n 臺南縣議會議長周五六服務處主任\n \n 立法委員周五六服務處主任\n \n 農民權益保障代表人",
				"allTel": "國會研究室：02-2358-6056;楠西服務處：06-575-1398;永康服務處：06-272-6156",
				"labTel": "02-2358-6056",
				"serviceTel1": "楠西服務處：06-575-1398",
				"serviceTel2": "永康服務處：06-272-6156",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6060;永康服務處：06-272-6256",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90027.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0207室;永康服務處：臺南市永康區大灣東路23號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0207室",
				"serviceAdd1": "永康服務處：臺南市永康區大灣東路23號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100006764016335&fref=ts",
				"wiki": "https://zh.wikipedia.org/w/index.php?title=%E5%91%A8%E9%99%B3%E7%A7%80%E9%9C%9E&action=edit&redlink=1",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "林靜儀",
				"ename": "Lin Ching Yi",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "lcydpp@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "台大分子醫學研究所碩士\n ;中山醫學大學醫學研究所碩士",
				"profession": "",
				"experience": "中山醫學大學醫學研究所博士候選人\n \n 民進黨中央黨部婦女發展部主任\n \n 中山醫大附設醫院產科主任\n \n 行政院婦權會委員",
				"allTel": "國會研究室：02-2358-6781",
				"labTel": "02-2358-6781",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6785",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90034.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0906室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0906室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/LinCYminorta/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E9%9D%9C%E5%84%80",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "林麗蟬",
				"ename": "Lin Li Chan",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "lcoffice15@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立暨南國際大學非營利組織經營管理碩士\n ;建國科技大學美容系",
				"profession": "內政委員會",
				"experience": "行政院青年顧問\n \n 新住民事務協調會報委員\n \n 十傑基金會董事\n \n 台灣新移民發展與交流協會理事長",
				"allTel": "國會研究室：02-2358-6646",
				"labTel": "02-2358-6646",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6650",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90035.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0907室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0907室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/19771002vivi/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E9%BA%97%E8%9F%AC",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "柯志恩",
				"ename": "Ko Chih En",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly11176f@ly.gov.tw",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "美國南加大教育心理學博士",
				"profession": "教育及文化委員會",
				"experience": "美國密西根州立大學教育碩士\n \n 國立政治大學教育系學士\n \n 淡江大學學務長、淡江大學教心所專任教授、高等教育評鑑中心心理學門評鑑委員",
				"allTel": "國會研究室：02-2358-6711",
				"labTel": "02-2358-6711",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6715",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90039.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路10號3506室",
				"labAddr": "10051臺北市中正區青島東路10號3506室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/KoChihEn/?fref=ts",
				"wiki": "https://zh.wikipedia.org/w/index.php?title=%E6%9F%AF%E5%BF%97%E6%81%A9&action=edit&redlink=1",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "段宜康",
				"ename": "Tuan Yi kang",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly10921a@ly.gov.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學政治學系學士",
				"profession": "",
				"experience": "第7、8屆臺北市議員\n \n 第5、8屆立法委員\n \n 民進黨政策會執行長",
				"allTel": "國會研究室：02-2358-6196",
				"labTel": "02-2358-6196",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6200",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90041.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0308室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0308室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/tuanyikang/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%AE%B5%E5%AE%9C%E5%BA%B7",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "徐永明",
				"ename": "Hsu Yung Ming",
				"sex": "男",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "全國不分區",
				"district": "",
				"Email": "polymh001@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "建國中學\n ;國立臺灣大學政治學系\n ;美國密西根大學政治學博士",
				"profession": "經濟委員會",
				"experience": "中研院助理研究員\n \n 行政院研考會委員\n \n 行政院公投審議委員\n \n 公民監督國會聯盟學術委員\n \n 時代力量政策小組召集人\n \n 財團法人臺灣智庫執行委員\n \n 新臺灣國策智庫民調中心主任\n \n 東吳大學政治系教授",
				"allTel": "國會研究室：02-2358-6233",
				"labTel": "02-2358-6233",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6235",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90044.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3406室",
				"labAddr": "10051臺北市中正區青島東路1-3號3406室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/polymh/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E6%B0%B8%E6%98%8E",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "徐國勇",
				"ename": "Hsu Kuo Yung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "a_yung47@yahoo.com.tw",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立台北師專啟智教育組畢業;國立中興大學法律系法學士;國立台灣海洋大學海洋法律研究所法學碩士、法學博士",
				"profession": "財政委員會",
				"experience": "教師\n 律師\n 臺北市議員\n 立法委員\n 電視、電台節目主持人\n 國際獅子會300A2區總監(2005-2006)",
				"allTel": "國會研究室：02-2358-6118",
				"labTel": "02-2358-6118",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6120",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90046.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2106室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2106室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/tommyhsu47/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%9C%8B%E5%8B%87",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "徐榛蔚",
				"ename": "Hsu Chen Wei",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly11180@ly.gov.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "中國文化大學",
				"profession": "內政委員會",
				"experience": "2016朱立倫總統選舉花蓮競選總部主委\n \n 2008及2012馬英九總統選舉後援會婦女幹部領袖\n \n 救國團花蓮團委會主委\n \n 花蓮縣巡守大隊長及國際崇她社長",
				"allTel": "國會研究室：02-2358-6299;花蓮服務處：03-853-2215",
				"labTel": "02-2358-6299",
				"serviceTel1": "花蓮服務處：03-853-2215",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6300;花蓮服務處：03-853-1365",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90047.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路10號3505室;花蓮服務處：花蓮縣吉安鄉中山路三段121號",
				"labAddr": "10051臺北市中正區青島東路10號3505室",
				"serviceAdd1": "花蓮服務處：花蓮縣吉安鄉中山路三段121號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E6%A6%9B%E8%94%9A",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "陳其邁",
				"ename": "Chen Chi Mai",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "5c198.ly@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄中學畢業;中山醫學院醫學系畢業;國立臺灣大學公共衛生研究所預防醫學碩士;醫師檢覈考試及格;醫師高等考試及格",
				"profession": "內政委員會",
				"experience": "1989長庚醫院醫師\n 1995立法委員(第3、4、5、8屆)\n 2004擔任行政院政務委員\n 2005代理高雄市市長\n 2006英國倫敦政經學院任訪問學者\n 2007總統府副秘書長\n 2008民進黨副秘書長\n 2011民進黨政策委員會執行長",
				"allTel": "國會研究室：02-2358-8566;高雄服務處：07-382-5189",
				"labTel": "02-2358-8566",
				"serviceTel1": "高雄服務處：07-382-5189",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8570;高雄服務處：07-382-5177",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90059.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1105室;高雄服務處：高雄市三民區九如一路399號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1105室",
				"serviceAdd1": "高雄服務處：高雄市三民區九如一路399號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%99%B3%E5%85%B6%E9%82%81-Chen-Chi-Mai-122936517768637/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E5%85%B6%E9%82%81",
				"LineID": "@ldw1832g"
			},
			{
				"w": 9,
				"name": "陳宜民",
				"ename": "Chen Yi Ming",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ymacly@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "陽明大學醫學士;微免所碩士;美國哈佛大學公共衛生學院科學博士",
				"profession": "",
				"experience": "美國國家衛生院博士後研究\n 陽明大學公衛所所長\n 國際長\n 研發長\n 高醫副校長\n 醫研所特聘教授",
				"allTel": "國會研究室：02-2358-6246",
				"labTel": "02-2358-6246",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6380",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90060.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3306室",
				"labAddr": "10051臺北市中正區青島東路1-3號3306室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%99%B3%E5%AE%9C%E6%B0%91-209615392715601/?fref=ts",
				"wiki": "https://zh.wikipedia.org/w/index.php?title=%E9%99%B3%E5%AE%9C%E6%B0%91&action=edit&redlink=1",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "陳怡潔",
				"ename": "Chen Yi Chieh",
				"sex": "女",
				"party": "親民黨",
				"partyGroup": "親民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "www507507@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "銘傳大學管理學院研究所博士",
				"profession": "內政委員會",
				"experience": "第8屆親民黨全國不分區立法委員\n 臺北市政府青年事務委員會副主任委員\n 銘傳大學管理學院助理教授\n 德明財經科技大學助理教授\n 康寧護專企管科講師\n 財團法人臺北市陳安文教基金會執行長",
				"allTel": "國會研究室：02-2358-6798",
				"labTel": "02-2358-6798",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6800",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90061.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0507室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0507室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/507Chenyichieh",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%80%A1%E6%BD%94",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "陳曼麗",
				"ename": "Chen Man Li",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "manli205@ms28.hinet.net",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國聖地牙哥國家大學公共行政管理碩士",
				"profession": "",
				"experience": "主婦聯盟環境保護基金會董事長\n \n 台灣婦女團體全國聯合會理事長\n \n 行政院國家永續發展委員會委員\n \n 法律扶助基金會董事",
				"allTel": "國會研究室：02-2358-6391",
				"labTel": "02-2358-6391",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6330",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90065.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0606室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0606室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/manli.chen3?ref=ts&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%9B%BC%E9%BA%97",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "高潞．以用．巴魕剌Kawlo．Iyun．Pacidal",
				"ename": "Kowlo．Iyun．Pacidal",
				"sex": "女",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "全國不分區",
				"district": "",
				"Email": "kawloiyunforyou@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "臺北商專國貿科;世新大學新聞系",
				"profession": "教育及文化委員會",
				"experience": "世新大學法研所碩士班 \n 國立台北教育大學文教法研所碩士班 \n 小米穗原住民族文化基金會董事暨執行長 \n 台灣原住民族政策協會理事",
				"allTel": "國會研究室：02-2358-8551",
				"labTel": "02-2358-8551",
				"serviceTel1": "02 2358 8552",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8555",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90051.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1008室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1008室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kawloiyun/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%AB%98%E6%BD%9E%C2%B7%E4%BB%A5%E7%94%A8%C2%B7%E5%B7%B4%E9%AD%95%E5%89%8C",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "張麗善",
				"ename": "Chang Li Shan",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "lishan6970@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣馬光國小\n ;雲林縣土庫國中\n ;臺中曉明女中\n ;國立虎尾科技大學工業管理系\n ;國立臺灣師範大學運動休閒管理研究所",
				"profession": "",
				"experience": "行政院雲嘉南區聯合服務中心執行長\n \n 雲林縣救國團主任委員\n \n 雲林縣青埔教育基金會董事長\n \n 中華民國第6屆立法委員\n \n 雲林縣日頭花姐妹協會理事長",
				"allTel": "國會研究室：02-2358-6970;青埔服務處：05-632-0629",
				"labTel": "02-2358-6970",
				"serviceTel1": "青埔服務處：05-632-0629",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6974;青埔服務處：05-633-3318",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90054.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2103室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2103室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lishan6970?fref=ts\nhttps://www.facebook.com/yunlin.lishan",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BC%B5%E9%BA%97%E5%96%84",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "許毓仁",
				"ename": "Hsu Yu Jen",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "congress.jason@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立政治大學英語系",
				"profession": "",
				"experience": "TEDxTaipei共同創辦人、策展人\n \n 大哉問公司董事長\n \n 行政院青年顧問團成員",
				"allTel": "國會研究室：02-2358-6161",
				"labTel": "02-2358-6161",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6160",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90058.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0408室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0408室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/congress.jason/?fref=ts\nhttps://www.facebook.com/augama",
				"wiki": "https://zh.wikipedia.org/w/index.php?title=%E8%A8%B1%E6%AF%93%E4%BB%81&action=edit&redlink=1",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "曾銘宗",
				"ename": "Tseng Ming chung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "7/20表示有留言板和電話地址不提供email",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺北大學企業管理研究所博士",
				"profession": "財政委員會",
				"experience": "財政部政務次長兼臺灣金控董事長\n \n 常務次長兼國安基金執行秘書\n \n 金融監督管理委員會檢查局長",
				"allTel": "國會研究室：02-2358-8286",
				"labTel": "02-2358-8286",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8290",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90072.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3405室",
				"labAddr": "10051臺北市中正區青島東路1-3號3405室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/TsengMingChung/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9B%BE%E9%8A%98%E5%AE%97",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "黃昭順",
				"ename": "Huang Chao Shun",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "khgogogo@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立中山大學高階經營碩士;高雄醫學大學藥學系;省立臺南女中",
				"profession": "內政委員會",
				"experience": "高雄市議會1~3屆市議員\n 第2~8屆立法委員\n 行政院婦女權益促進委員會委員\n 婦女工作會主任",
				"allTel": "國會研究室：02-2358-6786;高雄服務處：07-341-3361",
				"labTel": "02-2358-6786",
				"serviceTel1": "高雄服務處：07-341-3361",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6790;高雄服務處：07-341-2672",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90075.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1107室;高雄服務處：813高雄市左營區新庄仔路425號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1107室",
				"serviceAdd1": "高雄服務處：813高雄市左營區新庄仔路425號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chaoshun?fref=ts\nhttps://www.facebook.com/KHshun",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E6%98%AD%E9%A0%86",
				"LineID": "@grv2791n\n0937636666"
			},
			{
				"w": 9,
				"name": "蔡培慧",
				"ename": "Tsai Pei Hui",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly11194b@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學生物產業傳播暨發展學系博士",
				"profession": "經濟委員會",
				"experience": "九二一震災基金會執行秘書\n \n 台灣農村陣線發言人暨秘書長\n \n 世新大學社會發展研究所助理教授",
				"allTel": "國會研究室：02-2358-6812",
				"labTel": "02-2358-6812",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6525",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90091.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2111室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2111室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/ahuei.tsai/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E5%9F%B9%E6%85%A7",
				"LineID": ""
			},
			{
				"w": "離職",
				"name": "鄭麗君",
				"ename": "Cheng Li Chiun",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "love.lichiun@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "台大哲學系學士;法國巴黎第十大學政治、經濟、社會哲學碩士",
				"profession": "",
				"experience": "第8屆立法委員\n 行政院青年輔導委員會主任委員\n 青平台基金會董事長(兼執行長)\n 財團法人台灣智庫執行長\n 國藝基金會董事\n 東吳大學政治系兼任講師",
				"allTel": "國會研究室：02-2358-8329",
				"labTel": "02-2358-8329",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8330",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90097.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3301室",
				"labAddr": "10051臺北市中正區青島東路1-3號3301室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/love.lichiun/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%84%AD%E9%BA%97%E5%90%9B",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "鍾孔炤",
				"ename": "Chung Kung Chao",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ly11198c@ly.gov.tw",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東縣內埔國民小學\n ;屏東縣內埔國民中學\n ;私立美和高級中學",
				"profession": "",
				"experience": "台灣勞工陣線執委、理事\n \n 高雄市產業總工會理事長\n \n 全國產業總工會理事長\n \n 高雄市政府客家事務委員會主委\n \n 高雄市政府勞工局局長",
				"allTel": "國會研究室：02-2358-8106",
				"labTel": "02-2358-8106",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8110",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90103.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3111室",
				"labAddr": "10051臺北市中正區青島東路1-3號3111室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%8D%BE%E5%AD%94%E7%82%A4",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "蘇嘉全",
				"ename": "Su Jia chyuan",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "ptsu@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立中山大學公共事務管理碩士\n ;國立海洋大學食品科學系學士",
				"profession": "",
				"experience": "民主進步黨秘書長、中常委、選對會召集人\n \n 農委會主委\n \n 內政部長\n \n 屏東縣長\n \n 立法委員\n \n 國大代表",
				"allTel": "國會辦公室：02-2358-6011",
				"labTel": "國會辦公室：02-2358-6011",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會辦公室：02-2395-5317",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90111.jpg",
				"leaveDate": "",
				"allAddr": "國會辦公室：10051臺北市中正區中山南路1號",
				"labAddr": "國會辦公室：10051臺北市中正區中山南路1號",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/sujiachyuan/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E5%98%89%E5%85%A8",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "顧立雄",
				"ename": "Koo Li Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "全國不分區",
				"district": "",
				"Email": "GoodTaipeiPlus@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學法學士;美國紐約大學(NYU)法學碩士",
				"profession": "",
				"experience": "萬國法律事務所資深合夥律師(1983年-2016年)\n 臺北律師公會理事長(2003年-2005年)\n 中華民國律師公會全國聯合會理事長(2008年-2009年)\n 臺灣法學會理事長(2009年-2010年)\n 民間司法改革基金會董事長(2010年)\n 臺灣人權促進會會長(2013年)",
				"allTel": "國會研究室：02-2358-6866",
				"labTel": "02-2358-6866",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6870",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90113.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3203室",
				"labAddr": "10051臺北市中正區青島東路1-3號3203室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/WellingtonKoo.Taiwan/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A1%A7%E7%AB%8B%E9%9B%84",
				"LineID": ""
			}
		]
	},
	"臺南市": {
		"永康區": [
			{
				"w": 9,
				"name": "王定宇",
				"ename": "Wang Ting Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第5選舉區",
				"district": "永康區、仁德區、歸仁區、關廟區、龍崎區",
				"Email": "dingyu.tw@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "成功大學外交系80級\n ;成功大學管理學院禍階管理碩士97級\n ;長勞大學經營管理所博士班",
				"profession": "外交及國防委員會",
				"experience": "臺南市議會第15、16屆議員\n \n 台南直轄市第1屆市議員\n \n 臺南市議會教育委員會召集人\n \n 長老教會松年學講師\n \n 臺南市教師會顧問\n \n 臺南市教育產業工會顧問\n \n 關中虎慢速球聯盟理事長\n \n 電視台資深政論評論員",
				"allTel": "國會研究室：02-2358-8211;永康服務處：06-2739-217;南關線服務處：06-330-2318~9",
				"labTel": "02-2358-8211",
				"serviceTel1": "永康服務處：06-2739-217",
				"serviceTel2": "南關線服務處：06-330-2318~9",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8215;永康服務處：06-2739-817;南關線服務處：06-338-7412",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90003.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3205室;永康服務處：710臺南市永康區永大路一段259號(永大路及大灣東路口);南關線服務處：711臺南市歸仁區中山路三段129號",
				"labAddr": "10051臺北市中正區青島東路1-3號3205室",
				"serviceAdd1": "永康服務處：710臺南市永康區永大路一段259號(永大路及大灣東路口)",
				"serviceAdd2": "南關線服務處：711臺南市歸仁區中山路三段129號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wdy19690305/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E5%AE%9A%E5%AE%87",
				"LineID": ""
			}
		],
		"仁德區": [
			{
				"w": 9,
				"name": "王定宇",
				"ename": "Wang Ting Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第5選舉區",
				"district": "永康區、仁德區、歸仁區、關廟區、龍崎區",
				"Email": "dingyu.tw@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "成功大學外交系80級\n ;成功大學管理學院禍階管理碩士97級\n ;長勞大學經營管理所博士班",
				"profession": "外交及國防委員會",
				"experience": "臺南市議會第15、16屆議員\n \n 台南直轄市第1屆市議員\n \n 臺南市議會教育委員會召集人\n \n 長老教會松年學講師\n \n 臺南市教師會顧問\n \n 臺南市教育產業工會顧問\n \n 關中虎慢速球聯盟理事長\n \n 電視台資深政論評論員",
				"allTel": "國會研究室：02-2358-8211;永康服務處：06-2739-217;南關線服務處：06-330-2318~9",
				"labTel": "02-2358-8211",
				"serviceTel1": "永康服務處：06-2739-217",
				"serviceTel2": "南關線服務處：06-330-2318~9",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8215;永康服務處：06-2739-817;南關線服務處：06-338-7412",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90003.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3205室;永康服務處：710臺南市永康區永大路一段259號(永大路及大灣東路口);南關線服務處：711臺南市歸仁區中山路三段129號",
				"labAddr": "10051臺北市中正區青島東路1-3號3205室",
				"serviceAdd1": "永康服務處：710臺南市永康區永大路一段259號(永大路及大灣東路口)",
				"serviceAdd2": "南關線服務處：711臺南市歸仁區中山路三段129號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wdy19690305/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E5%AE%9A%E5%AE%87",
				"LineID": ""
			}
		],
		"歸仁區": [
			{
				"w": 9,
				"name": "王定宇",
				"ename": "Wang Ting Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第5選舉區",
				"district": "永康區、仁德區、歸仁區、關廟區、龍崎區",
				"Email": "dingyu.tw@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "成功大學外交系80級\n ;成功大學管理學院禍階管理碩士97級\n ;長勞大學經營管理所博士班",
				"profession": "外交及國防委員會",
				"experience": "臺南市議會第15、16屆議員\n \n 台南直轄市第1屆市議員\n \n 臺南市議會教育委員會召集人\n \n 長老教會松年學講師\n \n 臺南市教師會顧問\n \n 臺南市教育產業工會顧問\n \n 關中虎慢速球聯盟理事長\n \n 電視台資深政論評論員",
				"allTel": "國會研究室：02-2358-8211;永康服務處：06-2739-217;南關線服務處：06-330-2318~9",
				"labTel": "02-2358-8211",
				"serviceTel1": "永康服務處：06-2739-217",
				"serviceTel2": "南關線服務處：06-330-2318~9",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8215;永康服務處：06-2739-817;南關線服務處：06-338-7412",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90003.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3205室;永康服務處：710臺南市永康區永大路一段259號(永大路及大灣東路口);南關線服務處：711臺南市歸仁區中山路三段129號",
				"labAddr": "10051臺北市中正區青島東路1-3號3205室",
				"serviceAdd1": "永康服務處：710臺南市永康區永大路一段259號(永大路及大灣東路口)",
				"serviceAdd2": "南關線服務處：711臺南市歸仁區中山路三段129號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wdy19690305/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E5%AE%9A%E5%AE%87",
				"LineID": ""
			}
		],
		"關廟區": [
			{
				"w": 9,
				"name": "王定宇",
				"ename": "Wang Ting Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第5選舉區",
				"district": "永康區、仁德區、歸仁區、關廟區、龍崎區",
				"Email": "dingyu.tw@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "成功大學外交系80級\n ;成功大學管理學院禍階管理碩士97級\n ;長勞大學經營管理所博士班",
				"profession": "外交及國防委員會",
				"experience": "臺南市議會第15、16屆議員\n \n 台南直轄市第1屆市議員\n \n 臺南市議會教育委員會召集人\n \n 長老教會松年學講師\n \n 臺南市教師會顧問\n \n 臺南市教育產業工會顧問\n \n 關中虎慢速球聯盟理事長\n \n 電視台資深政論評論員",
				"allTel": "國會研究室：02-2358-8211;永康服務處：06-2739-217;南關線服務處：06-330-2318~9",
				"labTel": "02-2358-8211",
				"serviceTel1": "永康服務處：06-2739-217",
				"serviceTel2": "南關線服務處：06-330-2318~9",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8215;永康服務處：06-2739-817;南關線服務處：06-338-7412",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90003.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3205室;永康服務處：710臺南市永康區永大路一段259號(永大路及大灣東路口);南關線服務處：711臺南市歸仁區中山路三段129號",
				"labAddr": "10051臺北市中正區青島東路1-3號3205室",
				"serviceAdd1": "永康服務處：710臺南市永康區永大路一段259號(永大路及大灣東路口)",
				"serviceAdd2": "南關線服務處：711臺南市歸仁區中山路三段129號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wdy19690305/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E5%AE%9A%E5%AE%87",
				"LineID": ""
			}
		],
		"龍崎區": [
			{
				"w": 9,
				"name": "王定宇",
				"ename": "Wang Ting Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第5選舉區",
				"district": "永康區、仁德區、歸仁區、關廟區、龍崎區",
				"Email": "dingyu.tw@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "成功大學外交系80級\n ;成功大學管理學院禍階管理碩士97級\n ;長勞大學經營管理所博士班",
				"profession": "外交及國防委員會",
				"experience": "臺南市議會第15、16屆議員\n \n 台南直轄市第1屆市議員\n \n 臺南市議會教育委員會召集人\n \n 長老教會松年學講師\n \n 臺南市教師會顧問\n \n 臺南市教育產業工會顧問\n \n 關中虎慢速球聯盟理事長\n \n 電視台資深政論評論員",
				"allTel": "國會研究室：02-2358-8211;永康服務處：06-2739-217;南關線服務處：06-330-2318~9",
				"labTel": "02-2358-8211",
				"serviceTel1": "永康服務處：06-2739-217",
				"serviceTel2": "南關線服務處：06-330-2318~9",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8215;永康服務處：06-2739-817;南關線服務處：06-338-7412",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90003.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3205室;永康服務處：710臺南市永康區永大路一段259號(永大路及大灣東路口);南關線服務處：711臺南市歸仁區中山路三段129號",
				"labAddr": "10051臺北市中正區青島東路1-3號3205室",
				"serviceAdd1": "永康服務處：710臺南市永康區永大路一段259號(永大路及大灣東路口)",
				"serviceAdd2": "南關線服務處：711臺南市歸仁區中山路三段129號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wdy19690305/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E5%AE%9A%E5%AE%87",
				"LineID": ""
			}
		],
		"安平區": [
			{
				"w": 9,
				"name": "林俊憲",
				"ename": "Lin Chun Hsien",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第4選舉區",
				"district": "安平區、南區、東區",
				"Email": "letsgolin@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺南一中畢業\n ;國立成功大學企管系畢業\n ;美國密蘇里大學企管碩士(u. of Missouri,MBA)\n ;臺大國家發展研究所博士班",
				"profession": "",
				"experience": "臺南市第14、15、16屆議員(1997-2010)\n \n 民進黨中央黨部發言人\n \n 賴清德競選市長執行總幹事\n \n 民進黨中央執行委員\n \n 長榮大學-國際企業系兼任講師",
				"allTel": "國會研究室：02-2358-6931;東區服務處：06-2091-120;安平、南區服務處：06-2921-235",
				"labTel": "02-2358-6931",
				"serviceTel1": "東區服務處：06-2091-120",
				"serviceTel2": "安平、南區服務處：06-2921-235",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6935;東區服務處：06-2091-150;安平、南區服務處：06-2612-117",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90029.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1006室;東區服務處：701臺南市東區凱琁路225號;安平、南區服務處：702臺南市南區中華西路一段234號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1006室",
				"serviceAdd1": "東區服務處：701臺南市東區凱琁路225號",
				"serviceAdd2": "安平、南區服務處：702臺南市南區中華西路一段234號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/seeklin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E4%BF%8A%E6%86%B2",
				"LineID": "@pud0181n"
			}
		],
		"南區": [
			{
				"w": 9,
				"name": "林俊憲",
				"ename": "Lin Chun Hsien",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第4選舉區",
				"district": "安平區、南區、東區",
				"Email": "letsgolin@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺南一中畢業\n ;國立成功大學企管系畢業\n ;美國密蘇里大學企管碩士(u. of Missouri,MBA)\n ;臺大國家發展研究所博士班",
				"profession": "",
				"experience": "臺南市第14、15、16屆議員(1997-2010)\n \n 民進黨中央黨部發言人\n \n 賴清德競選市長執行總幹事\n \n 民進黨中央執行委員\n \n 長榮大學-國際企業系兼任講師",
				"allTel": "國會研究室：02-2358-6931;東區服務處：06-2091-120;安平、南區服務處：06-2921-235",
				"labTel": "02-2358-6931",
				"serviceTel1": "東區服務處：06-2091-120",
				"serviceTel2": "安平、南區服務處：06-2921-235",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6935;東區服務處：06-2091-150;安平、南區服務處：06-2612-117",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90029.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1006室;東區服務處：701臺南市東區凱琁路225號;安平、南區服務處：702臺南市南區中華西路一段234號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1006室",
				"serviceAdd1": "東區服務處：701臺南市東區凱琁路225號",
				"serviceAdd2": "安平、南區服務處：702臺南市南區中華西路一段234號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/seeklin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E4%BF%8A%E6%86%B2",
				"LineID": "@pud0181n"
			}
		],
		"東區": [
			{
				"w": 9,
				"name": "林俊憲",
				"ename": "Lin Chun Hsien",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第4選舉區",
				"district": "安平區、南區、東區",
				"Email": "letsgolin@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺南一中畢業\n ;國立成功大學企管系畢業\n ;美國密蘇里大學企管碩士(u. of Missouri,MBA)\n ;臺大國家發展研究所博士班",
				"profession": "",
				"experience": "臺南市第14、15、16屆議員(1997-2010)\n \n 民進黨中央黨部發言人\n \n 賴清德競選市長執行總幹事\n \n 民進黨中央執行委員\n \n 長榮大學-國際企業系兼任講師",
				"allTel": "國會研究室：02-2358-6931;東區服務處：06-2091-120;安平、南區服務處：06-2921-235",
				"labTel": "02-2358-6931",
				"serviceTel1": "東區服務處：06-2091-120",
				"serviceTel2": "安平、南區服務處：06-2921-235",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6935;東區服務處：06-2091-150;安平、南區服務處：06-2612-117",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90029.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1006室;東區服務處：701臺南市東區凱琁路225號;安平、南區服務處：702臺南市南區中華西路一段234號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1006室",
				"serviceAdd1": "東區服務處：701臺南市東區凱琁路225號",
				"serviceAdd2": "安平、南區服務處：702臺南市南區中華西路一段234號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/seeklin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E4%BF%8A%E6%86%B2",
				"LineID": "@pud0181n"
			}
		],
		"安南區": [
			{
				"w": 9,
				"name": "陳亭妃",
				"ename": "Chen Ting Fei",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第3選舉區",
				"district": "安南區、北區、中西區",
				"Email": "ly11094f@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "長榮大學經營管理學研究所碩士;文化大學;家齊女中;中山國中;協進國小",
				"profession": "外交及國防委員會",
				"experience": "第7、8屆立法委員\n 立法院民進黨團書記長、副書記長、副幹事長\n 立法院國防外交委員會召委\n 立法院教育文化委員會召委\n 民進黨中常委\n 民進黨中執委\n 民進黨2014市長議員選舉對策委員會委員\n 臺南市議員",
				"allTel": "國會研究室：02-2358-6761;北區服務處：06-280-3906;安南區服務處：06-256-8012;06-256-0701",
				"labTel": "02-2358-6761",
				"serviceTel1": "北區服務處：06-280-3906",
				"serviceTel2": "安南區服務處：06-256-8012",
				"serviceTel3": "06-256-0701",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6755;北區服務處：06-358-6489",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90063.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1101室;北區服務處：704臺南市北區海安路三段963號;安南區服務處：709臺南市安南區安中路二段8號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1101室",
				"serviceAdd1": "北區服務處：704臺南市北區海安路三段963號",
				"serviceAdd2": "安南區服務處：709臺南市安南區安中路二段8號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/fififans/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E4%BA%AD%E5%A6%83",
				"LineID": "@nhu2565u"
			}
		],
		"北區": [
			{
				"w": 9,
				"name": "陳亭妃",
				"ename": "Chen Ting Fei",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第3選舉區",
				"district": "安南區、北區、中西區",
				"Email": "ly11094f@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "長榮大學經營管理學研究所碩士;文化大學;家齊女中;中山國中;協進國小",
				"profession": "外交及國防委員會",
				"experience": "第7、8屆立法委員\n 立法院民進黨團書記長、副書記長、副幹事長\n 立法院國防外交委員會召委\n 立法院教育文化委員會召委\n 民進黨中常委\n 民進黨中執委\n 民進黨2014市長議員選舉對策委員會委員\n 臺南市議員",
				"allTel": "國會研究室：02-2358-6761;北區服務處：06-280-3906;安南區服務處：06-256-8012;06-256-0701",
				"labTel": "02-2358-6761",
				"serviceTel1": "北區服務處：06-280-3906",
				"serviceTel2": "安南區服務處：06-256-8012",
				"serviceTel3": "06-256-0701",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6755;北區服務處：06-358-6489",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90063.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1101室;北區服務處：704臺南市北區海安路三段963號;安南區服務處：709臺南市安南區安中路二段8號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1101室",
				"serviceAdd1": "北區服務處：704臺南市北區海安路三段963號",
				"serviceAdd2": "安南區服務處：709臺南市安南區安中路二段8號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/fififans/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E4%BA%AD%E5%A6%83",
				"LineID": "@nhu2565u"
			}
		],
		"中西區": [
			{
				"w": 9,
				"name": "陳亭妃",
				"ename": "Chen Ting Fei",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第3選舉區",
				"district": "安南區、北區、中西區",
				"Email": "ly11094f@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "長榮大學經營管理學研究所碩士;文化大學;家齊女中;中山國中;協進國小",
				"profession": "外交及國防委員會",
				"experience": "第7、8屆立法委員\n 立法院民進黨團書記長、副書記長、副幹事長\n 立法院國防外交委員會召委\n 立法院教育文化委員會召委\n 民進黨中常委\n 民進黨中執委\n 民進黨2014市長議員選舉對策委員會委員\n 臺南市議員",
				"allTel": "國會研究室：02-2358-6761;北區服務處：06-280-3906;安南區服務處：06-256-8012;06-256-0701",
				"labTel": "02-2358-6761",
				"serviceTel1": "北區服務處：06-280-3906",
				"serviceTel2": "安南區服務處：06-256-8012",
				"serviceTel3": "06-256-0701",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6755;北區服務處：06-358-6489",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90063.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1101室;北區服務處：704臺南市北區海安路三段963號;安南區服務處：709臺南市安南區安中路二段8號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1101室",
				"serviceAdd1": "北區服務處：704臺南市北區海安路三段963號",
				"serviceAdd2": "安南區服務處：709臺南市安南區安中路二段8號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/fififans/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E4%BA%AD%E5%A6%83",
				"LineID": "@nhu2565u"
			}
		],
		"後壁區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"白河區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"北門區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"學甲區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"鹽水區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"新營區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"柳營區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"東山區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"將軍區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"下營區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"六甲區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"官田區": [
			{
				"w": 9,
				"name": "葉宜津",
				"ename": "Yeh Yi Jin",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第1選舉區",
				"district": "後壁區、白河區、北門區、學甲區、鹽水區、新營區、柳營區、東山區、將軍區、下營區、六甲區、官田區",
				"Email": "kwain0215@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國Bridgeport大學音樂碩士",
				"profession": "交通委員會",
				"experience": "公民監督國會聯盟唯一評鑑滿分立委\n 澄社評鑑連續多年獲得表現優秀立委\n 商業周刊評鑑優秀立委\n 2007年美國國務院「菁英計畫」訪問學人\n 民進黨中央黨部婦女部主任\n 民進黨立法院黨團總幹事、書記長\n 現任立法委員\n 臺灣省議員暨民進黨黨團總召\n 奧地利維也納音樂學院",
				"allTel": "國會研究室：02-2358-6291;新營服務處：06-657-2808;安平服務處：06-295-0826;06-295-0829",
				"labTel": "02-2358-6291",
				"serviceTel1": "新營服務處：06-657-2808",
				"serviceTel2": "安平服務處：06-295-0826",
				"serviceTel3": "06-295-0829",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6295;新營服務處：06-657-2818",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90081.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0403室;新營服務處：臺南市新營區民生路130號;安平服務處：臺南市安平區健康路三段206號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0403室",
				"serviceAdd1": "新營服務處：臺南市新營區民生路130號",
				"serviceAdd2": "安平服務處：臺南市安平區健康路三段206號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YehYiJin/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%91%89%E5%AE%9C%E6%B4%A5",
				"LineID": ""
			}
		],
		"七股區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"佳里區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"麻豆區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"善化區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"大內區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"玉井區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"楠西區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"西港區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"安定區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"新市區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"山上區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"新化區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"左鎮區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		],
		"南化區": [
			{
				"w": 9,
				"name": "黃偉哲",
				"ename": "Huang Wei Cher",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺南市第2選舉區",
				"district": "七股區、佳里區、麻豆區、善化區、大內區、玉井區、楠西區、西港區、安定區、新市區、山上區、新化區、左鎮區、南化區",
				"Email": "w2335400@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學學士\n ;美國耶魯大學碩士\n ;美國哈佛大學碩士",
				"profession": "經濟委員會",
				"experience": "立法院第6、7、8屆立法委員\n \n 國民大會代表\n \n 台南縣議員\n \n 行政院顧問\n \n 行政院農業委員會專門委員",
				"allTel": "國會研究室：02-2358-8311;佳里服務處：06-723-0100;麻豆服務處：06-571-7753;06-571-0225;南科服務處：06-581-2798",
				"labTel": "02-2358-8311",
				"serviceTel1": "佳里服務處：06-723-0100",
				"serviceTel2": "麻豆服務處：06-571-7753",
				"serviceTel3": "06-571-0225",
				"serviceTel4": "南科服務處：06-581-2798",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8315;佳里服務處：06-723-0023;南科服務處：06-581-9168",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90076.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3303室;佳里服務處：臺南市佳里區進學路130號;麻豆服務處：臺南市麻豆區南勢里62-2號;南科服務處：臺南市善化區中山路564號",
				"labAddr": "10051臺北市中正區青島東路1-3號3303室",
				"serviceAdd1": "佳里服務處：臺南市佳里區進學路130號",
				"serviceAdd2": "麻豆服務處：臺南市麻豆區南勢里62-2號",
				"serviceAdd3": "南科服務處：臺南市善化區中山路564號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100000337819959&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%81%89%E5%93%B2",
				"LineID": ""
			}
		]
	},
	"彰化縣": {
		"伸港鄉": [
			{
				"w": 9,
				"name": "王惠美",
				"ename": "Wang Hui Mei",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "彰化縣第1選舉區",
				"district": "伸港鄉、線西鄉、和美鎮、鹿港鎮、福興鄉、 秀水鄉",
				"Email": "mei322006@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "彰化縣洛津國小 ;彰化縣鹿港國中 ;國立臺中第二高級中學;私立東海大學政治系學士學位、碩士學位;國立彰化師範大學財務金融學系博士班(就讀中)",
				"profession": "經濟委員會",
				"experience": "鹿鳴國中、伸港國中、大慶商工教師\n 大葉大學、建國科技大學兼任講師\n 彰化縣青年工作委員會總會長\n 救國團鹿港鎮團委會會長\n 鹿菁獅子會會長\n 彰化縣土風舞協會理事長\n 彰化縣議員\n 鹿港鎮長\n 立法委員\n 彰化師範大學財務金融學系博士生",
				"allTel": "國會研究室：02-2358-6181;鹿港服務處：04-775-4168;和美服務處：04-757-8568",
				"labTel": "02-2358-6181",
				"serviceTel1": "鹿港服務處：04-775-4168",
				"serviceTel2": "和美服務處：04-757-8568",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6185;鹿港服務處：04-777-9150;和美服務處：04-757-4822",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90004.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0501室;鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號;和美服務處：彰化縣和美鎮德美路456號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0501室",
				"serviceAdd1": "鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號",
				"serviceAdd2": "和美服務處：彰化縣和美鎮德美路456號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wang.huimei/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E6%83%A0%E7%BE%8E",
				"LineID": "@eih8662b"
			}
		],
		"線西鄉": [
			{
				"w": 9,
				"name": "王惠美",
				"ename": "Wang Hui Mei",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "彰化縣第1選舉區",
				"district": "伸港鄉、線西鄉、和美鎮、鹿港鎮、福興鄉、 秀水鄉",
				"Email": "mei322006@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "彰化縣洛津國小 ;彰化縣鹿港國中 ;國立臺中第二高級中學;私立東海大學政治系學士學位、碩士學位;國立彰化師範大學財務金融學系博士班(就讀中)",
				"profession": "經濟委員會",
				"experience": "鹿鳴國中、伸港國中、大慶商工教師\n 大葉大學、建國科技大學兼任講師\n 彰化縣青年工作委員會總會長\n 救國團鹿港鎮團委會會長\n 鹿菁獅子會會長\n 彰化縣土風舞協會理事長\n 彰化縣議員\n 鹿港鎮長\n 立法委員\n 彰化師範大學財務金融學系博士生",
				"allTel": "國會研究室：02-2358-6181;鹿港服務處：04-775-4168;和美服務處：04-757-8568",
				"labTel": "02-2358-6181",
				"serviceTel1": "鹿港服務處：04-775-4168",
				"serviceTel2": "和美服務處：04-757-8568",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6185;鹿港服務處：04-777-9150;和美服務處：04-757-4822",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90004.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0501室;鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號;和美服務處：彰化縣和美鎮德美路456號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0501室",
				"serviceAdd1": "鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號",
				"serviceAdd2": "和美服務處：彰化縣和美鎮德美路456號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wang.huimei/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E6%83%A0%E7%BE%8E",
				"LineID": "@eih8662b"
			}
		],
		"和美鎮": [
			{
				"w": 9,
				"name": "王惠美",
				"ename": "Wang Hui Mei",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "彰化縣第1選舉區",
				"district": "伸港鄉、線西鄉、和美鎮、鹿港鎮、福興鄉、 秀水鄉",
				"Email": "mei322006@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "彰化縣洛津國小 ;彰化縣鹿港國中 ;國立臺中第二高級中學;私立東海大學政治系學士學位、碩士學位;國立彰化師範大學財務金融學系博士班(就讀中)",
				"profession": "經濟委員會",
				"experience": "鹿鳴國中、伸港國中、大慶商工教師\n 大葉大學、建國科技大學兼任講師\n 彰化縣青年工作委員會總會長\n 救國團鹿港鎮團委會會長\n 鹿菁獅子會會長\n 彰化縣土風舞協會理事長\n 彰化縣議員\n 鹿港鎮長\n 立法委員\n 彰化師範大學財務金融學系博士生",
				"allTel": "國會研究室：02-2358-6181;鹿港服務處：04-775-4168;和美服務處：04-757-8568",
				"labTel": "02-2358-6181",
				"serviceTel1": "鹿港服務處：04-775-4168",
				"serviceTel2": "和美服務處：04-757-8568",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6185;鹿港服務處：04-777-9150;和美服務處：04-757-4822",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90004.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0501室;鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號;和美服務處：彰化縣和美鎮德美路456號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0501室",
				"serviceAdd1": "鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號",
				"serviceAdd2": "和美服務處：彰化縣和美鎮德美路456號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wang.huimei/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E6%83%A0%E7%BE%8E",
				"LineID": "@eih8662b"
			}
		],
		"鹿港鎮": [
			{
				"w": 9,
				"name": "王惠美",
				"ename": "Wang Hui Mei",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "彰化縣第1選舉區",
				"district": "伸港鄉、線西鄉、和美鎮、鹿港鎮、福興鄉、 秀水鄉",
				"Email": "mei322006@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "彰化縣洛津國小 ;彰化縣鹿港國中 ;國立臺中第二高級中學;私立東海大學政治系學士學位、碩士學位;國立彰化師範大學財務金融學系博士班(就讀中)",
				"profession": "經濟委員會",
				"experience": "鹿鳴國中、伸港國中、大慶商工教師\n 大葉大學、建國科技大學兼任講師\n 彰化縣青年工作委員會總會長\n 救國團鹿港鎮團委會會長\n 鹿菁獅子會會長\n 彰化縣土風舞協會理事長\n 彰化縣議員\n 鹿港鎮長\n 立法委員\n 彰化師範大學財務金融學系博士生",
				"allTel": "國會研究室：02-2358-6181;鹿港服務處：04-775-4168;和美服務處：04-757-8568",
				"labTel": "02-2358-6181",
				"serviceTel1": "鹿港服務處：04-775-4168",
				"serviceTel2": "和美服務處：04-757-8568",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6185;鹿港服務處：04-777-9150;和美服務處：04-757-4822",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90004.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0501室;鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號;和美服務處：彰化縣和美鎮德美路456號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0501室",
				"serviceAdd1": "鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號",
				"serviceAdd2": "和美服務處：彰化縣和美鎮德美路456號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wang.huimei/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E6%83%A0%E7%BE%8E",
				"LineID": "@eih8662b"
			}
		],
		"福興鄉": [
			{
				"w": 9,
				"name": "王惠美",
				"ename": "Wang Hui Mei",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "彰化縣第1選舉區",
				"district": "伸港鄉、線西鄉、和美鎮、鹿港鎮、福興鄉、 秀水鄉",
				"Email": "mei322006@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "彰化縣洛津國小 ;彰化縣鹿港國中 ;國立臺中第二高級中學;私立東海大學政治系學士學位、碩士學位;國立彰化師範大學財務金融學系博士班(就讀中)",
				"profession": "經濟委員會",
				"experience": "鹿鳴國中、伸港國中、大慶商工教師\n 大葉大學、建國科技大學兼任講師\n 彰化縣青年工作委員會總會長\n 救國團鹿港鎮團委會會長\n 鹿菁獅子會會長\n 彰化縣土風舞協會理事長\n 彰化縣議員\n 鹿港鎮長\n 立法委員\n 彰化師範大學財務金融學系博士生",
				"allTel": "國會研究室：02-2358-6181;鹿港服務處：04-775-4168;和美服務處：04-757-8568",
				"labTel": "02-2358-6181",
				"serviceTel1": "鹿港服務處：04-775-4168",
				"serviceTel2": "和美服務處：04-757-8568",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6185;鹿港服務處：04-777-9150;和美服務處：04-757-4822",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90004.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0501室;鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號;和美服務處：彰化縣和美鎮德美路456號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0501室",
				"serviceAdd1": "鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號",
				"serviceAdd2": "和美服務處：彰化縣和美鎮德美路456號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wang.huimei/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E6%83%A0%E7%BE%8E",
				"LineID": "@eih8662b"
			}
		],
		" 秀水鄉": [
			{
				"w": 9,
				"name": "王惠美",
				"ename": "Wang Hui Mei",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "彰化縣第1選舉區",
				"district": "伸港鄉、線西鄉、和美鎮、鹿港鎮、福興鄉、 秀水鄉",
				"Email": "mei322006@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "彰化縣洛津國小 ;彰化縣鹿港國中 ;國立臺中第二高級中學;私立東海大學政治系學士學位、碩士學位;國立彰化師範大學財務金融學系博士班(就讀中)",
				"profession": "經濟委員會",
				"experience": "鹿鳴國中、伸港國中、大慶商工教師\n 大葉大學、建國科技大學兼任講師\n 彰化縣青年工作委員會總會長\n 救國團鹿港鎮團委會會長\n 鹿菁獅子會會長\n 彰化縣土風舞協會理事長\n 彰化縣議員\n 鹿港鎮長\n 立法委員\n 彰化師範大學財務金融學系博士生",
				"allTel": "國會研究室：02-2358-6181;鹿港服務處：04-775-4168;和美服務處：04-757-8568",
				"labTel": "02-2358-6181",
				"serviceTel1": "鹿港服務處：04-775-4168",
				"serviceTel2": "和美服務處：04-757-8568",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6185;鹿港服務處：04-777-9150;和美服務處：04-757-4822",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90004.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0501室;鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號;和美服務處：彰化縣和美鎮德美路456號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0501室",
				"serviceAdd1": "鹿港服務處：彰化縣鹿港鎮永安里鹿東路55號",
				"serviceAdd2": "和美服務處：彰化縣和美鎮德美路456號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wang.huimei/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%8E%8B%E6%83%A0%E7%BE%8E",
				"LineID": "@eih8662b"
			}
		],
		"芳苑鄉": [
			{
				"w": 9,
				"name": "洪宗熠",
				"ename": "Hung Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第3選舉區",
				"district": "芳苑鄉、二林鎮、埔鹽鄉、溪湖鎮、埔心鄉、 大城鄉、竹塘鄉、埤頭鄉、北斗鎮、溪州鄉",
				"Email": "erhlinyi@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立彰化師範大學行政管理碩士;國立中興大學公共行政系法學士",
				"profession": "內政委員會",
				"experience": "第15、16、17、18屆彰化縣議員",
				"allTel": "國會研究室：02-2358-8316",
				"labTel": "02-2358-8316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90042.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0806室;二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0806室",
				"serviceAdd1": "二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/erhlinyi?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E5%AE%97%E7%86%A0",
				"LineID": ""
			}
		],
		"二林鎮": [
			{
				"w": 9,
				"name": "洪宗熠",
				"ename": "Hung Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第3選舉區",
				"district": "芳苑鄉、二林鎮、埔鹽鄉、溪湖鎮、埔心鄉、 大城鄉、竹塘鄉、埤頭鄉、北斗鎮、溪州鄉",
				"Email": "erhlinyi@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立彰化師範大學行政管理碩士;國立中興大學公共行政系法學士",
				"profession": "內政委員會",
				"experience": "第15、16、17、18屆彰化縣議員",
				"allTel": "國會研究室：02-2358-8316",
				"labTel": "02-2358-8316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90042.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0806室;二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0806室",
				"serviceAdd1": "二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/erhlinyi?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E5%AE%97%E7%86%A0",
				"LineID": ""
			}
		],
		"埔鹽鄉": [
			{
				"w": 9,
				"name": "洪宗熠",
				"ename": "Hung Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第3選舉區",
				"district": "芳苑鄉、二林鎮、埔鹽鄉、溪湖鎮、埔心鄉、 大城鄉、竹塘鄉、埤頭鄉、北斗鎮、溪州鄉",
				"Email": "erhlinyi@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立彰化師範大學行政管理碩士;國立中興大學公共行政系法學士",
				"profession": "內政委員會",
				"experience": "第15、16、17、18屆彰化縣議員",
				"allTel": "國會研究室：02-2358-8316",
				"labTel": "02-2358-8316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90042.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0806室;二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0806室",
				"serviceAdd1": "二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/erhlinyi?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E5%AE%97%E7%86%A0",
				"LineID": ""
			}
		],
		"溪湖鎮": [
			{
				"w": 9,
				"name": "洪宗熠",
				"ename": "Hung Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第3選舉區",
				"district": "芳苑鄉、二林鎮、埔鹽鄉、溪湖鎮、埔心鄉、 大城鄉、竹塘鄉、埤頭鄉、北斗鎮、溪州鄉",
				"Email": "erhlinyi@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立彰化師範大學行政管理碩士;國立中興大學公共行政系法學士",
				"profession": "內政委員會",
				"experience": "第15、16、17、18屆彰化縣議員",
				"allTel": "國會研究室：02-2358-8316",
				"labTel": "02-2358-8316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90042.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0806室;二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0806室",
				"serviceAdd1": "二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/erhlinyi?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E5%AE%97%E7%86%A0",
				"LineID": ""
			}
		],
		"埔心鄉": [
			{
				"w": 9,
				"name": "洪宗熠",
				"ename": "Hung Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第3選舉區",
				"district": "芳苑鄉、二林鎮、埔鹽鄉、溪湖鎮、埔心鄉、 大城鄉、竹塘鄉、埤頭鄉、北斗鎮、溪州鄉",
				"Email": "erhlinyi@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立彰化師範大學行政管理碩士;國立中興大學公共行政系法學士",
				"profession": "內政委員會",
				"experience": "第15、16、17、18屆彰化縣議員",
				"allTel": "國會研究室：02-2358-8316",
				"labTel": "02-2358-8316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90042.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0806室;二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0806室",
				"serviceAdd1": "二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/erhlinyi?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E5%AE%97%E7%86%A0",
				"LineID": ""
			}
		],
		" 大城鄉": [
			{
				"w": 9,
				"name": "洪宗熠",
				"ename": "Hung Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第3選舉區",
				"district": "芳苑鄉、二林鎮、埔鹽鄉、溪湖鎮、埔心鄉、 大城鄉、竹塘鄉、埤頭鄉、北斗鎮、溪州鄉",
				"Email": "erhlinyi@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立彰化師範大學行政管理碩士;國立中興大學公共行政系法學士",
				"profession": "內政委員會",
				"experience": "第15、16、17、18屆彰化縣議員",
				"allTel": "國會研究室：02-2358-8316",
				"labTel": "02-2358-8316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90042.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0806室;二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0806室",
				"serviceAdd1": "二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/erhlinyi?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E5%AE%97%E7%86%A0",
				"LineID": ""
			}
		],
		"竹塘鄉": [
			{
				"w": 9,
				"name": "洪宗熠",
				"ename": "Hung Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第3選舉區",
				"district": "芳苑鄉、二林鎮、埔鹽鄉、溪湖鎮、埔心鄉、 大城鄉、竹塘鄉、埤頭鄉、北斗鎮、溪州鄉",
				"Email": "erhlinyi@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立彰化師範大學行政管理碩士;國立中興大學公共行政系法學士",
				"profession": "內政委員會",
				"experience": "第15、16、17、18屆彰化縣議員",
				"allTel": "國會研究室：02-2358-8316",
				"labTel": "02-2358-8316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90042.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0806室;二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0806室",
				"serviceAdd1": "二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/erhlinyi?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E5%AE%97%E7%86%A0",
				"LineID": ""
			}
		],
		"埤頭鄉": [
			{
				"w": 9,
				"name": "洪宗熠",
				"ename": "Hung Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第3選舉區",
				"district": "芳苑鄉、二林鎮、埔鹽鄉、溪湖鎮、埔心鄉、 大城鄉、竹塘鄉、埤頭鄉、北斗鎮、溪州鄉",
				"Email": "erhlinyi@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立彰化師範大學行政管理碩士;國立中興大學公共行政系法學士",
				"profession": "內政委員會",
				"experience": "第15、16、17、18屆彰化縣議員",
				"allTel": "國會研究室：02-2358-8316",
				"labTel": "02-2358-8316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90042.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0806室;二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0806室",
				"serviceAdd1": "二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/erhlinyi?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E5%AE%97%E7%86%A0",
				"LineID": ""
			}
		],
		"北斗鎮": [
			{
				"w": 9,
				"name": "洪宗熠",
				"ename": "Hung Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第3選舉區",
				"district": "芳苑鄉、二林鎮、埔鹽鄉、溪湖鎮、埔心鄉、 大城鄉、竹塘鄉、埤頭鄉、北斗鎮、溪州鄉",
				"Email": "erhlinyi@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立彰化師範大學行政管理碩士;國立中興大學公共行政系法學士",
				"profession": "內政委員會",
				"experience": "第15、16、17、18屆彰化縣議員",
				"allTel": "國會研究室：02-2358-8316",
				"labTel": "02-2358-8316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90042.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0806室;二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0806室",
				"serviceAdd1": "二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/erhlinyi?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E5%AE%97%E7%86%A0",
				"LineID": ""
			}
		],
		"溪州鄉": [
			{
				"w": 9,
				"name": "洪宗熠",
				"ename": "Hung Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第3選舉區",
				"district": "芳苑鄉、二林鎮、埔鹽鄉、溪湖鎮、埔心鄉、 大城鄉、竹塘鄉、埤頭鄉、北斗鎮、溪州鄉",
				"Email": "erhlinyi@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立彰化師範大學行政管理碩士;國立中興大學公共行政系法學士",
				"profession": "內政委員會",
				"experience": "第15、16、17、18屆彰化縣議員",
				"allTel": "國會研究室：02-2358-8316",
				"labTel": "02-2358-8316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90042.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0806室;二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0806室",
				"serviceAdd1": "二林服務處：500彰化縣二林鎮豐田里二溪路一段207號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/erhlinyi?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E5%AE%97%E7%86%A0",
				"LineID": ""
			}
		],
		"大村鄉": [
			{
				"w": 9,
				"name": "陳素月",
				"ename": "Chen Su Yueh",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第4選舉區",
				"district": "大村鄉、員林鎮、永靖鄉、社頭鄉、田尾鄉、 田中鎮、二水鄉",
				"Email": "ly11157b@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "文化大學史學研究所碩士;文化大學史學系;台中女中;南投縣名間國中、僑興國小",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n 第16、17屆彰化縣議員\n 國立空中大學講師\n 財團法人拓展文教基金會執行長\n 立法委員魏明谷國會助理\n 大葉大學兼任講師\n 民主進步黨第10~16屆全國黨員代表\n 彰化縣南投同鄉會總幹事\n 員林百果山獅子會第21屆會長",
				"allTel": "國會研究室：02-2358-6691;員林服務處：04-832-8552",
				"labTel": "02-2358-6691",
				"serviceTel1": "員林服務處：04-832-8552",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6695;員林服務處：04-835-3414",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90064.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2109室;員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2109室",
				"serviceAdd1": "員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chengSayYes/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E7%B4%A0%E6%9C%88",
				"LineID": ""
			}
		],
		"員林鎮": [
			{
				"w": 9,
				"name": "陳素月",
				"ename": "Chen Su Yueh",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第4選舉區",
				"district": "大村鄉、員林鎮、永靖鄉、社頭鄉、田尾鄉、 田中鎮、二水鄉",
				"Email": "ly11157b@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "文化大學史學研究所碩士;文化大學史學系;台中女中;南投縣名間國中、僑興國小",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n 第16、17屆彰化縣議員\n 國立空中大學講師\n 財團法人拓展文教基金會執行長\n 立法委員魏明谷國會助理\n 大葉大學兼任講師\n 民主進步黨第10~16屆全國黨員代表\n 彰化縣南投同鄉會總幹事\n 員林百果山獅子會第21屆會長",
				"allTel": "國會研究室：02-2358-6691;員林服務處：04-832-8552",
				"labTel": "02-2358-6691",
				"serviceTel1": "員林服務處：04-832-8552",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6695;員林服務處：04-835-3414",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90064.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2109室;員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2109室",
				"serviceAdd1": "員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chengSayYes/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E7%B4%A0%E6%9C%88",
				"LineID": ""
			}
		],
		"永靖鄉": [
			{
				"w": 9,
				"name": "陳素月",
				"ename": "Chen Su Yueh",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第4選舉區",
				"district": "大村鄉、員林鎮、永靖鄉、社頭鄉、田尾鄉、 田中鎮、二水鄉",
				"Email": "ly11157b@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "文化大學史學研究所碩士;文化大學史學系;台中女中;南投縣名間國中、僑興國小",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n 第16、17屆彰化縣議員\n 國立空中大學講師\n 財團法人拓展文教基金會執行長\n 立法委員魏明谷國會助理\n 大葉大學兼任講師\n 民主進步黨第10~16屆全國黨員代表\n 彰化縣南投同鄉會總幹事\n 員林百果山獅子會第21屆會長",
				"allTel": "國會研究室：02-2358-6691;員林服務處：04-832-8552",
				"labTel": "02-2358-6691",
				"serviceTel1": "員林服務處：04-832-8552",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6695;員林服務處：04-835-3414",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90064.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2109室;員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2109室",
				"serviceAdd1": "員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chengSayYes/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E7%B4%A0%E6%9C%88",
				"LineID": ""
			}
		],
		"社頭鄉": [
			{
				"w": 9,
				"name": "陳素月",
				"ename": "Chen Su Yueh",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第4選舉區",
				"district": "大村鄉、員林鎮、永靖鄉、社頭鄉、田尾鄉、 田中鎮、二水鄉",
				"Email": "ly11157b@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "文化大學史學研究所碩士;文化大學史學系;台中女中;南投縣名間國中、僑興國小",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n 第16、17屆彰化縣議員\n 國立空中大學講師\n 財團法人拓展文教基金會執行長\n 立法委員魏明谷國會助理\n 大葉大學兼任講師\n 民主進步黨第10~16屆全國黨員代表\n 彰化縣南投同鄉會總幹事\n 員林百果山獅子會第21屆會長",
				"allTel": "國會研究室：02-2358-6691;員林服務處：04-832-8552",
				"labTel": "02-2358-6691",
				"serviceTel1": "員林服務處：04-832-8552",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6695;員林服務處：04-835-3414",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90064.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2109室;員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2109室",
				"serviceAdd1": "員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chengSayYes/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E7%B4%A0%E6%9C%88",
				"LineID": ""
			}
		],
		"田尾鄉": [
			{
				"w": 9,
				"name": "陳素月",
				"ename": "Chen Su Yueh",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第4選舉區",
				"district": "大村鄉、員林鎮、永靖鄉、社頭鄉、田尾鄉、 田中鎮、二水鄉",
				"Email": "ly11157b@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "文化大學史學研究所碩士;文化大學史學系;台中女中;南投縣名間國中、僑興國小",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n 第16、17屆彰化縣議員\n 國立空中大學講師\n 財團法人拓展文教基金會執行長\n 立法委員魏明谷國會助理\n 大葉大學兼任講師\n 民主進步黨第10~16屆全國黨員代表\n 彰化縣南投同鄉會總幹事\n 員林百果山獅子會第21屆會長",
				"allTel": "國會研究室：02-2358-6691;員林服務處：04-832-8552",
				"labTel": "02-2358-6691",
				"serviceTel1": "員林服務處：04-832-8552",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6695;員林服務處：04-835-3414",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90064.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2109室;員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2109室",
				"serviceAdd1": "員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chengSayYes/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E7%B4%A0%E6%9C%88",
				"LineID": ""
			}
		],
		" 田中鎮": [
			{
				"w": 9,
				"name": "陳素月",
				"ename": "Chen Su Yueh",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第4選舉區",
				"district": "大村鄉、員林鎮、永靖鄉、社頭鄉、田尾鄉、 田中鎮、二水鄉",
				"Email": "ly11157b@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "文化大學史學研究所碩士;文化大學史學系;台中女中;南投縣名間國中、僑興國小",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n 第16、17屆彰化縣議員\n 國立空中大學講師\n 財團法人拓展文教基金會執行長\n 立法委員魏明谷國會助理\n 大葉大學兼任講師\n 民主進步黨第10~16屆全國黨員代表\n 彰化縣南投同鄉會總幹事\n 員林百果山獅子會第21屆會長",
				"allTel": "國會研究室：02-2358-6691;員林服務處：04-832-8552",
				"labTel": "02-2358-6691",
				"serviceTel1": "員林服務處：04-832-8552",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6695;員林服務處：04-835-3414",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90064.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2109室;員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2109室",
				"serviceAdd1": "員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chengSayYes/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E7%B4%A0%E6%9C%88",
				"LineID": ""
			}
		],
		"二水鄉": [
			{
				"w": 9,
				"name": "陳素月",
				"ename": "Chen Su Yueh",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第4選舉區",
				"district": "大村鄉、員林鎮、永靖鄉、社頭鄉、田尾鄉、 田中鎮、二水鄉",
				"Email": "ly11157b@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "文化大學史學研究所碩士;文化大學史學系;台中女中;南投縣名間國中、僑興國小",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n 第16、17屆彰化縣議員\n 國立空中大學講師\n 財團法人拓展文教基金會執行長\n 立法委員魏明谷國會助理\n 大葉大學兼任講師\n 民主進步黨第10~16屆全國黨員代表\n 彰化縣南投同鄉會總幹事\n 員林百果山獅子會第21屆會長",
				"allTel": "國會研究室：02-2358-6691;員林服務處：04-832-8552",
				"labTel": "02-2358-6691",
				"serviceTel1": "員林服務處：04-832-8552",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6695;員林服務處：04-835-3414",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90064.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2109室;員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2109室",
				"serviceAdd1": "員林服務處：彰化縣員林鎮惠來里惠明街219號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chengSayYes/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E7%B4%A0%E6%9C%88",
				"LineID": ""
			}
		],
		"彰化市": [
			{
				"w": 9,
				"name": "黃秀芳",
				"ename": "Huang Hsiou Fang",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第2選舉區",
				"district": "彰化市、花壇鄉、芬園鄉",
				"Email": "ly11189b@ly.gov.tw",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "靜宜大學外文系畢業",
				"profession": "",
				"experience": "彰化縣第16、17、18屆縣議員\n \n 台灣關懷婦女協會理事長\n \n 關懷文教基金會執行長\n \n 關懷廣播電台台長\n \n 民主進步黨全國黨代表",
				"allTel": "國會研究室：02-2358-6256",
				"labTel": "02-2358-6256",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6260",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90074.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0407室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0407室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/smilefangfang/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E7%A7%80%E8%8A%B3",
				"LineID": "@smilefang"
			}
		],
		"花壇鄉": [
			{
				"w": 9,
				"name": "黃秀芳",
				"ename": "Huang Hsiou Fang",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第2選舉區",
				"district": "彰化市、花壇鄉、芬園鄉",
				"Email": "ly11189b@ly.gov.tw",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "靜宜大學外文系畢業",
				"profession": "",
				"experience": "彰化縣第16、17、18屆縣議員\n \n 台灣關懷婦女協會理事長\n \n 關懷文教基金會執行長\n \n 關懷廣播電台台長\n \n 民主進步黨全國黨代表",
				"allTel": "國會研究室：02-2358-6256",
				"labTel": "02-2358-6256",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6260",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90074.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0407室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0407室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/smilefangfang/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E7%A7%80%E8%8A%B3",
				"LineID": "@smilefang"
			}
		],
		"芬園鄉": [
			{
				"w": 9,
				"name": "黃秀芳",
				"ename": "Huang Hsiou Fang",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "彰化縣第2選舉區",
				"district": "彰化市、花壇鄉、芬園鄉",
				"Email": "ly11189b@ly.gov.tw",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "靜宜大學外文系畢業",
				"profession": "",
				"experience": "彰化縣第16、17、18屆縣議員\n \n 台灣關懷婦女協會理事長\n \n 關懷文教基金會執行長\n \n 關懷廣播電台台長\n \n 民主進步黨全國黨代表",
				"allTel": "國會研究室：02-2358-6256",
				"labTel": "02-2358-6256",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6260",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90074.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0407室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0407室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/smilefangfang/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E7%A7%80%E8%8A%B3",
				"LineID": "@smilefang"
			}
		]
	},
	"新北市": {
		"中和區": [
			{
				"w": 9,
				"name": "江永昌",
				"ename": "Chiang Yung Chang",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第8選舉區",
				"district": "中和區",
				"Email": "win2016design@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "中和國小\n ;海山國中\n ;建國高中\n ;中興大學物理學士\n ;臺灣師範大學政治學研究所碩士",
				"profession": "財政委員會",
				"experience": "臺灣大學工業工程研究所碩士\n \n 台北大學法律學院研究專班\n \n 第2屆新北市議員\n \n 第1屆新北市議員暨黨團幹事長\n \n 第16屆臺北縣議員\n \n 中和市市民代表\n \n 立委趙永清國會助理\n \n 凱達格蘭學校校友會監事\n \n 陽光之友協會理事長\n \n 紅十字會新北市分會副會長\n \n 新北市義消第七大隊幹事",
				"allTel": "國會研究室：02-2358-8199;中和服務處：02-2249-7899",
				"labTel": "02-2358-8199",
				"serviceTel1": "中和服務處：02-2249-7899",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8200;中和服務處：02-2249-7999",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90008.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2116室;中和服務處：新北市中和區中和路44號2樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2116室",
				"serviceAdd1": "中和服務處：新北市中和區中和路44號2樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/yungchang1022?fref=ts\nhttps://www.facebook.com/iamyungchang/timeline\n",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B1%9F%E6%B0%B8%E6%98%8C",
				"LineID": "@iamyungchang"
			},
			{
				"w": 9,
				"name": "林德福",
				"ename": "Lin Te Fu",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "新北市第9選舉區",
				"district": "永和區、中和區",
				"Email": "ly10912a@ly.gov.tw\n",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺北縣立頂溪國小畢業;臺灣省立板橋中學畢業;私立開南高級商工職業學校畢業",
				"profession": "",
				"experience": "臺北縣永和市第3屆市民代表\n 臺北縣永和市第4屆代表會副主席\n 臺北縣永和市第5、6屆市長\n 臺北縣鄉鎮市長聯誼會會長\n 新北市立新店高中文教基金會董事長\n 中華民國第5、6、7、8屆立法委員\n 開南大學副董事長\n 國立政治大學法律實務班結業",
				"allTel": "國會研究室：02-2358-6995;永和服務處：02-2232-9899",
				"labTel": "02-2358-6995",
				"serviceTel1": "永和服務處：02-2232-9899",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6999;永和服務處：02-3233-4625",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90033.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3201室;永和服務處：新北市永和區永和路二段403號",
				"labAddr": "10051臺北市中正區青島東路1-3號3201室",
				"serviceAdd1": "永和服務處：新北市永和區永和路二段403號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lintefu/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E5%BE%B7%E7%A6%8F",
				"LineID": ""
			}
		],
		"新莊區": [
			{
				"w": 9,
				"name": "吳秉叡",
				"ename": "Wu Ping Jui",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第4選舉區",
				"district": "新莊區",
				"Email": "braywu55@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "士林國小;成功高中;國立政治大學法律系法學組學士;國立政治大學法律研究所碩士",
				"profession": "財政委員會",
				"experience": "野百合學運政大學生代表\n 司法官訓練所29期\n 臺東地方法院法官\n 臺灣司法改革連線成員\n 凱達格蘭學校國策班第1期。臺北縣政府縣長機要秘書\n 第6屆立法委員\n 律師\n 民進黨臺北縣、新北市黨部主委\n 第8屆不分區立法委員\n 第8屆第4、5會期民進黨立法院黨團書記長",
				"allTel": "國會研究室：02-2358-6858;新北總服務處：02-8522-5786;大新莊服務處：02-2276-8287;福營服務處：02-2208-3852",
				"labTel": "02-2358-6858",
				"serviceTel1": "新北總服務處：02-8522-5786",
				"serviceTel2": "大新莊服務處：02-2276-8287",
				"serviceTel3": "福營服務處：02-2208-3852",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6859;新北總服務處：02-8522-5726;大新莊服務處：02-2277-5657;福營服務處：02-2208-3853",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90014.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0902室;新北總服務處：新北市新莊區化成路路814巷1號;大新莊服務處：新北市新莊區中原路327號1樓;福營服務處：新北市新莊區後港一路130巷48號1樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0902室",
				"serviceAdd1": "新北總服務處：新北市新莊區化成路路814巷1號",
				"serviceAdd2": "大新莊服務處：新北市新莊區中原路327號1樓",
				"serviceAdd3": "福營服務處：新北市新莊區後港一路130巷48號1樓",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/Wubray/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%90%B3%E7%A7%89%E5%8F%A1",
				"LineID": "@ubt7534c"
			},
			{
				"w": 9,
				"name": "蘇巧慧",
				"ename": "Su Chiao Hui",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第5選舉區",
				"district": "樹林區、鶯歌區、新莊區",
				"Email": "su.chiaohui@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "美國賓州大學法律博士（SJD）候選人\n ;美國賓州大學法律碩士(LLM)\n ;美國波士頓大學法律碩士(LLM)\n ;台大法律系司法組畢業\n ;北一女中",
				"profession": "教育及文化委員會",
				"experience": "超越基金會執行長\n \n 2004年總統大選律師後援會總聯絡人、驗票律師團律師\n \n 臺北縣偏鄉法律咨詢服務義務律師\n \n 萬國法律事務所律師\n \n 律師高考及格",
				"allTel": "國會研究室：02-2358-6191;樹林服務處：02-2684-2522;鶯歌服務處：02-2678-3368",
				"labTel": "02-2358-6191",
				"serviceTel1": "樹林服務處：02-2684-2522",
				"serviceTel2": "鶯歌服務處：02-2678-3368",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6195;樹林服務處：02-2684-2533;鶯歌服務處：02-2678-2268",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90109.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1007室;樹林服務處：238新北市樹林區大安路499號;鶯歌服務處：239新北市鶯歌區文化路175號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1007室",
				"serviceAdd1": "樹林服務處：238新北市樹林區大安路499號",
				"serviceAdd2": "鶯歌服務處：239新北市鶯歌區文化路175號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chiaohui.su/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E5%B7%A7%E6%85%A7",
				"LineID": "@zol4121r"
			}
		],
		"土城區": [
			{
				"w": 9,
				"name": "吳琪銘",
				"ename": "Wu Chi Ming",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第10選舉區",
				"district": "土城區、三峽區",
				"Email": "chimingwu.ntpc@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "德霖技術學院畢",
				"profession": "內政委員會",
				"experience": "2002年土城市民代表\n \n 2004年任務型國代\n \n 2005年當選第16屆臺北縣議員\n \n 2010年當選新北市第1屆市議員\n \n 2013、2014年擔任議會教育召集人\n \n 2014年當選新北市第2屆市議員\n \n 新北市消防局義勇消防隊第5大隊大隊長\n \n 土城區雲林同鄉會創會長\n \n 新北市礦工協會榮譽理事長\n \n 大漢溪文教基金會董事長\n \n 國立政治大學行政管理碩士學分班",
				"allTel": "國會研究室：02-2358-6316",
				"labTel": "02-2358-6316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90017.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0605室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0605室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wuqiming519/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%90%B3%E7%90%AA%E9%8A%98",
				"LineID": "@rgk4276m"
			}
		],
		"三峽區": [
			{
				"w": 9,
				"name": "吳琪銘",
				"ename": "Wu Chi Ming",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第10選舉區",
				"district": "土城區、三峽區",
				"Email": "chimingwu.ntpc@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "德霖技術學院畢",
				"profession": "內政委員會",
				"experience": "2002年土城市民代表\n \n 2004年任務型國代\n \n 2005年當選第16屆臺北縣議員\n \n 2010年當選新北市第1屆市議員\n \n 2013、2014年擔任議會教育召集人\n \n 2014年當選新北市第2屆市議員\n \n 新北市消防局義勇消防隊第5大隊大隊長\n \n 土城區雲林同鄉會創會長\n \n 新北市礦工協會榮譽理事長\n \n 大漢溪文教基金會董事長\n \n 國立政治大學行政管理碩士學分班",
				"allTel": "國會研究室：02-2358-6316",
				"labTel": "02-2358-6316",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6320",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90017.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0605室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0605室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wuqiming519/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%90%B3%E7%90%AA%E9%8A%98",
				"LineID": "@rgk4276m"
			}
		],
		"石門區": [
			{
				"w": 9,
				"name": "呂孫綾",
				"ename": "Lu Sun Ling",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第1選舉區",
				"district": "石門區、三芝區、淡水區、八里區、林口區、泰山區",
				"Email": "shirleylu312@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡水國小\n ;聖心女中\n ;文化大學政治學系\n ;文化大學政治研究所碩士",
				"profession": "外交及國防委員會",
				"experience": "文化大學政治研究所博士生\n \n 民進黨第14、 15、16屆中央執行委員\n \n 淡信慈善基金會執行長\n \n 淡水民主協會常務理事\n \n 新北市教育發展協會副總幹事",
				"allTel": "國會研究室：02-2358-6526",
				"labTel": "02-2358-6526",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6530",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90019.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0805室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0805室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/shirleylu312/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%91%82%E5%AD%AB%E7%B6%BE",
				"LineID": "@oet6682l"
			}
		],
		"三芝區": [
			{
				"w": 9,
				"name": "呂孫綾",
				"ename": "Lu Sun Ling",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第1選舉區",
				"district": "石門區、三芝區、淡水區、八里區、林口區、泰山區",
				"Email": "shirleylu312@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡水國小\n ;聖心女中\n ;文化大學政治學系\n ;文化大學政治研究所碩士",
				"profession": "外交及國防委員會",
				"experience": "文化大學政治研究所博士生\n \n 民進黨第14、 15、16屆中央執行委員\n \n 淡信慈善基金會執行長\n \n 淡水民主協會常務理事\n \n 新北市教育發展協會副總幹事",
				"allTel": "國會研究室：02-2358-6526",
				"labTel": "02-2358-6526",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6530",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90019.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0805室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0805室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/shirleylu312/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%91%82%E5%AD%AB%E7%B6%BE",
				"LineID": "@oet6682l"
			}
		],
		"淡水區": [
			{
				"w": 9,
				"name": "呂孫綾",
				"ename": "Lu Sun Ling",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第1選舉區",
				"district": "石門區、三芝區、淡水區、八里區、林口區、泰山區",
				"Email": "shirleylu312@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡水國小\n ;聖心女中\n ;文化大學政治學系\n ;文化大學政治研究所碩士",
				"profession": "外交及國防委員會",
				"experience": "文化大學政治研究所博士生\n \n 民進黨第14、 15、16屆中央執行委員\n \n 淡信慈善基金會執行長\n \n 淡水民主協會常務理事\n \n 新北市教育發展協會副總幹事",
				"allTel": "國會研究室：02-2358-6526",
				"labTel": "02-2358-6526",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6530",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90019.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0805室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0805室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/shirleylu312/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%91%82%E5%AD%AB%E7%B6%BE",
				"LineID": "@oet6682l"
			}
		],
		"八里區": [
			{
				"w": 9,
				"name": "呂孫綾",
				"ename": "Lu Sun Ling",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第1選舉區",
				"district": "石門區、三芝區、淡水區、八里區、林口區、泰山區",
				"Email": "shirleylu312@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡水國小\n ;聖心女中\n ;文化大學政治學系\n ;文化大學政治研究所碩士",
				"profession": "外交及國防委員會",
				"experience": "文化大學政治研究所博士生\n \n 民進黨第14、 15、16屆中央執行委員\n \n 淡信慈善基金會執行長\n \n 淡水民主協會常務理事\n \n 新北市教育發展協會副總幹事",
				"allTel": "國會研究室：02-2358-6526",
				"labTel": "02-2358-6526",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6530",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90019.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0805室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0805室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/shirleylu312/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%91%82%E5%AD%AB%E7%B6%BE",
				"LineID": "@oet6682l"
			}
		],
		"林口區": [
			{
				"w": 9,
				"name": "呂孫綾",
				"ename": "Lu Sun Ling",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第1選舉區",
				"district": "石門區、三芝區、淡水區、八里區、林口區、泰山區",
				"Email": "shirleylu312@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡水國小\n ;聖心女中\n ;文化大學政治學系\n ;文化大學政治研究所碩士",
				"profession": "外交及國防委員會",
				"experience": "文化大學政治研究所博士生\n \n 民進黨第14、 15、16屆中央執行委員\n \n 淡信慈善基金會執行長\n \n 淡水民主協會常務理事\n \n 新北市教育發展協會副總幹事",
				"allTel": "國會研究室：02-2358-6526",
				"labTel": "02-2358-6526",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6530",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90019.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0805室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0805室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/shirleylu312/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%91%82%E5%AD%AB%E7%B6%BE",
				"LineID": "@oet6682l"
			}
		],
		"泰山區": [
			{
				"w": 9,
				"name": "呂孫綾",
				"ename": "Lu Sun Ling",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第1選舉區",
				"district": "石門區、三芝區、淡水區、八里區、林口區、泰山區",
				"Email": "shirleylu312@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡水國小\n ;聖心女中\n ;文化大學政治學系\n ;文化大學政治研究所碩士",
				"profession": "外交及國防委員會",
				"experience": "文化大學政治研究所博士生\n \n 民進黨第14、 15、16屆中央執行委員\n \n 淡信慈善基金會執行長\n \n 淡水民主協會常務理事\n \n 新北市教育發展協會副總幹事",
				"allTel": "國會研究室：02-2358-6526",
				"labTel": "02-2358-6526",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6530",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90019.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0805室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0805室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/shirleylu312/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%91%82%E5%AD%AB%E7%B6%BE",
				"LineID": "@oet6682l"
			}
		],
		"五股區": [
			{
				"w": 9,
				"name": "林淑芬",
				"ename": "Lin Shu Fen",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第2選舉區",
				"district": "五股區、蘆洲區、三重區",
				"Email": "shufen3202@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "",
				"profession": "",
				"experience": "第6、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8186;蘆洲服務處：02-8285-6412;五服服務處：02-2291-2995",
				"labTel": "02-2358-8186",
				"serviceTel1": "蘆洲服務處：02-8285-6412",
				"serviceTel2": "五服服務處：02-2291-2995",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8190;蘆洲服務處：02-2281-7980;五服服務處：02-2291-2355",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90032.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3202室;蘆洲服務處：新北市蘆洲區長興路25號;五服服務處：臺北縣五股鄉民義路一段37號",
				"labAddr": "10051臺北市中正區青島東路1-3號3202室",
				"serviceAdd1": "蘆洲服務處：新北市蘆洲區長興路25號",
				"serviceAdd2": "五服服務處：臺北縣五股鄉民義路一段37號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/linshufen.fans/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E6%B7%91%E8%8A%AC",
				"LineID": "@linshufen"
			}
		],
		"蘆洲區": [
			{
				"w": 9,
				"name": "林淑芬",
				"ename": "Lin Shu Fen",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第2選舉區",
				"district": "五股區、蘆洲區、三重區",
				"Email": "shufen3202@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "",
				"profession": "",
				"experience": "第6、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8186;蘆洲服務處：02-8285-6412;五服服務處：02-2291-2995",
				"labTel": "02-2358-8186",
				"serviceTel1": "蘆洲服務處：02-8285-6412",
				"serviceTel2": "五服服務處：02-2291-2995",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8190;蘆洲服務處：02-2281-7980;五服服務處：02-2291-2355",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90032.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3202室;蘆洲服務處：新北市蘆洲區長興路25號;五服服務處：臺北縣五股鄉民義路一段37號",
				"labAddr": "10051臺北市中正區青島東路1-3號3202室",
				"serviceAdd1": "蘆洲服務處：新北市蘆洲區長興路25號",
				"serviceAdd2": "五服服務處：臺北縣五股鄉民義路一段37號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/linshufen.fans/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E6%B7%91%E8%8A%AC",
				"LineID": "@linshufen"
			}
		],
		"三重區": [
			{
				"w": 9,
				"name": "林淑芬",
				"ename": "Lin Shu Fen",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第2選舉區",
				"district": "五股區、蘆洲區、三重區",
				"Email": "shufen3202@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "",
				"profession": "",
				"experience": "第6、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8186;蘆洲服務處：02-8285-6412;五服服務處：02-2291-2995",
				"labTel": "02-2358-8186",
				"serviceTel1": "蘆洲服務處：02-8285-6412",
				"serviceTel2": "五服服務處：02-2291-2995",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8190;蘆洲服務處：02-2281-7980;五服服務處：02-2291-2355",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90032.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3202室;蘆洲服務處：新北市蘆洲區長興路25號;五服服務處：臺北縣五股鄉民義路一段37號",
				"labAddr": "10051臺北市中正區青島東路1-3號3202室",
				"serviceAdd1": "蘆洲服務處：新北市蘆洲區長興路25號",
				"serviceAdd2": "五服服務處：臺北縣五股鄉民義路一段37號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/linshufen.fans/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E6%B7%91%E8%8A%AC",
				"LineID": "@linshufen"
			},
			{
				"w": 9,
				"name": "高志鵬",
				"ename": "Gao Jyh Peng",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第3選舉區",
				"district": "三重區",
				"Email": "shin0102@ms28.hinet.net",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "建國中學;輔仁大學法律系財經法律組;臺灣大學EMBA",
				"profession": "",
				"experience": "台灣啤酒籃球隊總領隊\n 名陽法律事務所執業律師\n 民進黨臺北市黨部主任委員\n 民進黨中央執行委員、中央常務委員\n 民進黨中央評議委員會主任委員\n 第5、6、7、8屆立法委員\n 台韓國會議員聯誼會會長\n 立法院民進黨團書記長\n 立法院民進黨團幹事長\n 2014年通過ISO9001國際品質認證",
				"allTel": "國會研究室：02-2358-6241;三重服務處：02-8988-1368",
				"labTel": "02-2358-6241",
				"serviceTel1": "三重服務處：02-8988-1368",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6245;三重服務處：02-8988-3076",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90049.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0503室;三重服務處：新北市三重區忠孝路一段153號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0503室",
				"serviceAdd1": "三重服務處：新北市三重區忠孝路一段153號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/gaojyhpeng/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%AB%98%E5%BF%97%E9%B5%AC",
				"LineID": "@dvj5710x"
			}
		],
		"永和區": [
			{
				"w": 9,
				"name": "林德福",
				"ename": "Lin Te Fu",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "新北市第9選舉區",
				"district": "永和區、中和區",
				"Email": "ly10912a@ly.gov.tw\n",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺北縣立頂溪國小畢業;臺灣省立板橋中學畢業;私立開南高級商工職業學校畢業",
				"profession": "",
				"experience": "臺北縣永和市第3屆市民代表\n 臺北縣永和市第4屆代表會副主席\n 臺北縣永和市第5、6屆市長\n 臺北縣鄉鎮市長聯誼會會長\n 新北市立新店高中文教基金會董事長\n 中華民國第5、6、7、8屆立法委員\n 開南大學副董事長\n 國立政治大學法律實務班結業",
				"allTel": "國會研究室：02-2358-6995;永和服務處：02-2232-9899",
				"labTel": "02-2358-6995",
				"serviceTel1": "永和服務處：02-2232-9899",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6999;永和服務處：02-3233-4625",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90033.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3201室;永和服務處：新北市永和區永和路二段403號",
				"labAddr": "10051臺北市中正區青島東路1-3號3201室",
				"serviceAdd1": "永和服務處：新北市永和區永和路二段403號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lintefu/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E5%BE%B7%E7%A6%8F",
				"LineID": ""
			}
		],
		"板橋區": [
			{
				"w": 9,
				"name": "張宏陸",
				"ename": "Chang Hung Lu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第6選舉區",
				"district": "板橋區",
				"Email": "shien65@yahoo.com.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "東吳大學政治系學士\n ;國立臺北教育大學教育碩士",
				"profession": "",
				"experience": "文化大學美國研究所\n \n 新北市議員\n \n 臺北縣民政局長\n \n 板橋市代理市長\n \n 臺北縣長室秘書\n \n 行政院秘書\n \n 行政院反恐辦公室副主任\n \n 蘇貞昌立委團隊助理\n \n 民進黨臺北縣黨部執行長",
				"allTel": "國會研究室：02-2358-8066",
				"labTel": "02-2358-8066",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8070",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90052.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3305室",
				"labAddr": "10051臺北市中正區青島東路1-3號3305室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hunglueball/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BC%B5%E5%AE%8F%E9%99%B8",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "羅致政",
				"ename": "Lo Chih Cheng",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第7選舉區",
				"district": "板橋區",
				"Email": "voteforlo@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國加州大學洛杉磯分校(UCLA)政治學博士;國立政治大學外交學系學士",
				"profession": "外交及國防委員會",
				"experience": "新台灣國策智庫執行長\n 蔡英文競選新北市長總部政策部主任兼發言人\n 東吳大學政治學系主任\n 外交部研究設計委員會主委\n 民主進步黨新北市黨部主委\n 國策研究院執行長\n 民視「台灣看天下」節目主持人\n 公共電視「全球現場」節目主持人\n 台灣社秘書長",
				"allTel": "國會研究室：02-2358-6871",
				"labTel": "02-2358-6871",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6875;板橋服務處：02-2962-9390",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90108.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0506室;板橋服務處：220新北市板橋市民安街32號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0506室",
				"serviceAdd1": "板橋服務處：220新北市板橋市民安街32號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=639867341\nhttps://www.facebook.com/voteforlo/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%BE%85%E8%87%B4%E6%94%BF",
				"LineID": "@lightuplo"
			}
		],
		"金山區": [
			{
				"w": 9,
				"name": "黃國昌",
				"ename": "Huang Kuo Chang",
				"sex": "男",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "新北市第12選舉區",
				"district": "金山區、萬里區、汐止區、平溪區、瑞芳區、雙溪區、貢寮區",
				"Email": "kccongress@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學法律系學士\n ;美國康乃爾大學法學博士",
				"profession": "財政委員會",
				"experience": "前中央研究院法律學研究所研究員\n \n 臺灣大學、台北大學兼任副教授\n \n 美國傅爾布萊特獎訪問學人\n \n 執業律師、司法官特考及格\n \n 澄社社長\n \n 台灣法學會理事、秘書長",
				"allTel": "國會研究室：02-2358-6916;汐止服務處：02-2643-1123;瑞芳服務處：02-2497-0110",
				"labTel": "02-2358-6916",
				"serviceTel1": "汐止服務處：02-2643-1123",
				"serviceTel2": "瑞芳服務處：02-2497-0110",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6920;汐止服務處：02-2643-1266;瑞芳服務處：02-2497-0115",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90077.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0905室;汐止服務處：221新北市汐止區大同路二段387號;瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0905室",
				"serviceAdd1": "汐止服務處：221新北市汐止區大同路二段387號",
				"serviceAdd2": "瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kcfor2016/?fref=ts\nhttps://www.facebook.com/kchuang2013",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%98%8C",
				"LineID": "@rnd6013l"
			}
		],
		"萬里區": [
			{
				"w": 9,
				"name": "黃國昌",
				"ename": "Huang Kuo Chang",
				"sex": "男",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "新北市第12選舉區",
				"district": "金山區、萬里區、汐止區、平溪區、瑞芳區、雙溪區、貢寮區",
				"Email": "kccongress@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學法律系學士\n ;美國康乃爾大學法學博士",
				"profession": "財政委員會",
				"experience": "前中央研究院法律學研究所研究員\n \n 臺灣大學、台北大學兼任副教授\n \n 美國傅爾布萊特獎訪問學人\n \n 執業律師、司法官特考及格\n \n 澄社社長\n \n 台灣法學會理事、秘書長",
				"allTel": "國會研究室：02-2358-6916;汐止服務處：02-2643-1123;瑞芳服務處：02-2497-0110",
				"labTel": "02-2358-6916",
				"serviceTel1": "汐止服務處：02-2643-1123",
				"serviceTel2": "瑞芳服務處：02-2497-0110",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6920;汐止服務處：02-2643-1266;瑞芳服務處：02-2497-0115",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90077.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0905室;汐止服務處：221新北市汐止區大同路二段387號;瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0905室",
				"serviceAdd1": "汐止服務處：221新北市汐止區大同路二段387號",
				"serviceAdd2": "瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kcfor2016/?fref=ts\nhttps://www.facebook.com/kchuang2013",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%98%8C",
				"LineID": "@rnd6013l"
			}
		],
		"汐止區": [
			{
				"w": 9,
				"name": "黃國昌",
				"ename": "Huang Kuo Chang",
				"sex": "男",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "新北市第12選舉區",
				"district": "金山區、萬里區、汐止區、平溪區、瑞芳區、雙溪區、貢寮區",
				"Email": "kccongress@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學法律系學士\n ;美國康乃爾大學法學博士",
				"profession": "財政委員會",
				"experience": "前中央研究院法律學研究所研究員\n \n 臺灣大學、台北大學兼任副教授\n \n 美國傅爾布萊特獎訪問學人\n \n 執業律師、司法官特考及格\n \n 澄社社長\n \n 台灣法學會理事、秘書長",
				"allTel": "國會研究室：02-2358-6916;汐止服務處：02-2643-1123;瑞芳服務處：02-2497-0110",
				"labTel": "02-2358-6916",
				"serviceTel1": "汐止服務處：02-2643-1123",
				"serviceTel2": "瑞芳服務處：02-2497-0110",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6920;汐止服務處：02-2643-1266;瑞芳服務處：02-2497-0115",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90077.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0905室;汐止服務處：221新北市汐止區大同路二段387號;瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0905室",
				"serviceAdd1": "汐止服務處：221新北市汐止區大同路二段387號",
				"serviceAdd2": "瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kcfor2016/?fref=ts\nhttps://www.facebook.com/kchuang2013",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%98%8C",
				"LineID": "@rnd6013l"
			}
		],
		"平溪區": [
			{
				"w": 9,
				"name": "黃國昌",
				"ename": "Huang Kuo Chang",
				"sex": "男",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "新北市第12選舉區",
				"district": "金山區、萬里區、汐止區、平溪區、瑞芳區、雙溪區、貢寮區",
				"Email": "kccongress@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學法律系學士\n ;美國康乃爾大學法學博士",
				"profession": "財政委員會",
				"experience": "前中央研究院法律學研究所研究員\n \n 臺灣大學、台北大學兼任副教授\n \n 美國傅爾布萊特獎訪問學人\n \n 執業律師、司法官特考及格\n \n 澄社社長\n \n 台灣法學會理事、秘書長",
				"allTel": "國會研究室：02-2358-6916;汐止服務處：02-2643-1123;瑞芳服務處：02-2497-0110",
				"labTel": "02-2358-6916",
				"serviceTel1": "汐止服務處：02-2643-1123",
				"serviceTel2": "瑞芳服務處：02-2497-0110",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6920;汐止服務處：02-2643-1266;瑞芳服務處：02-2497-0115",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90077.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0905室;汐止服務處：221新北市汐止區大同路二段387號;瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0905室",
				"serviceAdd1": "汐止服務處：221新北市汐止區大同路二段387號",
				"serviceAdd2": "瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kcfor2016/?fref=ts\nhttps://www.facebook.com/kchuang2013",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%98%8C",
				"LineID": "@rnd6013l"
			}
		],
		"瑞芳區": [
			{
				"w": 9,
				"name": "黃國昌",
				"ename": "Huang Kuo Chang",
				"sex": "男",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "新北市第12選舉區",
				"district": "金山區、萬里區、汐止區、平溪區、瑞芳區、雙溪區、貢寮區",
				"Email": "kccongress@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學法律系學士\n ;美國康乃爾大學法學博士",
				"profession": "財政委員會",
				"experience": "前中央研究院法律學研究所研究員\n \n 臺灣大學、台北大學兼任副教授\n \n 美國傅爾布萊特獎訪問學人\n \n 執業律師、司法官特考及格\n \n 澄社社長\n \n 台灣法學會理事、秘書長",
				"allTel": "國會研究室：02-2358-6916;汐止服務處：02-2643-1123;瑞芳服務處：02-2497-0110",
				"labTel": "02-2358-6916",
				"serviceTel1": "汐止服務處：02-2643-1123",
				"serviceTel2": "瑞芳服務處：02-2497-0110",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6920;汐止服務處：02-2643-1266;瑞芳服務處：02-2497-0115",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90077.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0905室;汐止服務處：221新北市汐止區大同路二段387號;瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0905室",
				"serviceAdd1": "汐止服務處：221新北市汐止區大同路二段387號",
				"serviceAdd2": "瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kcfor2016/?fref=ts\nhttps://www.facebook.com/kchuang2013",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%98%8C",
				"LineID": "@rnd6013l"
			}
		],
		"雙溪區": [
			{
				"w": 9,
				"name": "黃國昌",
				"ename": "Huang Kuo Chang",
				"sex": "男",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "新北市第12選舉區",
				"district": "金山區、萬里區、汐止區、平溪區、瑞芳區、雙溪區、貢寮區",
				"Email": "kccongress@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學法律系學士\n ;美國康乃爾大學法學博士",
				"profession": "財政委員會",
				"experience": "前中央研究院法律學研究所研究員\n \n 臺灣大學、台北大學兼任副教授\n \n 美國傅爾布萊特獎訪問學人\n \n 執業律師、司法官特考及格\n \n 澄社社長\n \n 台灣法學會理事、秘書長",
				"allTel": "國會研究室：02-2358-6916;汐止服務處：02-2643-1123;瑞芳服務處：02-2497-0110",
				"labTel": "02-2358-6916",
				"serviceTel1": "汐止服務處：02-2643-1123",
				"serviceTel2": "瑞芳服務處：02-2497-0110",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6920;汐止服務處：02-2643-1266;瑞芳服務處：02-2497-0115",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90077.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0905室;汐止服務處：221新北市汐止區大同路二段387號;瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0905室",
				"serviceAdd1": "汐止服務處：221新北市汐止區大同路二段387號",
				"serviceAdd2": "瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kcfor2016/?fref=ts\nhttps://www.facebook.com/kchuang2013",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%98%8C",
				"LineID": "@rnd6013l"
			}
		],
		"貢寮區": [
			{
				"w": 9,
				"name": "黃國昌",
				"ename": "Huang Kuo Chang",
				"sex": "男",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "新北市第12選舉區",
				"district": "金山區、萬里區、汐止區、平溪區、瑞芳區、雙溪區、貢寮區",
				"Email": "kccongress@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學法律系學士\n ;美國康乃爾大學法學博士",
				"profession": "財政委員會",
				"experience": "前中央研究院法律學研究所研究員\n \n 臺灣大學、台北大學兼任副教授\n \n 美國傅爾布萊特獎訪問學人\n \n 執業律師、司法官特考及格\n \n 澄社社長\n \n 台灣法學會理事、秘書長",
				"allTel": "國會研究室：02-2358-6916;汐止服務處：02-2643-1123;瑞芳服務處：02-2497-0110",
				"labTel": "02-2358-6916",
				"serviceTel1": "汐止服務處：02-2643-1123",
				"serviceTel2": "瑞芳服務處：02-2497-0110",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6920;汐止服務處：02-2643-1266;瑞芳服務處：02-2497-0115",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90077.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0905室;汐止服務處：221新北市汐止區大同路二段387號;瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0905室",
				"serviceAdd1": "汐止服務處：221新北市汐止區大同路二段387號",
				"serviceAdd2": "瑞芳服務處：224新北市瑞芳 區明燈路73號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kcfor2016/?fref=ts\nhttps://www.facebook.com/kchuang2013",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%98%8C",
				"LineID": "@rnd6013l"
			}
		],
		"新店區": [
			{
				"w": 9,
				"name": "羅明才",
				"ename": "Lo Ming Tsai",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "新北市第11選舉區",
				"district": "新店區、深坑區、石碇區、坪林區、烏來區",
				"Email": "mingtsailo@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國華盛頓城市大學企業管理碩士\n ;致理商專(現升格科技大學)企業管理系畢",
				"profession": "財政委員會",
				"experience": "國民大會主席團主席\n \n 國民黨中央委員\n \n 立法院財政委員會召集委員\n \n 立法院經濟委員會召集委員\n \n 立法院國民黨團副書記長\n \n 臺北縣體育會理事長\n \n 臺北縣彰化同鄉會理事長\n \n 救國團新北市團委會指導委員",
				"allTel": "國會研究室：02-2358-6776;新店服務處：02-2915-7788",
				"labTel": "02-2358-6776",
				"serviceTel1": "新店服務處：02-2915-7788",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6780;新店服務處：02-2911-1448",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90107.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1106室;新店服務處：新北市新店區中正路54巷8號1樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1106室",
				"serviceAdd1": "新店服務處：新北市新店區中正路54巷8號1樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mtlo.tw/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%BE%85%E6%98%8E%E6%89%8D",
				"LineID": "@ksu7848n\n0978880885"
			}
		],
		"深坑區": [
			{
				"w": 9,
				"name": "羅明才",
				"ename": "Lo Ming Tsai",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "新北市第11選舉區",
				"district": "新店區、深坑區、石碇區、坪林區、烏來區",
				"Email": "mingtsailo@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國華盛頓城市大學企業管理碩士\n ;致理商專(現升格科技大學)企業管理系畢",
				"profession": "財政委員會",
				"experience": "國民大會主席團主席\n \n 國民黨中央委員\n \n 立法院財政委員會召集委員\n \n 立法院經濟委員會召集委員\n \n 立法院國民黨團副書記長\n \n 臺北縣體育會理事長\n \n 臺北縣彰化同鄉會理事長\n \n 救國團新北市團委會指導委員",
				"allTel": "國會研究室：02-2358-6776;新店服務處：02-2915-7788",
				"labTel": "02-2358-6776",
				"serviceTel1": "新店服務處：02-2915-7788",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6780;新店服務處：02-2911-1448",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90107.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1106室;新店服務處：新北市新店區中正路54巷8號1樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1106室",
				"serviceAdd1": "新店服務處：新北市新店區中正路54巷8號1樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mtlo.tw/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%BE%85%E6%98%8E%E6%89%8D",
				"LineID": "@ksu7848n\n0978880885"
			}
		],
		"石碇區": [
			{
				"w": 9,
				"name": "羅明才",
				"ename": "Lo Ming Tsai",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "新北市第11選舉區",
				"district": "新店區、深坑區、石碇區、坪林區、烏來區",
				"Email": "mingtsailo@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國華盛頓城市大學企業管理碩士\n ;致理商專(現升格科技大學)企業管理系畢",
				"profession": "財政委員會",
				"experience": "國民大會主席團主席\n \n 國民黨中央委員\n \n 立法院財政委員會召集委員\n \n 立法院經濟委員會召集委員\n \n 立法院國民黨團副書記長\n \n 臺北縣體育會理事長\n \n 臺北縣彰化同鄉會理事長\n \n 救國團新北市團委會指導委員",
				"allTel": "國會研究室：02-2358-6776;新店服務處：02-2915-7788",
				"labTel": "02-2358-6776",
				"serviceTel1": "新店服務處：02-2915-7788",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6780;新店服務處：02-2911-1448",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90107.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1106室;新店服務處：新北市新店區中正路54巷8號1樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1106室",
				"serviceAdd1": "新店服務處：新北市新店區中正路54巷8號1樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mtlo.tw/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%BE%85%E6%98%8E%E6%89%8D",
				"LineID": "@ksu7848n\n0978880885"
			}
		],
		"坪林區": [
			{
				"w": 9,
				"name": "羅明才",
				"ename": "Lo Ming Tsai",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "新北市第11選舉區",
				"district": "新店區、深坑區、石碇區、坪林區、烏來區",
				"Email": "mingtsailo@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國華盛頓城市大學企業管理碩士\n ;致理商專(現升格科技大學)企業管理系畢",
				"profession": "財政委員會",
				"experience": "國民大會主席團主席\n \n 國民黨中央委員\n \n 立法院財政委員會召集委員\n \n 立法院經濟委員會召集委員\n \n 立法院國民黨團副書記長\n \n 臺北縣體育會理事長\n \n 臺北縣彰化同鄉會理事長\n \n 救國團新北市團委會指導委員",
				"allTel": "國會研究室：02-2358-6776;新店服務處：02-2915-7788",
				"labTel": "02-2358-6776",
				"serviceTel1": "新店服務處：02-2915-7788",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6780;新店服務處：02-2911-1448",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90107.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1106室;新店服務處：新北市新店區中正路54巷8號1樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1106室",
				"serviceAdd1": "新店服務處：新北市新店區中正路54巷8號1樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mtlo.tw/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%BE%85%E6%98%8E%E6%89%8D",
				"LineID": "@ksu7848n\n0978880885"
			}
		],
		"烏來區": [
			{
				"w": 9,
				"name": "羅明才",
				"ename": "Lo Ming Tsai",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "新北市第11選舉區",
				"district": "新店區、深坑區、石碇區、坪林區、烏來區",
				"Email": "mingtsailo@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國華盛頓城市大學企業管理碩士\n ;致理商專(現升格科技大學)企業管理系畢",
				"profession": "財政委員會",
				"experience": "國民大會主席團主席\n \n 國民黨中央委員\n \n 立法院財政委員會召集委員\n \n 立法院經濟委員會召集委員\n \n 立法院國民黨團副書記長\n \n 臺北縣體育會理事長\n \n 臺北縣彰化同鄉會理事長\n \n 救國團新北市團委會指導委員",
				"allTel": "國會研究室：02-2358-6776;新店服務處：02-2915-7788",
				"labTel": "02-2358-6776",
				"serviceTel1": "新店服務處：02-2915-7788",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6780;新店服務處：02-2911-1448",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90107.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1106室;新店服務處：新北市新店區中正路54巷8號1樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1106室",
				"serviceAdd1": "新店服務處：新北市新店區中正路54巷8號1樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mtlo.tw/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%BE%85%E6%98%8E%E6%89%8D",
				"LineID": "@ksu7848n\n0978880885"
			}
		],
		"樹林區": [
			{
				"w": 9,
				"name": "蘇巧慧",
				"ename": "Su Chiao Hui",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第5選舉區",
				"district": "樹林區、鶯歌區、新莊區",
				"Email": "su.chiaohui@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "美國賓州大學法律博士（SJD）候選人\n ;美國賓州大學法律碩士(LLM)\n ;美國波士頓大學法律碩士(LLM)\n ;台大法律系司法組畢業\n ;北一女中",
				"profession": "教育及文化委員會",
				"experience": "超越基金會執行長\n \n 2004年總統大選律師後援會總聯絡人、驗票律師團律師\n \n 臺北縣偏鄉法律咨詢服務義務律師\n \n 萬國法律事務所律師\n \n 律師高考及格",
				"allTel": "國會研究室：02-2358-6191;樹林服務處：02-2684-2522;鶯歌服務處：02-2678-3368",
				"labTel": "02-2358-6191",
				"serviceTel1": "樹林服務處：02-2684-2522",
				"serviceTel2": "鶯歌服務處：02-2678-3368",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6195;樹林服務處：02-2684-2533;鶯歌服務處：02-2678-2268",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90109.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1007室;樹林服務處：238新北市樹林區大安路499號;鶯歌服務處：239新北市鶯歌區文化路175號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1007室",
				"serviceAdd1": "樹林服務處：238新北市樹林區大安路499號",
				"serviceAdd2": "鶯歌服務處：239新北市鶯歌區文化路175號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chiaohui.su/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E5%B7%A7%E6%85%A7",
				"LineID": "@zol4121r"
			}
		],
		"鶯歌區": [
			{
				"w": 9,
				"name": "蘇巧慧",
				"ename": "Su Chiao Hui",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新北市第5選舉區",
				"district": "樹林區、鶯歌區、新莊區",
				"Email": "su.chiaohui@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "美國賓州大學法律博士（SJD）候選人\n ;美國賓州大學法律碩士(LLM)\n ;美國波士頓大學法律碩士(LLM)\n ;台大法律系司法組畢業\n ;北一女中",
				"profession": "教育及文化委員會",
				"experience": "超越基金會執行長\n \n 2004年總統大選律師後援會總聯絡人、驗票律師團律師\n \n 臺北縣偏鄉法律咨詢服務義務律師\n \n 萬國法律事務所律師\n \n 律師高考及格",
				"allTel": "國會研究室：02-2358-6191;樹林服務處：02-2684-2522;鶯歌服務處：02-2678-3368",
				"labTel": "02-2358-6191",
				"serviceTel1": "樹林服務處：02-2684-2522",
				"serviceTel2": "鶯歌服務處：02-2678-3368",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6195;樹林服務處：02-2684-2533;鶯歌服務處：02-2678-2268",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90109.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1007室;樹林服務處：238新北市樹林區大安路499號;鶯歌服務處：239新北市鶯歌區文化路175號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1007室",
				"serviceAdd1": "樹林服務處：238新北市樹林區大安路499號",
				"serviceAdd2": "鶯歌服務處：239新北市鶯歌區文化路175號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chiaohui.su/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E5%B7%A7%E6%85%A7",
				"LineID": "@zol4121r"
			}
		]
	},
	"臺中市": {
		"豐原區": [
			{
				"w": 9,
				"name": "江啟臣",
				"ename": "Chiang Chi Chen",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第8選舉區",
				"district": "豐原區、石岡區、東勢區、新社區、和平區",
				"Email": "kesing168@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國南卡羅萊納大學國際關係博士\n ;美國匹茲堡大學國際事務碩士\n ;國立政治大學外交學系\n ;台中一中\n ;豐南國中\n ;瑞穗國小",
				"profession": "外交及國防委員會",
				"experience": "中華民國第8屆立法委員\n \n 行政院新聞局局長\n \n 東吳大學政治系專任副教授\n \n 立法院中華民國與新加坡國會議員友好協會會長\n \n 台灣經濟研究院國際處代處長\n \n 台灣新世代關懷協會理事長\n \n 公民監督國會聯盟、財經立法促進院評選為立法院績優委員",
				"allTel": "國會研究室：02-2358-6726;豐原服務處：04-2515-9998;東勢服務處：04-2577-3099",
				"labTel": "02-2358-6726",
				"serviceTel1": "豐原服務處：04-2515-9998",
				"serviceTel2": "東勢服務處：04-2577-3099",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6730;豐原服務處：04-2515-6798;東勢服務處：04-2577-3167",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90009.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2102室;豐原服務處：臺中市豐原區南村路20號;東勢服務處：臺中市東勢區公園路36號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2102室",
				"serviceAdd1": "豐原服務處：臺中市豐原區南村路20號",
				"serviceAdd2": "東勢服務處：臺中市東勢區公園路36號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/johnnyccchiang/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B1%9F%E5%95%9F%E8%87%A3",
				"LineID": "＠wiz6714m"
			}
		],
		"石岡區": [
			{
				"w": 9,
				"name": "江啟臣",
				"ename": "Chiang Chi Chen",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第8選舉區",
				"district": "豐原區、石岡區、東勢區、新社區、和平區",
				"Email": "kesing168@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國南卡羅萊納大學國際關係博士\n ;美國匹茲堡大學國際事務碩士\n ;國立政治大學外交學系\n ;台中一中\n ;豐南國中\n ;瑞穗國小",
				"profession": "外交及國防委員會",
				"experience": "中華民國第8屆立法委員\n \n 行政院新聞局局長\n \n 東吳大學政治系專任副教授\n \n 立法院中華民國與新加坡國會議員友好協會會長\n \n 台灣經濟研究院國際處代處長\n \n 台灣新世代關懷協會理事長\n \n 公民監督國會聯盟、財經立法促進院評選為立法院績優委員",
				"allTel": "國會研究室：02-2358-6726;豐原服務處：04-2515-9998;東勢服務處：04-2577-3099",
				"labTel": "02-2358-6726",
				"serviceTel1": "豐原服務處：04-2515-9998",
				"serviceTel2": "東勢服務處：04-2577-3099",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6730;豐原服務處：04-2515-6798;東勢服務處：04-2577-3167",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90009.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2102室;豐原服務處：臺中市豐原區南村路20號;東勢服務處：臺中市東勢區公園路36號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2102室",
				"serviceAdd1": "豐原服務處：臺中市豐原區南村路20號",
				"serviceAdd2": "東勢服務處：臺中市東勢區公園路36號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/johnnyccchiang/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B1%9F%E5%95%9F%E8%87%A3",
				"LineID": "＠wiz6714m"
			}
		],
		"東勢區": [
			{
				"w": 9,
				"name": "江啟臣",
				"ename": "Chiang Chi Chen",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第8選舉區",
				"district": "豐原區、石岡區、東勢區、新社區、和平區",
				"Email": "kesing168@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國南卡羅萊納大學國際關係博士\n ;美國匹茲堡大學國際事務碩士\n ;國立政治大學外交學系\n ;台中一中\n ;豐南國中\n ;瑞穗國小",
				"profession": "外交及國防委員會",
				"experience": "中華民國第8屆立法委員\n \n 行政院新聞局局長\n \n 東吳大學政治系專任副教授\n \n 立法院中華民國與新加坡國會議員友好協會會長\n \n 台灣經濟研究院國際處代處長\n \n 台灣新世代關懷協會理事長\n \n 公民監督國會聯盟、財經立法促進院評選為立法院績優委員",
				"allTel": "國會研究室：02-2358-6726;豐原服務處：04-2515-9998;東勢服務處：04-2577-3099",
				"labTel": "02-2358-6726",
				"serviceTel1": "豐原服務處：04-2515-9998",
				"serviceTel2": "東勢服務處：04-2577-3099",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6730;豐原服務處：04-2515-6798;東勢服務處：04-2577-3167",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90009.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2102室;豐原服務處：臺中市豐原區南村路20號;東勢服務處：臺中市東勢區公園路36號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2102室",
				"serviceAdd1": "豐原服務處：臺中市豐原區南村路20號",
				"serviceAdd2": "東勢服務處：臺中市東勢區公園路36號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/johnnyccchiang/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B1%9F%E5%95%9F%E8%87%A3",
				"LineID": "＠wiz6714m"
			}
		],
		"新社區": [
			{
				"w": 9,
				"name": "江啟臣",
				"ename": "Chiang Chi Chen",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第8選舉區",
				"district": "豐原區、石岡區、東勢區、新社區、和平區",
				"Email": "kesing168@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國南卡羅萊納大學國際關係博士\n ;美國匹茲堡大學國際事務碩士\n ;國立政治大學外交學系\n ;台中一中\n ;豐南國中\n ;瑞穗國小",
				"profession": "外交及國防委員會",
				"experience": "中華民國第8屆立法委員\n \n 行政院新聞局局長\n \n 東吳大學政治系專任副教授\n \n 立法院中華民國與新加坡國會議員友好協會會長\n \n 台灣經濟研究院國際處代處長\n \n 台灣新世代關懷協會理事長\n \n 公民監督國會聯盟、財經立法促進院評選為立法院績優委員",
				"allTel": "國會研究室：02-2358-6726;豐原服務處：04-2515-9998;東勢服務處：04-2577-3099",
				"labTel": "02-2358-6726",
				"serviceTel1": "豐原服務處：04-2515-9998",
				"serviceTel2": "東勢服務處：04-2577-3099",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6730;豐原服務處：04-2515-6798;東勢服務處：04-2577-3167",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90009.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2102室;豐原服務處：臺中市豐原區南村路20號;東勢服務處：臺中市東勢區公園路36號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2102室",
				"serviceAdd1": "豐原服務處：臺中市豐原區南村路20號",
				"serviceAdd2": "東勢服務處：臺中市東勢區公園路36號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/johnnyccchiang/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B1%9F%E5%95%9F%E8%87%A3",
				"LineID": "＠wiz6714m"
			}
		],
		"和平區": [
			{
				"w": 9,
				"name": "江啟臣",
				"ename": "Chiang Chi Chen",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第8選舉區",
				"district": "豐原區、石岡區、東勢區、新社區、和平區",
				"Email": "kesing168@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國南卡羅萊納大學國際關係博士\n ;美國匹茲堡大學國際事務碩士\n ;國立政治大學外交學系\n ;台中一中\n ;豐南國中\n ;瑞穗國小",
				"profession": "外交及國防委員會",
				"experience": "中華民國第8屆立法委員\n \n 行政院新聞局局長\n \n 東吳大學政治系專任副教授\n \n 立法院中華民國與新加坡國會議員友好協會會長\n \n 台灣經濟研究院國際處代處長\n \n 台灣新世代關懷協會理事長\n \n 公民監督國會聯盟、財經立法促進院評選為立法院績優委員",
				"allTel": "國會研究室：02-2358-6726;豐原服務處：04-2515-9998;東勢服務處：04-2577-3099",
				"labTel": "02-2358-6726",
				"serviceTel1": "豐原服務處：04-2515-9998",
				"serviceTel2": "東勢服務處：04-2577-3099",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6730;豐原服務處：04-2515-6798;東勢服務處：04-2577-3167",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90009.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2102室;豐原服務處：臺中市豐原區南村路20號;東勢服務處：臺中市東勢區公園路36號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2102室",
				"serviceAdd1": "豐原服務處：臺中市豐原區南村路20號",
				"serviceAdd2": "東勢服務處：臺中市東勢區公園路36號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/johnnyccchiang/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B1%9F%E5%95%9F%E8%87%A3",
				"LineID": "＠wiz6714m"
			}
		],
		"太平區": [
			{
				"w": 9,
				"name": "何欣純",
				"ename": "Ho Hsin Chun",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第7選舉區",
				"district": "太平區",
				"Email": "a_chun1973@yahoo.com.tw",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "塗城國小\n ;成功國中\n ;臺中女中\n ;國立成功大學\n ;英國約克大學婦女研究碩士",
				"profession": "教育及文化委員會",
				"experience": "第8屆立法委員（公督盟評鑑教育文化委員會優秀立委、財促院評鑑教育組績優立委）\n \n 立法院民進黨黨團副書記長\n \n 第一屆大臺中市議員\n \n 第15、16屆台中縣議員\n \n 家扶中心北台中區副主任\n \n 福田行善會、廣亮、同心、和風、合濟、眾愛等慈善團體會員",
				"allTel": "國會研究室：02-2358-8388;大里服務處：04-2483-6527;太平服務處：04-2276-3111",
				"labTel": "02-2358-8388",
				"serviceTel1": "大里服務處：04-2483-6527",
				"serviceTel2": "太平服務處：04-2276-3111",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8390;大里服務處：04-2482-8743;太平服務處：04-2276-3555",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90010.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0301室;大里服務處：臺中市大里區大里路63號;太平服務處：臺中市太平區新平路二段142號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0301室",
				"serviceAdd1": "大里服務處：臺中市大里區大里路63號",
				"serviceAdd2": "太平服務處：臺中市太平區新平路二段142號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/achun1973?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E4%BD%95%E6%AC%A3%E7%B4%94",
				"LineID": "@beu1231o"
			}
		],
		"后里區": [
			{
				"w": 9,
				"name": "洪慈庸",
				"ename": "Hung Tzu Yung",
				"sex": "女",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "臺中市第3選舉區",
				"district": "后里區、神岡區、大雅區、潭子區",
				"Email": "npptw.hung@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "后里區內埔國小\n ;臺中市后里國中\n ;國立台中商專\n ;國立高雄第一科技大學行銷與流通管理學系",
				"profession": "",
				"experience": "時代力量黨青年事務委員會召集人\n \n 臺灣青年基金會副執行長\n \n 洪仲丘事件洪家對外代表\n \n 遠綠科技公司專案經理\n \n GfK捷孚凱行銷研究顧問公司零售通路服務專員",
				"allTel": "國會研究室：02-2358-6581",
				"labTel": "02-2358-6581",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6585",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90043.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0808室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0808室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/newpowerhung/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E6%85%88%E5%BA%B8",
				"LineID": ""
			}
		],
		"神岡區": [
			{
				"w": 9,
				"name": "洪慈庸",
				"ename": "Hung Tzu Yung",
				"sex": "女",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "臺中市第3選舉區",
				"district": "后里區、神岡區、大雅區、潭子區",
				"Email": "npptw.hung@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "后里區內埔國小\n ;臺中市后里國中\n ;國立台中商專\n ;國立高雄第一科技大學行銷與流通管理學系",
				"profession": "",
				"experience": "時代力量黨青年事務委員會召集人\n \n 臺灣青年基金會副執行長\n \n 洪仲丘事件洪家對外代表\n \n 遠綠科技公司專案經理\n \n GfK捷孚凱行銷研究顧問公司零售通路服務專員",
				"allTel": "國會研究室：02-2358-6581",
				"labTel": "02-2358-6581",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6585",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90043.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0808室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0808室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/newpowerhung/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E6%85%88%E5%BA%B8",
				"LineID": ""
			}
		],
		"大雅區": [
			{
				"w": 9,
				"name": "洪慈庸",
				"ename": "Hung Tzu Yung",
				"sex": "女",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "臺中市第3選舉區",
				"district": "后里區、神岡區、大雅區、潭子區",
				"Email": "npptw.hung@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "后里區內埔國小\n ;臺中市后里國中\n ;國立台中商專\n ;國立高雄第一科技大學行銷與流通管理學系",
				"profession": "",
				"experience": "時代力量黨青年事務委員會召集人\n \n 臺灣青年基金會副執行長\n \n 洪仲丘事件洪家對外代表\n \n 遠綠科技公司專案經理\n \n GfK捷孚凱行銷研究顧問公司零售通路服務專員",
				"allTel": "國會研究室：02-2358-6581",
				"labTel": "02-2358-6581",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6585",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90043.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0808室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0808室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/newpowerhung/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E6%85%88%E5%BA%B8",
				"LineID": ""
			}
		],
		"潭子區": [
			{
				"w": 9,
				"name": "洪慈庸",
				"ename": "Hung Tzu Yung",
				"sex": "女",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "臺中市第3選舉區",
				"district": "后里區、神岡區、大雅區、潭子區",
				"Email": "npptw.hung@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "后里區內埔國小\n ;臺中市后里國中\n ;國立台中商專\n ;國立高雄第一科技大學行銷與流通管理學系",
				"profession": "",
				"experience": "時代力量黨青年事務委員會召集人\n \n 臺灣青年基金會副執行長\n \n 洪仲丘事件洪家對外代表\n \n 遠綠科技公司專案經理\n \n GfK捷孚凱行銷研究顧問公司零售通路服務專員",
				"allTel": "國會研究室：02-2358-6581",
				"labTel": "02-2358-6581",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6585",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90043.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0808室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0808室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/newpowerhung/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%B4%AA%E6%85%88%E5%BA%B8",
				"LineID": ""
			}
		],
		"西屯區": [
			{
				"w": 9,
				"name": "張廖萬堅",
				"ename": "Chang Liao Wan Chien",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第4選舉區",
				"district": "西屯區、南屯區",
				"Email": "wanchien0209@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "東海大學EMBA高階管理學院博士;東海大學政治學研究所碩士班;輔仁大學大眾傳播系;台中一中;",
				"profession": "教育及文化委員會",
				"experience": "民進黨中央黨部執行委員\n 大臺中直轄市第1、2屆市議員\n 第14、15、16屆臺中市議員\n 民進黨臺中市黨部第11屆主任委員\n 臺中市棒球委員會主任委員\n 中華民國棒球協會理事",
				"allTel": "國會研究室：02-2358-8282;台中服務處：04-2708-8883",
				"labTel": "02-2358-8282",
				"serviceTel1": "台中服務處：04-2708-8883",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8285;台中服務處：04-2708-9803",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90053.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3402室",
				"labAddr": "10051臺北市中正區青島東路1-3號3402室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wanchien0209/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BC%B5%E5%BB%96%E8%90%AC%E5%A0%85",
				"LineID": ""
			}
		],
		"南屯區": [
			{
				"w": 9,
				"name": "張廖萬堅",
				"ename": "Chang Liao Wan Chien",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第4選舉區",
				"district": "西屯區、南屯區",
				"Email": "wanchien0209@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "東海大學EMBA高階管理學院博士;東海大學政治學研究所碩士班;輔仁大學大眾傳播系;台中一中;",
				"profession": "教育及文化委員會",
				"experience": "民進黨中央黨部執行委員\n 大臺中直轄市第1、2屆市議員\n 第14、15、16屆臺中市議員\n 民進黨臺中市黨部第11屆主任委員\n 臺中市棒球委員會主任委員\n 中華民國棒球協會理事",
				"allTel": "國會研究室：02-2358-8282;台中服務處：04-2708-8883",
				"labTel": "02-2358-8282",
				"serviceTel1": "台中服務處：04-2708-8883",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8285;台中服務處：04-2708-9803",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90053.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3402室",
				"labAddr": "10051臺北市中正區青島東路1-3號3402室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/wanchien0209/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BC%B5%E5%BB%96%E8%90%AC%E5%A0%85",
				"LineID": ""
			}
		],
		"東區": [
			{
				"w": 9,
				"name": "黃國書",
				"ename": "Huang Kuo Shu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第6選舉區",
				"district": "東區、南區、中區、西區",
				"Email": "kuoshu0103@yahoo.com.tw",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "國立中興大學國際政治研究所碩士\n ;國立臺北藝術大學\n ;國立臺中一中",
				"profession": "教育及文化委員會",
				"experience": "第8屆立法委員\n \n 臺中市議員（連任五屆）\n \n 民進黨第7屆中央評議委員\n \n 臺中市醫師公會顧問\n \n 臺中市棒球委員會副主委\n \n 臺中市圍棋協會理事長\n \n 臺中一中校友會監事\n \n 臺中市書法協會理事\n \n 臺中市西屯扶輪社社友",
				"allTel": "國會研究室：02-2358-6846;台中服務處：04-2376-8701",
				"labTel": "02-2358-6846",
				"serviceTel1": "台中服務處：04-2376-8701",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6850;台中服務處：04-2376-8702",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90078.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0302室;台中服務處：403臺中市西區美村路一段632號B1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0302室",
				"serviceAdd1": "台中服務處：403臺中市西區美村路一段632號B1",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%BB%83%E5%9C%8B%E6%9B%B8-566381323386617/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%9B%B8_(%E8%87%BA%E4%B8%AD%E5%B8%82%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": "@wty9553u"
			}
		],
		"南區": [
			{
				"w": 9,
				"name": "黃國書",
				"ename": "Huang Kuo Shu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第6選舉區",
				"district": "東區、南區、中區、西區",
				"Email": "kuoshu0103@yahoo.com.tw",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "國立中興大學國際政治研究所碩士\n ;國立臺北藝術大學\n ;國立臺中一中",
				"profession": "教育及文化委員會",
				"experience": "第8屆立法委員\n \n 臺中市議員（連任五屆）\n \n 民進黨第7屆中央評議委員\n \n 臺中市醫師公會顧問\n \n 臺中市棒球委員會副主委\n \n 臺中市圍棋協會理事長\n \n 臺中一中校友會監事\n \n 臺中市書法協會理事\n \n 臺中市西屯扶輪社社友",
				"allTel": "國會研究室：02-2358-6846;台中服務處：04-2376-8701",
				"labTel": "02-2358-6846",
				"serviceTel1": "台中服務處：04-2376-8701",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6850;台中服務處：04-2376-8702",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90078.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0302室;台中服務處：403臺中市西區美村路一段632號B1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0302室",
				"serviceAdd1": "台中服務處：403臺中市西區美村路一段632號B1",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%BB%83%E5%9C%8B%E6%9B%B8-566381323386617/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%9B%B8_(%E8%87%BA%E4%B8%AD%E5%B8%82%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": "@wty9553u"
			}
		],
		"中區": [
			{
				"w": 9,
				"name": "黃國書",
				"ename": "Huang Kuo Shu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第6選舉區",
				"district": "東區、南區、中區、西區",
				"Email": "kuoshu0103@yahoo.com.tw",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "國立中興大學國際政治研究所碩士\n ;國立臺北藝術大學\n ;國立臺中一中",
				"profession": "教育及文化委員會",
				"experience": "第8屆立法委員\n \n 臺中市議員（連任五屆）\n \n 民進黨第7屆中央評議委員\n \n 臺中市醫師公會顧問\n \n 臺中市棒球委員會副主委\n \n 臺中市圍棋協會理事長\n \n 臺中一中校友會監事\n \n 臺中市書法協會理事\n \n 臺中市西屯扶輪社社友",
				"allTel": "國會研究室：02-2358-6846;台中服務處：04-2376-8701",
				"labTel": "02-2358-6846",
				"serviceTel1": "台中服務處：04-2376-8701",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6850;台中服務處：04-2376-8702",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90078.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0302室;台中服務處：403臺中市西區美村路一段632號B1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0302室",
				"serviceAdd1": "台中服務處：403臺中市西區美村路一段632號B1",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%BB%83%E5%9C%8B%E6%9B%B8-566381323386617/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%9B%B8_(%E8%87%BA%E4%B8%AD%E5%B8%82%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": "@wty9553u"
			}
		],
		"西區": [
			{
				"w": 9,
				"name": "黃國書",
				"ename": "Huang Kuo Shu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第6選舉區",
				"district": "東區、南區、中區、西區",
				"Email": "kuoshu0103@yahoo.com.tw",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "國立中興大學國際政治研究所碩士\n ;國立臺北藝術大學\n ;國立臺中一中",
				"profession": "教育及文化委員會",
				"experience": "第8屆立法委員\n \n 臺中市議員（連任五屆）\n \n 民進黨第7屆中央評議委員\n \n 臺中市醫師公會顧問\n \n 臺中市棒球委員會副主委\n \n 臺中市圍棋協會理事長\n \n 臺中一中校友會監事\n \n 臺中市書法協會理事\n \n 臺中市西屯扶輪社社友",
				"allTel": "國會研究室：02-2358-6846;台中服務處：04-2376-8701",
				"labTel": "02-2358-6846",
				"serviceTel1": "台中服務處：04-2376-8701",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6850;台中服務處：04-2376-8702",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90078.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0302室;台中服務處：403臺中市西區美村路一段632號B1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0302室",
				"serviceAdd1": "台中服務處：403臺中市西區美村路一段632號B1",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%BB%83%E5%9C%8B%E6%9B%B8-566381323386617/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%BB%83%E5%9C%8B%E6%9B%B8_(%E8%87%BA%E4%B8%AD%E5%B8%82%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": "@wty9553u"
			}
		],
		"大甲區": [
			{
				"w": 9,
				"name": "蔡其昌",
				"ename": "Tsai Chi Chang",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第1選舉區",
				"district": "大甲區、大安區、外埔區、清水區、梧棲區",
				"Email": "tsai04168@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "中興大學財金所EMBA碩士 \n ;東海大學歷史研究所碩士 \n ;東海大學歷史學系畢業 \n ;清水高中 \n ;沙鹿國中 \n ;清水國小",
				"profession": "",
				"experience": "中興大學財金所博士班 \n \n 立法院民主進步黨團幹事長 \n \n 第6屆、第8屆立法委員 \n \n 民主進步黨中常委、發言人 \n \n 臺中縣政府民政局長 \n \n 臺中縣工業策進會總幹事 \n \n 靜宜大學、聯合大學兼任講師 \n \n 台中市壘球委員會主任委員",
				"allTel": "國會研究室：02-2358-6151;清水服務處：04-2623-8581;大甲服務處：04-2688-7555",
				"labTel": "02-2358-6151",
				"serviceTel1": "清水服務處：04-2623-8581",
				"serviceTel2": "大甲服務處：04-2688-7555",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6155;清水服務處：04-2623-8583;大甲服務處：04-2688-9123",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90089.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號12樓;清水服務處：臺中市清水區中華路448號;大甲服務處：臺中市大甲區文武路274號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號12樓",
				"serviceAdd1": "清水服務處：臺中市清水區中華路448號",
				"serviceAdd2": "大甲服務處：臺中市大甲區文武路274號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/taichungGogogo/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E5%85%B6%E6%98%8C",
				"LineID": ""
			}
		],
		"大安區": [
			{
				"w": 9,
				"name": "蔡其昌",
				"ename": "Tsai Chi Chang",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第1選舉區",
				"district": "大甲區、大安區、外埔區、清水區、梧棲區",
				"Email": "tsai04168@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "中興大學財金所EMBA碩士 \n ;東海大學歷史研究所碩士 \n ;東海大學歷史學系畢業 \n ;清水高中 \n ;沙鹿國中 \n ;清水國小",
				"profession": "",
				"experience": "中興大學財金所博士班 \n \n 立法院民主進步黨團幹事長 \n \n 第6屆、第8屆立法委員 \n \n 民主進步黨中常委、發言人 \n \n 臺中縣政府民政局長 \n \n 臺中縣工業策進會總幹事 \n \n 靜宜大學、聯合大學兼任講師 \n \n 台中市壘球委員會主任委員",
				"allTel": "國會研究室：02-2358-6151;清水服務處：04-2623-8581;大甲服務處：04-2688-7555",
				"labTel": "02-2358-6151",
				"serviceTel1": "清水服務處：04-2623-8581",
				"serviceTel2": "大甲服務處：04-2688-7555",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6155;清水服務處：04-2623-8583;大甲服務處：04-2688-9123",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90089.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號12樓;清水服務處：臺中市清水區中華路448號;大甲服務處：臺中市大甲區文武路274號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號12樓",
				"serviceAdd1": "清水服務處：臺中市清水區中華路448號",
				"serviceAdd2": "大甲服務處：臺中市大甲區文武路274號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/taichungGogogo/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E5%85%B6%E6%98%8C",
				"LineID": ""
			}
		],
		"外埔區": [
			{
				"w": 9,
				"name": "蔡其昌",
				"ename": "Tsai Chi Chang",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第1選舉區",
				"district": "大甲區、大安區、外埔區、清水區、梧棲區",
				"Email": "tsai04168@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "中興大學財金所EMBA碩士 \n ;東海大學歷史研究所碩士 \n ;東海大學歷史學系畢業 \n ;清水高中 \n ;沙鹿國中 \n ;清水國小",
				"profession": "",
				"experience": "中興大學財金所博士班 \n \n 立法院民主進步黨團幹事長 \n \n 第6屆、第8屆立法委員 \n \n 民主進步黨中常委、發言人 \n \n 臺中縣政府民政局長 \n \n 臺中縣工業策進會總幹事 \n \n 靜宜大學、聯合大學兼任講師 \n \n 台中市壘球委員會主任委員",
				"allTel": "國會研究室：02-2358-6151;清水服務處：04-2623-8581;大甲服務處：04-2688-7555",
				"labTel": "02-2358-6151",
				"serviceTel1": "清水服務處：04-2623-8581",
				"serviceTel2": "大甲服務處：04-2688-7555",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6155;清水服務處：04-2623-8583;大甲服務處：04-2688-9123",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90089.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號12樓;清水服務處：臺中市清水區中華路448號;大甲服務處：臺中市大甲區文武路274號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號12樓",
				"serviceAdd1": "清水服務處：臺中市清水區中華路448號",
				"serviceAdd2": "大甲服務處：臺中市大甲區文武路274號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/taichungGogogo/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E5%85%B6%E6%98%8C",
				"LineID": ""
			}
		],
		"清水區": [
			{
				"w": 9,
				"name": "蔡其昌",
				"ename": "Tsai Chi Chang",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第1選舉區",
				"district": "大甲區、大安區、外埔區、清水區、梧棲區",
				"Email": "tsai04168@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "中興大學財金所EMBA碩士 \n ;東海大學歷史研究所碩士 \n ;東海大學歷史學系畢業 \n ;清水高中 \n ;沙鹿國中 \n ;清水國小",
				"profession": "",
				"experience": "中興大學財金所博士班 \n \n 立法院民主進步黨團幹事長 \n \n 第6屆、第8屆立法委員 \n \n 民主進步黨中常委、發言人 \n \n 臺中縣政府民政局長 \n \n 臺中縣工業策進會總幹事 \n \n 靜宜大學、聯合大學兼任講師 \n \n 台中市壘球委員會主任委員",
				"allTel": "國會研究室：02-2358-6151;清水服務處：04-2623-8581;大甲服務處：04-2688-7555",
				"labTel": "02-2358-6151",
				"serviceTel1": "清水服務處：04-2623-8581",
				"serviceTel2": "大甲服務處：04-2688-7555",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6155;清水服務處：04-2623-8583;大甲服務處：04-2688-9123",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90089.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號12樓;清水服務處：臺中市清水區中華路448號;大甲服務處：臺中市大甲區文武路274號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號12樓",
				"serviceAdd1": "清水服務處：臺中市清水區中華路448號",
				"serviceAdd2": "大甲服務處：臺中市大甲區文武路274號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/taichungGogogo/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E5%85%B6%E6%98%8C",
				"LineID": ""
			}
		],
		"梧棲區": [
			{
				"w": 9,
				"name": "蔡其昌",
				"ename": "Tsai Chi Chang",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺中市第1選舉區",
				"district": "大甲區、大安區、外埔區、清水區、梧棲區",
				"Email": "tsai04168@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "中興大學財金所EMBA碩士 \n ;東海大學歷史研究所碩士 \n ;東海大學歷史學系畢業 \n ;清水高中 \n ;沙鹿國中 \n ;清水國小",
				"profession": "",
				"experience": "中興大學財金所博士班 \n \n 立法院民主進步黨團幹事長 \n \n 第6屆、第8屆立法委員 \n \n 民主進步黨中常委、發言人 \n \n 臺中縣政府民政局長 \n \n 臺中縣工業策進會總幹事 \n \n 靜宜大學、聯合大學兼任講師 \n \n 台中市壘球委員會主任委員",
				"allTel": "國會研究室：02-2358-6151;清水服務處：04-2623-8581;大甲服務處：04-2688-7555",
				"labTel": "02-2358-6151",
				"serviceTel1": "清水服務處：04-2623-8581",
				"serviceTel2": "大甲服務處：04-2688-7555",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6155;清水服務處：04-2623-8583;大甲服務處：04-2688-9123",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90089.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號12樓;清水服務處：臺中市清水區中華路448號;大甲服務處：臺中市大甲區文武路274號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號12樓",
				"serviceAdd1": "清水服務處：臺中市清水區中華路448號",
				"serviceAdd2": "大甲服務處：臺中市大甲區文武路274號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/taichungGogogo/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E5%85%B6%E6%98%8C",
				"LineID": ""
			}
		],
		"北屯區": [
			{
				"w": 9,
				"name": "盧秀燕",
				"ename": "Lu Shiow Yen",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第5選舉區",
				"district": "北屯區、北區",
				"Email": "lym205a@ly.gov.tw",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立政治大學地政系學士\n ;私立淡江大學國際事務與戰略研究所碩士",
				"profession": "財政委員會",
				"experience": "華梘記者\n \n 華視中部採訪中心主任暨省政特派員\n \n 79年電視金鐘獎最佳採訪獎得主\n \n 第10屆臺灣省議員\n \n 第4～9屆立法委員\n \n 102年國家磐石關懷獎章得主",
				"allTel": "國會研究室：02-2358-8121;台中服務處：04-2319-9770",
				"labTel": "02-2358-8121",
				"serviceTel1": "台中服務處：04-2319-9770",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8125;台中服務處：04-2319-9760",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90099.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3106室;台中服務處：臺中市北區博館路92號4樓",
				"labAddr": "10051臺北市中正區青島東路1-3號3106室",
				"serviceAdd1": "台中服務處：臺中市北區博館路92號4樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/schoollearning?fref=ts\nhttps://www.facebook.com/盧秀燕-109391162488374",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%9B%A7%E7%A7%80%E7%87%95",
				"LineID": ""
			}
		],
		"北區": [
			{
				"w": 9,
				"name": "盧秀燕",
				"ename": "Lu Shiow Yen",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第5選舉區",
				"district": "北屯區、北區",
				"Email": "lym205a@ly.gov.tw",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立政治大學地政系學士\n ;私立淡江大學國際事務與戰略研究所碩士",
				"profession": "財政委員會",
				"experience": "華梘記者\n \n 華視中部採訪中心主任暨省政特派員\n \n 79年電視金鐘獎最佳採訪獎得主\n \n 第10屆臺灣省議員\n \n 第4～9屆立法委員\n \n 102年國家磐石關懷獎章得主",
				"allTel": "國會研究室：02-2358-8121;台中服務處：04-2319-9770",
				"labTel": "02-2358-8121",
				"serviceTel1": "台中服務處：04-2319-9770",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8125;台中服務處：04-2319-9760",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90099.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3106室;台中服務處：臺中市北區博館路92號4樓",
				"labAddr": "10051臺北市中正區青島東路1-3號3106室",
				"serviceAdd1": "台中服務處：臺中市北區博館路92號4樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/schoollearning?fref=ts\nhttps://www.facebook.com/盧秀燕-109391162488374",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%9B%A7%E7%A7%80%E7%87%95",
				"LineID": ""
			}
		],
		"沙鹿區": [
			{
				"w": 9,
				"name": "顏寬恒",
				"ename": "Yen Kuan Heng",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第2選舉區",
				"district": "沙鹿區、龍井區、大肚區、烏日區、霧峰區，大里區",
				"Email": "kuanheng@kuankuan.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "建國工專機械工程科畢業\n ;美國舊金山多明尼肯大學企管碩士\n ;中華大學行政管理研究所碩士",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n \n 臺中縣議會第14屆議長特別助理\n \n 任務型國大代表\n \n 立法委員顏清標國會助理\n \n 鎮瀾兒童家園義工",
				"allTel": "國會研究室：02-2358-8006;沙鹿服務處：04-2632-6151;烏日服務處：04-2337-3351;霧峰服務處：04-2330-2559",
				"labTel": "02-2358-8006",
				"serviceTel1": "沙鹿服務處：04-2632-6151",
				"serviceTel2": "烏日服務處：04-2337-3351",
				"serviceTel3": "霧峰服務處：04-2330-2559",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8010;沙鹿服務處：04-2632-6155;烏日服務處：04-2338-0155;霧峰服務處：04-2330-2551",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90106.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路10號3501室;沙鹿服務處：臺中市沙鹿區埔子里正義路1號;烏日服務處：臺中市烏日區光日路48號;霧峰服務處：臺中市霧峰區樹仁路178號",
				"labAddr": "10051臺北市中正區青島東路10號3501室",
				"serviceAdd1": "沙鹿服務處：臺中市沙鹿區埔子里正義路1號",
				"serviceAdd2": "烏日服務處：臺中市烏日區光日路48號",
				"serviceAdd3": "霧峰服務處：臺中市霧峰區樹仁路178號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kuanheng99/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A1%8F%E5%AF%AC%E6%81%92",
				"LineID": "@ygl4660j"
			}
		],
		"龍井區": [
			{
				"w": 9,
				"name": "顏寬恒",
				"ename": "Yen Kuan Heng",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第2選舉區",
				"district": "沙鹿區、龍井區、大肚區、烏日區、霧峰區，大里區",
				"Email": "kuanheng@kuankuan.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "建國工專機械工程科畢業\n ;美國舊金山多明尼肯大學企管碩士\n ;中華大學行政管理研究所碩士",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n \n 臺中縣議會第14屆議長特別助理\n \n 任務型國大代表\n \n 立法委員顏清標國會助理\n \n 鎮瀾兒童家園義工",
				"allTel": "國會研究室：02-2358-8006;沙鹿服務處：04-2632-6151;烏日服務處：04-2337-3351;霧峰服務處：04-2330-2559",
				"labTel": "02-2358-8006",
				"serviceTel1": "沙鹿服務處：04-2632-6151",
				"serviceTel2": "烏日服務處：04-2337-3351",
				"serviceTel3": "霧峰服務處：04-2330-2559",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8010;沙鹿服務處：04-2632-6155;烏日服務處：04-2338-0155;霧峰服務處：04-2330-2551",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90106.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路10號3501室;沙鹿服務處：臺中市沙鹿區埔子里正義路1號;烏日服務處：臺中市烏日區光日路48號;霧峰服務處：臺中市霧峰區樹仁路178號",
				"labAddr": "10051臺北市中正區青島東路10號3501室",
				"serviceAdd1": "沙鹿服務處：臺中市沙鹿區埔子里正義路1號",
				"serviceAdd2": "烏日服務處：臺中市烏日區光日路48號",
				"serviceAdd3": "霧峰服務處：臺中市霧峰區樹仁路178號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kuanheng99/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A1%8F%E5%AF%AC%E6%81%92",
				"LineID": "@ygl4660j"
			}
		],
		"大肚區": [
			{
				"w": 9,
				"name": "顏寬恒",
				"ename": "Yen Kuan Heng",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第2選舉區",
				"district": "沙鹿區、龍井區、大肚區、烏日區、霧峰區，大里區",
				"Email": "kuanheng@kuankuan.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "建國工專機械工程科畢業\n ;美國舊金山多明尼肯大學企管碩士\n ;中華大學行政管理研究所碩士",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n \n 臺中縣議會第14屆議長特別助理\n \n 任務型國大代表\n \n 立法委員顏清標國會助理\n \n 鎮瀾兒童家園義工",
				"allTel": "國會研究室：02-2358-8006;沙鹿服務處：04-2632-6151;烏日服務處：04-2337-3351;霧峰服務處：04-2330-2559",
				"labTel": "02-2358-8006",
				"serviceTel1": "沙鹿服務處：04-2632-6151",
				"serviceTel2": "烏日服務處：04-2337-3351",
				"serviceTel3": "霧峰服務處：04-2330-2559",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8010;沙鹿服務處：04-2632-6155;烏日服務處：04-2338-0155;霧峰服務處：04-2330-2551",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90106.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路10號3501室;沙鹿服務處：臺中市沙鹿區埔子里正義路1號;烏日服務處：臺中市烏日區光日路48號;霧峰服務處：臺中市霧峰區樹仁路178號",
				"labAddr": "10051臺北市中正區青島東路10號3501室",
				"serviceAdd1": "沙鹿服務處：臺中市沙鹿區埔子里正義路1號",
				"serviceAdd2": "烏日服務處：臺中市烏日區光日路48號",
				"serviceAdd3": "霧峰服務處：臺中市霧峰區樹仁路178號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kuanheng99/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A1%8F%E5%AF%AC%E6%81%92",
				"LineID": "@ygl4660j"
			}
		],
		"烏日區": [
			{
				"w": 9,
				"name": "顏寬恒",
				"ename": "Yen Kuan Heng",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第2選舉區",
				"district": "沙鹿區、龍井區、大肚區、烏日區、霧峰區，大里區",
				"Email": "kuanheng@kuankuan.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "建國工專機械工程科畢業\n ;美國舊金山多明尼肯大學企管碩士\n ;中華大學行政管理研究所碩士",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n \n 臺中縣議會第14屆議長特別助理\n \n 任務型國大代表\n \n 立法委員顏清標國會助理\n \n 鎮瀾兒童家園義工",
				"allTel": "國會研究室：02-2358-8006;沙鹿服務處：04-2632-6151;烏日服務處：04-2337-3351;霧峰服務處：04-2330-2559",
				"labTel": "02-2358-8006",
				"serviceTel1": "沙鹿服務處：04-2632-6151",
				"serviceTel2": "烏日服務處：04-2337-3351",
				"serviceTel3": "霧峰服務處：04-2330-2559",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8010;沙鹿服務處：04-2632-6155;烏日服務處：04-2338-0155;霧峰服務處：04-2330-2551",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90106.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路10號3501室;沙鹿服務處：臺中市沙鹿區埔子里正義路1號;烏日服務處：臺中市烏日區光日路48號;霧峰服務處：臺中市霧峰區樹仁路178號",
				"labAddr": "10051臺北市中正區青島東路10號3501室",
				"serviceAdd1": "沙鹿服務處：臺中市沙鹿區埔子里正義路1號",
				"serviceAdd2": "烏日服務處：臺中市烏日區光日路48號",
				"serviceAdd3": "霧峰服務處：臺中市霧峰區樹仁路178號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kuanheng99/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A1%8F%E5%AF%AC%E6%81%92",
				"LineID": "@ygl4660j"
			}
		],
		"霧峰區，大里區": [
			{
				"w": 9,
				"name": "顏寬恒",
				"ename": "Yen Kuan Heng",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺中市第2選舉區",
				"district": "沙鹿區、龍井區、大肚區、烏日區、霧峰區，大里區",
				"Email": "kuanheng@kuankuan.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "建國工專機械工程科畢業\n ;美國舊金山多明尼肯大學企管碩士\n ;中華大學行政管理研究所碩士",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n \n 臺中縣議會第14屆議長特別助理\n \n 任務型國大代表\n \n 立法委員顏清標國會助理\n \n 鎮瀾兒童家園義工",
				"allTel": "國會研究室：02-2358-8006;沙鹿服務處：04-2632-6151;烏日服務處：04-2337-3351;霧峰服務處：04-2330-2559",
				"labTel": "02-2358-8006",
				"serviceTel1": "沙鹿服務處：04-2632-6151",
				"serviceTel2": "烏日服務處：04-2337-3351",
				"serviceTel3": "霧峰服務處：04-2330-2559",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8010;沙鹿服務處：04-2632-6155;烏日服務處：04-2338-0155;霧峰服務處：04-2330-2551",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90106.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路10號3501室;沙鹿服務處：臺中市沙鹿區埔子里正義路1號;烏日服務處：臺中市烏日區光日路48號;霧峰服務處：臺中市霧峰區樹仁路178號",
				"labAddr": "10051臺北市中正區青島東路10號3501室",
				"serviceAdd1": "沙鹿服務處：臺中市沙鹿區埔子里正義路1號",
				"serviceAdd2": "烏日服務處：臺中市烏日區光日路48號",
				"serviceAdd3": "霧峰服務處：臺中市霧峰區樹仁路178號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kuanheng99/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A1%8F%E5%AF%AC%E6%81%92",
				"LineID": "@ygl4660j"
			}
		]
	},
	"臺北市": {
		"北投區": [
			{
				"w": 9,
				"name": "吳思瑤",
				"ename": "Wu Szu Yao",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺北市第1選舉區",
				"district": "北投區、士林區",
				"Email": "ly11164a@ly.gov.tw",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學政治學研究所碩士\n ;輔仁大學西語系、日語系文學雙學士",
				"profession": "教育及文化委員會",
				"experience": "臺北市議員(第10、11、12屆)\n \n 臺北市議會民進黨團總召集人\n \n 民進黨中常委、中執委、中評委",
				"allTel": "國會研究室：02-2358-8131;北投服務處：02-2820-5800",
				"labTel": "02-2358-8131",
				"serviceTel1": "北投服務處：02-2820-5800",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8135;北投服務處：02-2820-3500",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90015.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3108室;北投服務處：臺北市北投區承德路七段196號",
				"labAddr": "10051臺北市中正區青島東路1-3號3108室",
				"serviceAdd1": "北投服務處：臺北市北投區承德路七段196號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/rosalia0528?fref=ts\nhttps://www.facebook.com/TaipeiNeedYou",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%90%B3%E6%80%9D%E7%91%A4",
				"LineID": "@zue7555p"
			}
		],
		"士林區": [
			{
				"w": 9,
				"name": "吳思瑤",
				"ename": "Wu Szu Yao",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺北市第1選舉區",
				"district": "北投區、士林區",
				"Email": "ly11164a@ly.gov.tw",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學政治學研究所碩士\n ;輔仁大學西語系、日語系文學雙學士",
				"profession": "教育及文化委員會",
				"experience": "臺北市議員(第10、11、12屆)\n \n 臺北市議會民進黨團總召集人\n \n 民進黨中常委、中執委、中評委",
				"allTel": "國會研究室：02-2358-8131;北投服務處：02-2820-5800",
				"labTel": "02-2358-8131",
				"serviceTel1": "北投服務處：02-2820-5800",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8135;北投服務處：02-2820-3500",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90015.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3108室;北投服務處：臺北市北投區承德路七段196號",
				"labAddr": "10051臺北市中正區青島東路1-3號3108室",
				"serviceAdd1": "北投服務處：臺北市北投區承德路七段196號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/rosalia0528?fref=ts\nhttps://www.facebook.com/TaipeiNeedYou",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%90%B3%E6%80%9D%E7%91%A4",
				"LineID": "@zue7555p"
			},
			{
				"w": 9,
				"name": "姚文智",
				"ename": "Yao Wen Chih",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺北市第2選舉區",
				"district": "大同區、士林區",
				"Email": "pasuyayao@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "輔仁大學大眾傳播系學士\n ;政治大學政治研究所碩士",
				"profession": "內政委員會",
				"experience": "自由時報記者、編輯\n \n 高雄市新聞處長、副秘書長\n \n 愛河整治工作小組召集人\n \n 文建會公共藝術獎共同得獎人\n \n 台視董事兼文化公司總經理\n \n 行政院新聞局長\n \n 蘭雅國中、輔大、政大社科院傑出校友\n \n 2014年柯文哲競選臺北市市長後援會總會長\n \n 士林大同選出立法委員",
				"allTel": "國會研究室：02-2358-6758",
				"labTel": "02-2358-6758",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6040",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90038.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1102室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1102室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YaoTurningTaipei/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%A7%9A%E6%96%87%E6%99%BA",
				"LineID": "@mnr8768c"
			}
		],
		"內湖區": [
			{
				"w": 9,
				"name": "李彥秀",
				"ename": "Lee Yen Hsiu",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺北市第4選舉區",
				"district": "內湖區、南港區",
				"Email": "tcc8708@mail.tcc.gov.tw",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國加州爾灣大學經濟系畢業",
				"profession": "",
				"experience": "臺北市議會第8、9、10、11、12屆市議員\n \n 青溪婦聯會南港支分會主任委員\n \n 南港區體育會理事長",
				"allTel": "國會研究室：02-2358-6281;南港服務處：02-2783-4987;內湖服務處：02-2798-9288",
				"labTel": "02-2358-6281",
				"serviceTel1": "南港服務處：02-2783-4987",
				"serviceTel2": "內湖服務處：02-2798-9288",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6925;南港服務處：02-2651-1941;內湖服務處：02-2798-6766",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90022.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2119室;南港服務處：臺北市南港區研究院路二段70巷10弄8號;內湖服務處：臺北市內湖區內湖路一段737巷27號2樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2119室",
				"serviceAdd1": "南港服務處：臺北市南港區研究院路二段70巷10弄8號",
				"serviceAdd2": "內湖服務處：臺北市內湖區內湖路一段737巷27號2樓",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/ashow.tpe/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9D%8E%E5%BD%A5%E7%A7%80",
				"LineID": ""
			}
		],
		"南港區": [
			{
				"w": 9,
				"name": "李彥秀",
				"ename": "Lee Yen Hsiu",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺北市第4選舉區",
				"district": "內湖區、南港區",
				"Email": "tcc8708@mail.tcc.gov.tw",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國加州爾灣大學經濟系畢業",
				"profession": "",
				"experience": "臺北市議會第8、9、10、11、12屆市議員\n \n 青溪婦聯會南港支分會主任委員\n \n 南港區體育會理事長",
				"allTel": "國會研究室：02-2358-6281;南港服務處：02-2783-4987;內湖服務處：02-2798-9288",
				"labTel": "02-2358-6281",
				"serviceTel1": "南港服務處：02-2783-4987",
				"serviceTel2": "內湖服務處：02-2798-9288",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6925;南港服務處：02-2651-1941;內湖服務處：02-2798-6766",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90022.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2119室;南港服務處：臺北市南港區研究院路二段70巷10弄8號;內湖服務處：臺北市內湖區內湖路一段737巷27號2樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2119室",
				"serviceAdd1": "南港服務處：臺北市南港區研究院路二段70巷10弄8號",
				"serviceAdd2": "內湖服務處：臺北市內湖區內湖路一段737巷27號2樓",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/ashow.tpe/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9D%8E%E5%BD%A5%E7%A7%80",
				"LineID": ""
			}
		],
		"萬華區": [
			{
				"w": 9,
				"name": "林昶佐",
				"ename": "Lim Tshiong Tso",
				"sex": "男",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "臺北市第5選舉區",
				"district": "萬華區、中正區",
				"Email": "ivotefreddy@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立台北大學企業管理學系學士",
				"profession": "外交及國防委員會",
				"experience": "時代力量創黨工程隊總隊長\n \n 時代力量主席團成員\n \n 國際知名閃靈樂團主唱\n \n 國際特赦組織台灣分會理事長\n \n 行政院二二八基金會董事\n \n 獨立音樂協會理事長\n \n 曾獲金曲獎、總統文化獎\n \n 第16、18屆金曲獎評審\n \n 三立「超級紅人榜」評審",
				"allTel": "國會研究室：02-2358-6121",
				"labTel": "02-2358-6121",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90030.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0803室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0803室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/ivotefreddy/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E6%98%B6%E4%BD%90",
				"LineID": ""
			}
		],
		"中正區": [
			{
				"w": 9,
				"name": "林昶佐",
				"ename": "Lim Tshiong Tso",
				"sex": "男",
				"party": "時代力量",
				"partyGroup": "時代力量",
				"areaName": "臺北市第5選舉區",
				"district": "萬華區、中正區",
				"Email": "ivotefreddy@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立台北大學企業管理學系學士",
				"profession": "外交及國防委員會",
				"experience": "時代力量創黨工程隊總隊長\n \n 時代力量主席團成員\n \n 國際知名閃靈樂團主唱\n \n 國際特赦組織台灣分會理事長\n \n 行政院二二八基金會董事\n \n 獨立音樂協會理事長\n \n 曾獲金曲獎、總統文化獎\n \n 第16、18屆金曲獎評審\n \n 三立「超級紅人榜」評審",
				"allTel": "國會研究室：02-2358-6121",
				"labTel": "02-2358-6121",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90030.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0803室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0803室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/ivotefreddy/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E6%98%B6%E4%BD%90",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "賴士葆",
				"ename": "Lai Shyh Bao",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺北市第8選舉區",
				"district": "文山區、中正區",
				"Email": "abao.service@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國南加州大學工業與系統工程碩士、博士;國立政治大學企管所碩士;國立成功大學機械系學士",
				"profession": "財政委員會",
				"experience": "第3屆國民大會代表\n 第4、6、7、8屆立法委員\n 臺北市政府市政顧問團總召集人\n 臺北市政府經濟發展委員會副總召集人、首席顧問\n 臺北市政府花博顧問\n 考試院典試委員\n 國立政治大學企研所所長、教授",
				"allTel": "國會研究室：02-2358-8166;文山服務處：02-2935-5358",
				"labTel": "02-2358-8166",
				"serviceTel1": "文山服務處：02-2935-5358",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8170;文山服務處：02-2930-0945",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90101.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3110室;文山服務處：臺北市文山區景興路254號",
				"labAddr": "10051臺北市中正區青島東路1-3號3110室",
				"serviceAdd1": "文山服務處：臺北市文山區景興路254號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%B3%B4%E5%A3%AB%E8%91%86-1573873889493647/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B3%B4%E5%A3%AB%E8%91%86",
				"LineID": "@abao"
			}
		],
		"大同區": [
			{
				"w": 9,
				"name": "姚文智",
				"ename": "Yao Wen Chih",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺北市第2選舉區",
				"district": "大同區、士林區",
				"Email": "pasuyayao@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "輔仁大學大眾傳播系學士\n ;政治大學政治研究所碩士",
				"profession": "內政委員會",
				"experience": "自由時報記者、編輯\n \n 高雄市新聞處長、副秘書長\n \n 愛河整治工作小組召集人\n \n 文建會公共藝術獎共同得獎人\n \n 台視董事兼文化公司總經理\n \n 行政院新聞局長\n \n 蘭雅國中、輔大、政大社科院傑出校友\n \n 2014年柯文哲競選臺北市市長後援會總會長\n \n 士林大同選出立法委員",
				"allTel": "國會研究室：02-2358-6758",
				"labTel": "02-2358-6758",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6040",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90038.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1102室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1102室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/YaoTurningTaipei/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%A7%9A%E6%96%87%E6%99%BA",
				"LineID": "@mnr8768c"
			}
		],
		"信義區": [
			{
				"w": 9,
				"name": "費鴻泰",
				"ename": "Fai Alex Hrong Tai",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺北市第7選舉區",
				"district": "信義區、松山區",
				"Email": "fai27291966@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國肯塔基大學統計學博士\n ;美國北伊利諾大學統計學碩士\n ;國立中興大學統計學學士\n ;成功高中\n ;大安國中\n ;三興國小\n ;信義國小",
				"profession": "財政委員會",
				"experience": "立法委員（94年迄今）\n \n 國民黨中央常務委員\n \n 立法院國民黨團書記長\n \n 立法院財政委員會召集委員\n \n 立法院程序委員會召集委員\n \n 立法院經費稽核委員會委員\n \n 臺北市議會副議長（87-91年）\n \n 臺北市議會議員（83-93年）",
				"allTel": "國會研究室：02-2358-6990;服務處：02-2729-1966",
				"labTel": "02-2358-6990",
				"serviceTel1": "服務處：02-2729-1966",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6994;服務處：02-2720-9492",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90073.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0502室;服務處：11050臺北市信義區莊敬路311號5樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0502室",
				"serviceAdd1": "服務處：11050臺北市信義區莊敬路311號5樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%B2%BB%E9%B4%BB%E6%B3%B0%E9%98%BF%E5%8A%9B%E5%85%8B%E5%8F%B8-893657620668012/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B2%BB%E9%B4%BB%E6%B3%B0",
				"LineID": "@dtp8176d"
			}
		],
		"松山區": [
			{
				"w": 9,
				"name": "費鴻泰",
				"ename": "Fai Alex Hrong Tai",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺北市第7選舉區",
				"district": "信義區、松山區",
				"Email": "fai27291966@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國肯塔基大學統計學博士\n ;美國北伊利諾大學統計學碩士\n ;國立中興大學統計學學士\n ;成功高中\n ;大安國中\n ;三興國小\n ;信義國小",
				"profession": "財政委員會",
				"experience": "立法委員（94年迄今）\n \n 國民黨中央常務委員\n \n 立法院國民黨團書記長\n \n 立法院財政委員會召集委員\n \n 立法院程序委員會召集委員\n \n 立法院經費稽核委員會委員\n \n 臺北市議會副議長（87-91年）\n \n 臺北市議會議員（83-93年）",
				"allTel": "國會研究室：02-2358-6990;服務處：02-2729-1966",
				"labTel": "02-2358-6990",
				"serviceTel1": "服務處：02-2729-1966",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6994;服務處：02-2720-9492",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90073.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0502室;服務處：11050臺北市信義區莊敬路311號5樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0502室",
				"serviceAdd1": "服務處：11050臺北市信義區莊敬路311號5樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%B2%BB%E9%B4%BB%E6%B3%B0%E9%98%BF%E5%8A%9B%E5%85%8B%E5%8F%B8-893657620668012/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B2%BB%E9%B4%BB%E6%B3%B0",
				"LineID": "@dtp8176d"
			},
			{
				"w": 9,
				"name": "蔣萬安",
				"ename": "Chiang Wan An",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺北市第3選舉區",
				"district": "中山區、松山區",
				"Email": "office@wanan.tw",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國賓夕法尼亞大學法學院法律博士\n ;美國賓夕法尼亞大學法學院法學碩士\n ;國立政治大學法律系、外交系雙學士\n ;臺北市立建國高級中學\n ;國立師大附中國中部",
				"profession": "法律",
				"experience": "萬澤外國法事務律師事務所主持律師\n \n 美國WSGR律師事務所執業律師",
				"allTel": "國會研究室：02-2358-8268",
				"labTel": "02-2358-8268",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90094.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3206室",
				"labAddr": "10051臺北市中正區青島東路1-3號3206室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chiangwanan/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A3%E8%90%AC%E5%AE%89",
				"LineID": "@wanan"
			}
		],
		"大安區": [
			{
				"w": 9,
				"name": "蔣乃辛",
				"ename": "Chiang Nai Shin",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺北市第6選舉區",
				"district": "大安區",
				"Email": "ly11107b@ly.gov.tw",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "大同大學事業經營研究所碩士畢業",
				"profession": "教育及文化委員會",
				"experience": "第7、8屆立法委員\n 臺北市第4、5、6、7、8、9、10屆議員\n 臺北市家庭扶助中心扶幼委員會主任委員\n 臺北市金華國中、小學家長會榮譽會長\n 政治大學大同大學校友會理事",
				"allTel": "國會研究室：02-2358-6901",
				"labTel": "02-2358-6901",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6905",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90093.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2112室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2112室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100004700057932&fref=ts\nhttps://www.facebook.com/Chiang.NaiShin",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A3%E4%B9%83%E8%BE%9B",
				"LineID": ""
			}
		],
		"中山區": [
			{
				"w": 9,
				"name": "蔣萬安",
				"ename": "Chiang Wan An",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺北市第3選舉區",
				"district": "中山區、松山區",
				"Email": "office@wanan.tw",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國賓夕法尼亞大學法學院法律博士\n ;美國賓夕法尼亞大學法學院法學碩士\n ;國立政治大學法律系、外交系雙學士\n ;臺北市立建國高級中學\n ;國立師大附中國中部",
				"profession": "法律",
				"experience": "萬澤外國法事務律師事務所主持律師\n \n 美國WSGR律師事務所執業律師",
				"allTel": "國會研究室：02-2358-8268",
				"labTel": "02-2358-8268",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90094.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3206室",
				"labAddr": "10051臺北市中正區青島東路1-3號3206室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chiangwanan/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A3%E8%90%AC%E5%AE%89",
				"LineID": "@wanan"
			}
		],
		"文山區": [
			{
				"w": 9,
				"name": "賴士葆",
				"ename": "Lai Shyh Bao",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "臺北市第8選舉區",
				"district": "文山區、中正區",
				"Email": "abao.service@gmail.com",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國南加州大學工業與系統工程碩士、博士;國立政治大學企管所碩士;國立成功大學機械系學士",
				"profession": "財政委員會",
				"experience": "第3屆國民大會代表\n 第4、6、7、8屆立法委員\n 臺北市政府市政顧問團總召集人\n 臺北市政府經濟發展委員會副總召集人、首席顧問\n 臺北市政府花博顧問\n 考試院典試委員\n 國立政治大學企研所所長、教授",
				"allTel": "國會研究室：02-2358-8166;文山服務處：02-2935-5358",
				"labTel": "02-2358-8166",
				"serviceTel1": "文山服務處：02-2935-5358",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8170;文山服務處：02-2930-0945",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90101.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3110室;文山服務處：臺北市文山區景興路254號",
				"labAddr": "10051臺北市中正區青島東路1-3號3110室",
				"serviceAdd1": "文山服務處：臺北市文山區景興路254號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%B3%B4%E5%A3%AB%E8%91%86-1573873889493647/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B3%B4%E5%A3%AB%E8%91%86",
				"LineID": "@abao"
			}
		]
	},
	"桃園市": {
		"平鎮區": [
			{
				"w": 9,
				"name": "呂玉玲",
				"ename": "Lu Yu Ling",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "桃園市第5選舉區",
				"district": "平鎮區、龍潭區",
				"Email": "yuling4015616@hotmail.com.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "桃園創新技術學院企業管理科\n ;桃園市育達高中\n ;桃園市中壢國中\n ;桃園市中壢國小",
				"profession": "外交及國防委員會",
				"experience": "中華民國第8屆立法委員\n \n 中國國民黨第19屆中央委員\n \n 中國國民黨桃園市平鎮區委員會主任委員\n \n 珍珠國際同濟會第10屆會長\n \n 桃園市守望相助大隊平鎮中隊長\n \n 國立中央大學客家學院平鎮客家書院執行委員\n \n 桃園市體育會划船委員會主任委員\n \n 桃園市平鎮區槌球推廣協會理事長\n \n 婦聯青溪桃園縣支會主任委員\n \n 中華民國婦女聯合會平鎮分會主任委員\n \n 桃園市平鎮區志工協會理事長\n \n 桃園市平鎮區社區營造協會理事長",
				"allTel": "國會研究室：02-2358-6836;平鎮服務處：03-401-5616;龍潭服務處：03-409-6688;03-480-6549",
				"labTel": "02-2358-6836",
				"serviceTel1": "平鎮服務處：03-401-5616",
				"serviceTel2": "龍潭服務處：03-409-6688",
				"serviceTel3": "03-480-6549",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6840;平鎮服務處：03-401-0616",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90018.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0903室;平鎮服務處：桃園縣平鎮市復興街68號;龍潭服務處：桃園縣龍潭鄉華南路一段135號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0903室",
				"serviceAdd1": "平鎮服務處：桃園縣平鎮市復興街68號",
				"serviceAdd2": "龍潭服務處：桃園縣龍潭鄉華南路一段135號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100002600612191&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%91%82%E7%8E%89%E7%8E%B2",
				"LineID": "@yuling"
			}
		],
		"龍潭區": [
			{
				"w": 9,
				"name": "呂玉玲",
				"ename": "Lu Yu Ling",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "桃園市第5選舉區",
				"district": "平鎮區、龍潭區",
				"Email": "yuling4015616@hotmail.com.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "桃園創新技術學院企業管理科\n ;桃園市育達高中\n ;桃園市中壢國中\n ;桃園市中壢國小",
				"profession": "外交及國防委員會",
				"experience": "中華民國第8屆立法委員\n \n 中國國民黨第19屆中央委員\n \n 中國國民黨桃園市平鎮區委員會主任委員\n \n 珍珠國際同濟會第10屆會長\n \n 桃園市守望相助大隊平鎮中隊長\n \n 國立中央大學客家學院平鎮客家書院執行委員\n \n 桃園市體育會划船委員會主任委員\n \n 桃園市平鎮區槌球推廣協會理事長\n \n 婦聯青溪桃園縣支會主任委員\n \n 中華民國婦女聯合會平鎮分會主任委員\n \n 桃園市平鎮區志工協會理事長\n \n 桃園市平鎮區社區營造協會理事長",
				"allTel": "國會研究室：02-2358-6836;平鎮服務處：03-401-5616;龍潭服務處：03-409-6688;03-480-6549",
				"labTel": "02-2358-6836",
				"serviceTel1": "平鎮服務處：03-401-5616",
				"serviceTel2": "龍潭服務處：03-409-6688",
				"serviceTel3": "03-480-6549",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6840;平鎮服務處：03-401-0616",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90018.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0903室;平鎮服務處：桃園縣平鎮市復興街68號;龍潭服務處：桃園縣龍潭鄉華南路一段135號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0903室",
				"serviceAdd1": "平鎮服務處：桃園縣平鎮市復興街68號",
				"serviceAdd2": "龍潭服務處：桃園縣龍潭鄉華南路一段135號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100002600612191&fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%91%82%E7%8E%89%E7%8E%B2",
				"LineID": "@yuling"
			}
		],
		"中壢區": [
			{
				"w": 9,
				"name": "陳學聖",
				"ename": "Chen Shei Saint",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "桃園市第3選舉區",
				"district": "中壢區",
				"Email": "apolloa@ms2.hinet.net",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "建國中學\n ;國立臺灣大學政治學系學士\n ;淡江大學中國大陸研究所碩士",
				"profession": "教育及文化委員會",
				"experience": "第4、5、8屆立法委員\n \n 桃園縣政府文化局局長\n \n 中國國民黨桃園縣、市黨部主委\n \n 亞洲電台資深主持人\n \n 中華民國保護動物協會理事長\n \n 中華民國腦性麻痺協會理事長\n \n 中國時報撰述委員",
				"allTel": "國會研究室：02-2358-6699",
				"labTel": "02-2358-6699",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6700",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90070.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0908室;中壢服務處：桃園縣中壢市中央西路二段281號4樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0908室",
				"serviceAdd1": "中壢服務處：桃園縣中壢市中央西路二段281號4樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/junglicity/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E5%AD%B8%E8%81%96",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "趙正宇",
				"ename": "Chao Cheng Yu",
				"sex": "男",
				"party": "無黨籍",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第6選舉區",
				"district": "八德區、大溪區、復興區、中壢區",
				"Email": "a0988128745@yahoo.com.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "銘傳大學公共事務學系研究所碩士",
				"profession": "交通委員會",
				"experience": "桃園縣八德市公所秘書\n 桃園縣八德市民代表\n 桃園縣第15、16、16屆議員\n 桃園市第1屆議員",
				"allTel": "國會研究室：02-2358-6896;八德服務處：03-3661-613",
				"labTel": "02-2358-6896",
				"serviceTel1": "八德服務處：03-3661-613",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6900;八德服務處：03-3617-569",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90085.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1002室;八德服務處：334桃園市八德區永福西街38號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1002室",
				"serviceAdd1": "八德服務處：334桃園市八德區永福西街38號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/JhengYuOfficeBlog/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B6%99%E6%AD%A3%E5%AE%87",
				"LineID": ""
			}
		],
		"楊梅區": [
			{
				"w": 9,
				"name": "陳賴素美",
				"ename": "Chen Lai Su Mei",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第2選舉區",
				"district": "楊梅區、新屋區、觀音區、大園區",
				"Email": "su.mei0110@yahoo.com.tw",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "萬能科技大學學士畢業\n ;國立新竹高商",
				"profession": "財政委員會",
				"experience": "中央大學EMBA企管碩士班\n \n 國家地政士特考及格\n \n 桃園市議會第1屆市議員\n \n 民主進步黨桃園市黨部主任委員\n \n 桃園縣議會第16、17屆議員\n \n 桃園市陳姓宗親會副會長\n \n 桃園市賴姓宗親會副會長\n \n 楊光國中小家長會長\n \n 桃園市楊梅慢速壘球協會理事長",
				"allTel": "國會研究室：02-2358-6136",
				"labTel": "02-2358-6136",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6140",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90071.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0601室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0601室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su.mei0110/\nhttps://www.facebook.com/people/%E9%99%B3%E8%B3%B4%E7%B4%A0%E7%BE%8E/100003570733627",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B3%B4%E7%B4%A0%E7%BE%8E",
				"LineID": ""
			}
		],
		"新屋區": [
			{
				"w": 9,
				"name": "陳賴素美",
				"ename": "Chen Lai Su Mei",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第2選舉區",
				"district": "楊梅區、新屋區、觀音區、大園區",
				"Email": "su.mei0110@yahoo.com.tw",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "萬能科技大學學士畢業\n ;國立新竹高商",
				"profession": "財政委員會",
				"experience": "中央大學EMBA企管碩士班\n \n 國家地政士特考及格\n \n 桃園市議會第1屆市議員\n \n 民主進步黨桃園市黨部主任委員\n \n 桃園縣議會第16、17屆議員\n \n 桃園市陳姓宗親會副會長\n \n 桃園市賴姓宗親會副會長\n \n 楊光國中小家長會長\n \n 桃園市楊梅慢速壘球協會理事長",
				"allTel": "國會研究室：02-2358-6136",
				"labTel": "02-2358-6136",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6140",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90071.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0601室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0601室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su.mei0110/\nhttps://www.facebook.com/people/%E9%99%B3%E8%B3%B4%E7%B4%A0%E7%BE%8E/100003570733627",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B3%B4%E7%B4%A0%E7%BE%8E",
				"LineID": ""
			}
		],
		"觀音區": [
			{
				"w": 9,
				"name": "陳賴素美",
				"ename": "Chen Lai Su Mei",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第2選舉區",
				"district": "楊梅區、新屋區、觀音區、大園區",
				"Email": "su.mei0110@yahoo.com.tw",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "萬能科技大學學士畢業\n ;國立新竹高商",
				"profession": "財政委員會",
				"experience": "中央大學EMBA企管碩士班\n \n 國家地政士特考及格\n \n 桃園市議會第1屆市議員\n \n 民主進步黨桃園市黨部主任委員\n \n 桃園縣議會第16、17屆議員\n \n 桃園市陳姓宗親會副會長\n \n 桃園市賴姓宗親會副會長\n \n 楊光國中小家長會長\n \n 桃園市楊梅慢速壘球協會理事長",
				"allTel": "國會研究室：02-2358-6136",
				"labTel": "02-2358-6136",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6140",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90071.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0601室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0601室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su.mei0110/\nhttps://www.facebook.com/people/%E9%99%B3%E8%B3%B4%E7%B4%A0%E7%BE%8E/100003570733627",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B3%B4%E7%B4%A0%E7%BE%8E",
				"LineID": ""
			}
		],
		"大園區": [
			{
				"w": 9,
				"name": "陳賴素美",
				"ename": "Chen Lai Su Mei",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第2選舉區",
				"district": "楊梅區、新屋區、觀音區、大園區",
				"Email": "su.mei0110@yahoo.com.tw",
				"committee": "第9屆第1會期：財政委員會;第9屆第2會期：財政委員會",
				"onboardDate": "2016/2/1",
				"degree": "萬能科技大學學士畢業\n ;國立新竹高商",
				"profession": "財政委員會",
				"experience": "中央大學EMBA企管碩士班\n \n 國家地政士特考及格\n \n 桃園市議會第1屆市議員\n \n 民主進步黨桃園市黨部主任委員\n \n 桃園縣議會第16、17屆議員\n \n 桃園市陳姓宗親會副會長\n \n 桃園市賴姓宗親會副會長\n \n 楊光國中小家長會長\n \n 桃園市楊梅慢速壘球協會理事長",
				"allTel": "國會研究室：02-2358-6136",
				"labTel": "02-2358-6136",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6140",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90071.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0601室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0601室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su.mei0110/\nhttps://www.facebook.com/people/%E9%99%B3%E8%B3%B4%E7%B4%A0%E7%BE%8E/100003570733627",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B3%B4%E7%B4%A0%E7%BE%8E",
				"LineID": ""
			}
		],
		"八德區": [
			{
				"w": 9,
				"name": "趙正宇",
				"ename": "Chao Cheng Yu",
				"sex": "男",
				"party": "無黨籍",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第6選舉區",
				"district": "八德區、大溪區、復興區、中壢區",
				"Email": "a0988128745@yahoo.com.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "銘傳大學公共事務學系研究所碩士",
				"profession": "交通委員會",
				"experience": "桃園縣八德市公所秘書\n 桃園縣八德市民代表\n 桃園縣第15、16、16屆議員\n 桃園市第1屆議員",
				"allTel": "國會研究室：02-2358-6896;八德服務處：03-3661-613",
				"labTel": "02-2358-6896",
				"serviceTel1": "八德服務處：03-3661-613",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6900;八德服務處：03-3617-569",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90085.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1002室;八德服務處：334桃園市八德區永福西街38號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1002室",
				"serviceAdd1": "八德服務處：334桃園市八德區永福西街38號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/JhengYuOfficeBlog/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B6%99%E6%AD%A3%E5%AE%87",
				"LineID": ""
			}
		],
		"大溪區": [
			{
				"w": 9,
				"name": "趙正宇",
				"ename": "Chao Cheng Yu",
				"sex": "男",
				"party": "無黨籍",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第6選舉區",
				"district": "八德區、大溪區、復興區、中壢區",
				"Email": "a0988128745@yahoo.com.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "銘傳大學公共事務學系研究所碩士",
				"profession": "交通委員會",
				"experience": "桃園縣八德市公所秘書\n 桃園縣八德市民代表\n 桃園縣第15、16、16屆議員\n 桃園市第1屆議員",
				"allTel": "國會研究室：02-2358-6896;八德服務處：03-3661-613",
				"labTel": "02-2358-6896",
				"serviceTel1": "八德服務處：03-3661-613",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6900;八德服務處：03-3617-569",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90085.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1002室;八德服務處：334桃園市八德區永福西街38號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1002室",
				"serviceAdd1": "八德服務處：334桃園市八德區永福西街38號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/JhengYuOfficeBlog/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B6%99%E6%AD%A3%E5%AE%87",
				"LineID": ""
			}
		],
		"復興區": [
			{
				"w": 9,
				"name": "趙正宇",
				"ename": "Chao Cheng Yu",
				"sex": "男",
				"party": "無黨籍",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第6選舉區",
				"district": "八德區、大溪區、復興區、中壢區",
				"Email": "a0988128745@yahoo.com.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "銘傳大學公共事務學系研究所碩士",
				"profession": "交通委員會",
				"experience": "桃園縣八德市公所秘書\n 桃園縣八德市民代表\n 桃園縣第15、16、16屆議員\n 桃園市第1屆議員",
				"allTel": "國會研究室：02-2358-6896;八德服務處：03-3661-613",
				"labTel": "02-2358-6896",
				"serviceTel1": "八德服務處：03-3661-613",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6900;八德服務處：03-3617-569",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90085.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1002室;八德服務處：334桃園市八德區永福西街38號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1002室",
				"serviceAdd1": "八德服務處：334桃園市八德區永福西街38號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/JhengYuOfficeBlog/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B6%99%E6%AD%A3%E5%AE%87",
				"LineID": ""
			}
		],
		"蘆竹區": [
			{
				"w": 9,
				"name": "鄭運鵬",
				"ename": "Cheng Yun Peng",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第1選舉區",
				"district": "蘆竹區、龜山區、桃園區",
				"Email": "",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺北市立福星國民小學\n ;私立延平中學直升部\n ;國立臺灣大學土木工程學系畢業",
				"profession": "交通委員會",
				"experience": "高雄市政府工務局機要秘書\n \n 謝長廷高雄市長競選總部發言人兼政務部主任\n \n 民主進步黨文宣部主任\n \n 第6屆立法委員\n \n 民主進步黨網路部主任\n \n 民主進步黨組織部主任\n \n 民主進步黨發言人",
				"allTel": "國會研究室：02-2358-6666;桃園區服務處：03-3357-255;蘆竹區服務處：03-3231-830;龜山服務處：03-3509-005",
				"labTel": "02-2358-6666",
				"serviceTel1": "桃園區服務處：03-3357-255",
				"serviceTel2": "蘆竹區服務處：03-3231-830",
				"serviceTel3": "龜山服務處：03-3509-005",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6670;桃園區服務處：03-3352-611;蘆竹區服務處：03-3232-370;龜山服務處：03-3909-015",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90096.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0608室;桃園區服務處：桃園市桃園區自強路224號;蘆竹區服務處：桃園市蘆竹區南竹路四段37號;龜山服務處：桃園市龜山區萬壽路二段1050號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0608室",
				"serviceAdd1": "桃園區服務處：桃園市桃園區自強路224號",
				"serviceAdd2": "蘆竹區服務處：桃園市蘆竹區南竹路四段37號",
				"serviceAdd3": "龜山服務處：桃園市龜山區萬壽路二段1050號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/nicepongpong/?fref=ts\nhttps://www.facebook.com/phoenix.cheng.96",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%84%AD%E9%81%8B%E9%B5%AC",
				"LineID": ""
			}
		],
		"龜山區": [
			{
				"w": 9,
				"name": "鄭運鵬",
				"ename": "Cheng Yun Peng",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第1選舉區",
				"district": "蘆竹區、龜山區、桃園區",
				"Email": "",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺北市立福星國民小學\n ;私立延平中學直升部\n ;國立臺灣大學土木工程學系畢業",
				"profession": "交通委員會",
				"experience": "高雄市政府工務局機要秘書\n \n 謝長廷高雄市長競選總部發言人兼政務部主任\n \n 民主進步黨文宣部主任\n \n 第6屆立法委員\n \n 民主進步黨網路部主任\n \n 民主進步黨組織部主任\n \n 民主進步黨發言人",
				"allTel": "國會研究室：02-2358-6666;桃園區服務處：03-3357-255;蘆竹區服務處：03-3231-830;龜山服務處：03-3509-005",
				"labTel": "02-2358-6666",
				"serviceTel1": "桃園區服務處：03-3357-255",
				"serviceTel2": "蘆竹區服務處：03-3231-830",
				"serviceTel3": "龜山服務處：03-3509-005",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6670;桃園區服務處：03-3352-611;蘆竹區服務處：03-3232-370;龜山服務處：03-3909-015",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90096.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0608室;桃園區服務處：桃園市桃園區自強路224號;蘆竹區服務處：桃園市蘆竹區南竹路四段37號;龜山服務處：桃園市龜山區萬壽路二段1050號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0608室",
				"serviceAdd1": "桃園區服務處：桃園市桃園區自強路224號",
				"serviceAdd2": "蘆竹區服務處：桃園市蘆竹區南竹路四段37號",
				"serviceAdd3": "龜山服務處：桃園市龜山區萬壽路二段1050號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/nicepongpong/?fref=ts\nhttps://www.facebook.com/phoenix.cheng.96",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%84%AD%E9%81%8B%E9%B5%AC",
				"LineID": ""
			}
		],
		"桃園區": [
			{
				"w": 9,
				"name": "鄭運鵬",
				"ename": "Cheng Yun Peng",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第1選舉區",
				"district": "蘆竹區、龜山區、桃園區",
				"Email": "",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺北市立福星國民小學\n ;私立延平中學直升部\n ;國立臺灣大學土木工程學系畢業",
				"profession": "交通委員會",
				"experience": "高雄市政府工務局機要秘書\n \n 謝長廷高雄市長競選總部發言人兼政務部主任\n \n 民主進步黨文宣部主任\n \n 第6屆立法委員\n \n 民主進步黨網路部主任\n \n 民主進步黨組織部主任\n \n 民主進步黨發言人",
				"allTel": "國會研究室：02-2358-6666;桃園區服務處：03-3357-255;蘆竹區服務處：03-3231-830;龜山服務處：03-3509-005",
				"labTel": "02-2358-6666",
				"serviceTel1": "桃園區服務處：03-3357-255",
				"serviceTel2": "蘆竹區服務處：03-3231-830",
				"serviceTel3": "龜山服務處：03-3509-005",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6670;桃園區服務處：03-3352-611;蘆竹區服務處：03-3232-370;龜山服務處：03-3909-015",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90096.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0608室;桃園區服務處：桃園市桃園區自強路224號;蘆竹區服務處：桃園市蘆竹區南竹路四段37號;龜山服務處：桃園市龜山區萬壽路二段1050號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0608室",
				"serviceAdd1": "桃園區服務處：桃園市桃園區自強路224號",
				"serviceAdd2": "蘆竹區服務處：桃園市蘆竹區南竹路四段37號",
				"serviceAdd3": "龜山服務處：桃園市龜山區萬壽路二段1050號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/nicepongpong/?fref=ts\nhttps://www.facebook.com/phoenix.cheng.96",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%84%AD%E9%81%8B%E9%B5%AC",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "鄭寶清",
				"ename": "Cheng Pao Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "桃園市第4選舉區",
				"district": "桃園區",
				"Email": "ly10751f@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立中央大學管理學博士\n ;國立中興大學法學碩士\n ;國立中興大學行政系學士",
				"profession": "交通委員會",
				"experience": "桃園航空城公司董事長\n \n 台鹽董事長\n \n 崇右技術學院副校長、教授\n \n 立法院民主進步黨黨團總召\n \n 第3、4屆立法委員\n \n 第二屆國大代表\n \n 民主進步黨中執委、中常委\n \n 民進黨桃園縣黨部主委",
				"allTel": "國會研究室：02-2358-6707",
				"labTel": "02-2358-6707",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6710",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90098.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0707室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0707室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/鄭寶清-1572448819666020",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%84%AD%E5%AF%B6%E6%B8%85",
				"LineID": ""
			}
		]
	},
	"高雄市": {
		"三民區": [
			{
				"w": 9,
				"name": "李昆澤",
				"ename": "Lee Kun Tse",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第6選舉區",
				"district": "三民區",
				"Email": "ptt928@gmail.com",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "輔大歷史系畢\n ;中山大學政治學碩士",
				"profession": "交通委員會",
				"experience": "蔡英文主席特別助理\n \n 第6、8屆立法委員（交通委員會召委）\n \n 第6屆高雄市議員（民進黨團總召）\n \n 第3屆國大代表（修憲審查小組召集人）\n \n 高雄縣政府新聞室主任\n \n 民進黨大型造勢晚會主持人\n \n 陳定南立委特別助理\n \n 台灣人權促進會總幹事\n \n 台灣人權雜誌總主筆\n \n 台灣環保聯盟幹事\n \n 電器維修工\n \n 成衣廠縫紉機維修工",
				"allTel": "國會研究室：02-2358-6086;高雄服務處：07-386-8292",
				"labTel": "02-2358-6086",
				"serviceTel1": "高雄服務處：07-386-8292",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6090;高雄服務處：07-386-3277",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90020.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0306室;高雄服務處：高雄市三民區大昌二路63號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0306室",
				"serviceAdd1": "高雄服務處：高雄市三民區大昌二路63號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/power2tw/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9D%8E%E6%98%86%E6%BE%A4",
				"LineID": ""
			},
			{
				"w": 9,
				"name": "管碧玲",
				"ename": "Kuan Bi Ling",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第5選舉區",
				"district": "鼓山區、鹽埕區、旗津區、三民區",
				"Email": "ly11059a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學政治學博士",
				"profession": "經濟委員會",
				"experience": "哈佛大學甘迺迪政府學院國家與國際安全高階行政專班結業\n \n 國立台北大學公共行政暨政策學系副教授\n \n 台灣教授協會秘書長\n \n 高雄市新聞處處長、文化局局長\n \n 第6、7、8屆立法委員\n \n 立法院教育文化委員會、交通委員會召集委員\n \n 立法院民進黨黨團幹事長\n \n 民進黨中央黨部政策中心主任\n \n 民進黨中央常務委員、中央執行委員",
				"allTel": "國會研究室：02-2358-8146;高雄服務處：07-313-7816;內惟服務處：07-533-0227;07-521-5237",
				"labTel": "02-2358-8146",
				"serviceTel1": "高雄服務處：07-313-7816",
				"serviceTel2": "內惟服務處：07-533-0227",
				"serviceTel3": "07-521-5237",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8150;高雄服務處：07-313-5797",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90083.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0901室;高雄服務處：高雄市三民區博愛一路183號;內惟服務處：高雄市鼓山區九如四路1097號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0901室",
				"serviceAdd1": "高雄服務處：高雄市三民區博愛一路183號",
				"serviceAdd2": "內惟服務處：高雄市鼓山區九如四路1097號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/biling.kuan/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%AE%A1%E7%A2%A7%E7%8E%B2",
				"LineID": "@shf4833c\n@kuanmom"
			}
		],
		"茄萣區": [
			{
				"w": 9,
				"name": "邱志偉",
				"ename": "Chiu Chih Wei",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第2選舉區",
				"district": "茄萣區、湖內區、路竹區、永安區、岡山區、彌陀區、梓官區、橋頭區",
				"Email": "hope-chiu@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡江大學俄羅斯研究所法學碩士\n ;國立臺灣大學國家發展研究所法學碩士\n ;國立中山大學大陸研究所社會科學博士",
				"profession": "經濟委員會",
				"experience": "高雄市政府民政局長\n \n 高雄縣政府民政處長\n \n 修憲國民大會代表\n \n 立陶宛維爾紐斯大學講座教授\n \n 愛沙尼亞塔圖大學講座教授\n \n 南華大學旅遊系助理教授\n \n 英國劍橋大學國際關係研究所\n \n 比利時魯汶大學歐洲研究所\n \n 中正大學國際經濟所博士班",
				"allTel": "國會研究室：02-2358-6561;岡山服務處：07-623-0655;茄萣服務處：07-690-1234;彌陀聯絡處：07-623-0655;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999;路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525;梓官服務處：07-610-3338",
				"labTel": "02-2358-6561",
				"serviceTel1": "岡山服務處：07-623-0655",
				"serviceTel2": "茄萣服務處：07-690-1234",
				"serviceTel3": "彌陀聯絡處：07-623-0655",
				"serviceTel4": "路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999",
				"serviceTel5": "路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525",
				"LabFax": "國會研究室：02-2358-6565;岡山服務處：07-623-0671;茄萣服務處：07-690-2598;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-6869;路竹區邱志偉立委與張文瑞議員聯合服務處：07-697-8588;梓官服務處：07-610-3338",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90036.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0607室;岡山服務處：高雄市岡山區華園路99號;茄萣服務處：高雄市茄萣區信義路三段138號;彌陀聯絡處：高雄市彌陀區鹽埕大路75號;路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號;路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0607室",
				"serviceAdd1": "岡山服務處：高雄市岡山區華園路99號",
				"serviceAdd2": "茄萣服務處：高雄市茄萣區信義路三段138號",
				"serviceAdd3": "彌陀聯絡處：高雄市彌陀區鹽埕大路75號",
				"serviceAdd4": "路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號",
				"serviceAdd5": "路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"facebook": "https://www.facebook.com/%E9%82%B1%E5%BF%97%E5%81%89-1588286501409955/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E5%BF%97%E5%81%89_(%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": ""
			}
		],
		"湖內區": [
			{
				"w": 9,
				"name": "邱志偉",
				"ename": "Chiu Chih Wei",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第2選舉區",
				"district": "茄萣區、湖內區、路竹區、永安區、岡山區、彌陀區、梓官區、橋頭區",
				"Email": "hope-chiu@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡江大學俄羅斯研究所法學碩士\n ;國立臺灣大學國家發展研究所法學碩士\n ;國立中山大學大陸研究所社會科學博士",
				"profession": "經濟委員會",
				"experience": "高雄市政府民政局長\n \n 高雄縣政府民政處長\n \n 修憲國民大會代表\n \n 立陶宛維爾紐斯大學講座教授\n \n 愛沙尼亞塔圖大學講座教授\n \n 南華大學旅遊系助理教授\n \n 英國劍橋大學國際關係研究所\n \n 比利時魯汶大學歐洲研究所\n \n 中正大學國際經濟所博士班",
				"allTel": "國會研究室：02-2358-6561;岡山服務處：07-623-0655;茄萣服務處：07-690-1234;彌陀聯絡處：07-623-0655;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999;路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525;梓官服務處：07-610-3338",
				"labTel": "02-2358-6561",
				"serviceTel1": "岡山服務處：07-623-0655",
				"serviceTel2": "茄萣服務處：07-690-1234",
				"serviceTel3": "彌陀聯絡處：07-623-0655",
				"serviceTel4": "路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999",
				"serviceTel5": "路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525",
				"LabFax": "國會研究室：02-2358-6565;岡山服務處：07-623-0671;茄萣服務處：07-690-2598;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-6869;路竹區邱志偉立委與張文瑞議員聯合服務處：07-697-8588;梓官服務處：07-610-3338",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90036.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0607室;岡山服務處：高雄市岡山區華園路99號;茄萣服務處：高雄市茄萣區信義路三段138號;彌陀聯絡處：高雄市彌陀區鹽埕大路75號;路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號;路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0607室",
				"serviceAdd1": "岡山服務處：高雄市岡山區華園路99號",
				"serviceAdd2": "茄萣服務處：高雄市茄萣區信義路三段138號",
				"serviceAdd3": "彌陀聯絡處：高雄市彌陀區鹽埕大路75號",
				"serviceAdd4": "路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號",
				"serviceAdd5": "路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"facebook": "https://www.facebook.com/%E9%82%B1%E5%BF%97%E5%81%89-1588286501409955/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E5%BF%97%E5%81%89_(%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": ""
			}
		],
		"路竹區": [
			{
				"w": 9,
				"name": "邱志偉",
				"ename": "Chiu Chih Wei",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第2選舉區",
				"district": "茄萣區、湖內區、路竹區、永安區、岡山區、彌陀區、梓官區、橋頭區",
				"Email": "hope-chiu@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡江大學俄羅斯研究所法學碩士\n ;國立臺灣大學國家發展研究所法學碩士\n ;國立中山大學大陸研究所社會科學博士",
				"profession": "經濟委員會",
				"experience": "高雄市政府民政局長\n \n 高雄縣政府民政處長\n \n 修憲國民大會代表\n \n 立陶宛維爾紐斯大學講座教授\n \n 愛沙尼亞塔圖大學講座教授\n \n 南華大學旅遊系助理教授\n \n 英國劍橋大學國際關係研究所\n \n 比利時魯汶大學歐洲研究所\n \n 中正大學國際經濟所博士班",
				"allTel": "國會研究室：02-2358-6561;岡山服務處：07-623-0655;茄萣服務處：07-690-1234;彌陀聯絡處：07-623-0655;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999;路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525;梓官服務處：07-610-3338",
				"labTel": "02-2358-6561",
				"serviceTel1": "岡山服務處：07-623-0655",
				"serviceTel2": "茄萣服務處：07-690-1234",
				"serviceTel3": "彌陀聯絡處：07-623-0655",
				"serviceTel4": "路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999",
				"serviceTel5": "路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525",
				"LabFax": "國會研究室：02-2358-6565;岡山服務處：07-623-0671;茄萣服務處：07-690-2598;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-6869;路竹區邱志偉立委與張文瑞議員聯合服務處：07-697-8588;梓官服務處：07-610-3338",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90036.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0607室;岡山服務處：高雄市岡山區華園路99號;茄萣服務處：高雄市茄萣區信義路三段138號;彌陀聯絡處：高雄市彌陀區鹽埕大路75號;路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號;路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0607室",
				"serviceAdd1": "岡山服務處：高雄市岡山區華園路99號",
				"serviceAdd2": "茄萣服務處：高雄市茄萣區信義路三段138號",
				"serviceAdd3": "彌陀聯絡處：高雄市彌陀區鹽埕大路75號",
				"serviceAdd4": "路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號",
				"serviceAdd5": "路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"facebook": "https://www.facebook.com/%E9%82%B1%E5%BF%97%E5%81%89-1588286501409955/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E5%BF%97%E5%81%89_(%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": ""
			}
		],
		"永安區": [
			{
				"w": 9,
				"name": "邱志偉",
				"ename": "Chiu Chih Wei",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第2選舉區",
				"district": "茄萣區、湖內區、路竹區、永安區、岡山區、彌陀區、梓官區、橋頭區",
				"Email": "hope-chiu@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡江大學俄羅斯研究所法學碩士\n ;國立臺灣大學國家發展研究所法學碩士\n ;國立中山大學大陸研究所社會科學博士",
				"profession": "經濟委員會",
				"experience": "高雄市政府民政局長\n \n 高雄縣政府民政處長\n \n 修憲國民大會代表\n \n 立陶宛維爾紐斯大學講座教授\n \n 愛沙尼亞塔圖大學講座教授\n \n 南華大學旅遊系助理教授\n \n 英國劍橋大學國際關係研究所\n \n 比利時魯汶大學歐洲研究所\n \n 中正大學國際經濟所博士班",
				"allTel": "國會研究室：02-2358-6561;岡山服務處：07-623-0655;茄萣服務處：07-690-1234;彌陀聯絡處：07-623-0655;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999;路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525;梓官服務處：07-610-3338",
				"labTel": "02-2358-6561",
				"serviceTel1": "岡山服務處：07-623-0655",
				"serviceTel2": "茄萣服務處：07-690-1234",
				"serviceTel3": "彌陀聯絡處：07-623-0655",
				"serviceTel4": "路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999",
				"serviceTel5": "路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525",
				"LabFax": "國會研究室：02-2358-6565;岡山服務處：07-623-0671;茄萣服務處：07-690-2598;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-6869;路竹區邱志偉立委與張文瑞議員聯合服務處：07-697-8588;梓官服務處：07-610-3338",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90036.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0607室;岡山服務處：高雄市岡山區華園路99號;茄萣服務處：高雄市茄萣區信義路三段138號;彌陀聯絡處：高雄市彌陀區鹽埕大路75號;路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號;路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0607室",
				"serviceAdd1": "岡山服務處：高雄市岡山區華園路99號",
				"serviceAdd2": "茄萣服務處：高雄市茄萣區信義路三段138號",
				"serviceAdd3": "彌陀聯絡處：高雄市彌陀區鹽埕大路75號",
				"serviceAdd4": "路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號",
				"serviceAdd5": "路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"facebook": "https://www.facebook.com/%E9%82%B1%E5%BF%97%E5%81%89-1588286501409955/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E5%BF%97%E5%81%89_(%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": ""
			}
		],
		"岡山區": [
			{
				"w": 9,
				"name": "邱志偉",
				"ename": "Chiu Chih Wei",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第2選舉區",
				"district": "茄萣區、湖內區、路竹區、永安區、岡山區、彌陀區、梓官區、橋頭區",
				"Email": "hope-chiu@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡江大學俄羅斯研究所法學碩士\n ;國立臺灣大學國家發展研究所法學碩士\n ;國立中山大學大陸研究所社會科學博士",
				"profession": "經濟委員會",
				"experience": "高雄市政府民政局長\n \n 高雄縣政府民政處長\n \n 修憲國民大會代表\n \n 立陶宛維爾紐斯大學講座教授\n \n 愛沙尼亞塔圖大學講座教授\n \n 南華大學旅遊系助理教授\n \n 英國劍橋大學國際關係研究所\n \n 比利時魯汶大學歐洲研究所\n \n 中正大學國際經濟所博士班",
				"allTel": "國會研究室：02-2358-6561;岡山服務處：07-623-0655;茄萣服務處：07-690-1234;彌陀聯絡處：07-623-0655;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999;路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525;梓官服務處：07-610-3338",
				"labTel": "02-2358-6561",
				"serviceTel1": "岡山服務處：07-623-0655",
				"serviceTel2": "茄萣服務處：07-690-1234",
				"serviceTel3": "彌陀聯絡處：07-623-0655",
				"serviceTel4": "路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999",
				"serviceTel5": "路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525",
				"LabFax": "國會研究室：02-2358-6565;岡山服務處：07-623-0671;茄萣服務處：07-690-2598;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-6869;路竹區邱志偉立委與張文瑞議員聯合服務處：07-697-8588;梓官服務處：07-610-3338",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90036.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0607室;岡山服務處：高雄市岡山區華園路99號;茄萣服務處：高雄市茄萣區信義路三段138號;彌陀聯絡處：高雄市彌陀區鹽埕大路75號;路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號;路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0607室",
				"serviceAdd1": "岡山服務處：高雄市岡山區華園路99號",
				"serviceAdd2": "茄萣服務處：高雄市茄萣區信義路三段138號",
				"serviceAdd3": "彌陀聯絡處：高雄市彌陀區鹽埕大路75號",
				"serviceAdd4": "路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號",
				"serviceAdd5": "路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"facebook": "https://www.facebook.com/%E9%82%B1%E5%BF%97%E5%81%89-1588286501409955/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E5%BF%97%E5%81%89_(%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": ""
			}
		],
		"彌陀區": [
			{
				"w": 9,
				"name": "邱志偉",
				"ename": "Chiu Chih Wei",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第2選舉區",
				"district": "茄萣區、湖內區、路竹區、永安區、岡山區、彌陀區、梓官區、橋頭區",
				"Email": "hope-chiu@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡江大學俄羅斯研究所法學碩士\n ;國立臺灣大學國家發展研究所法學碩士\n ;國立中山大學大陸研究所社會科學博士",
				"profession": "經濟委員會",
				"experience": "高雄市政府民政局長\n \n 高雄縣政府民政處長\n \n 修憲國民大會代表\n \n 立陶宛維爾紐斯大學講座教授\n \n 愛沙尼亞塔圖大學講座教授\n \n 南華大學旅遊系助理教授\n \n 英國劍橋大學國際關係研究所\n \n 比利時魯汶大學歐洲研究所\n \n 中正大學國際經濟所博士班",
				"allTel": "國會研究室：02-2358-6561;岡山服務處：07-623-0655;茄萣服務處：07-690-1234;彌陀聯絡處：07-623-0655;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999;路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525;梓官服務處：07-610-3338",
				"labTel": "02-2358-6561",
				"serviceTel1": "岡山服務處：07-623-0655",
				"serviceTel2": "茄萣服務處：07-690-1234",
				"serviceTel3": "彌陀聯絡處：07-623-0655",
				"serviceTel4": "路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999",
				"serviceTel5": "路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525",
				"LabFax": "國會研究室：02-2358-6565;岡山服務處：07-623-0671;茄萣服務處：07-690-2598;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-6869;路竹區邱志偉立委與張文瑞議員聯合服務處：07-697-8588;梓官服務處：07-610-3338",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90036.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0607室;岡山服務處：高雄市岡山區華園路99號;茄萣服務處：高雄市茄萣區信義路三段138號;彌陀聯絡處：高雄市彌陀區鹽埕大路75號;路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號;路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0607室",
				"serviceAdd1": "岡山服務處：高雄市岡山區華園路99號",
				"serviceAdd2": "茄萣服務處：高雄市茄萣區信義路三段138號",
				"serviceAdd3": "彌陀聯絡處：高雄市彌陀區鹽埕大路75號",
				"serviceAdd4": "路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號",
				"serviceAdd5": "路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"facebook": "https://www.facebook.com/%E9%82%B1%E5%BF%97%E5%81%89-1588286501409955/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E5%BF%97%E5%81%89_(%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": ""
			}
		],
		"梓官區": [
			{
				"w": 9,
				"name": "邱志偉",
				"ename": "Chiu Chih Wei",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第2選舉區",
				"district": "茄萣區、湖內區、路竹區、永安區、岡山區、彌陀區、梓官區、橋頭區",
				"Email": "hope-chiu@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡江大學俄羅斯研究所法學碩士\n ;國立臺灣大學國家發展研究所法學碩士\n ;國立中山大學大陸研究所社會科學博士",
				"profession": "經濟委員會",
				"experience": "高雄市政府民政局長\n \n 高雄縣政府民政處長\n \n 修憲國民大會代表\n \n 立陶宛維爾紐斯大學講座教授\n \n 愛沙尼亞塔圖大學講座教授\n \n 南華大學旅遊系助理教授\n \n 英國劍橋大學國際關係研究所\n \n 比利時魯汶大學歐洲研究所\n \n 中正大學國際經濟所博士班",
				"allTel": "國會研究室：02-2358-6561;岡山服務處：07-623-0655;茄萣服務處：07-690-1234;彌陀聯絡處：07-623-0655;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999;路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525;梓官服務處：07-610-3338",
				"labTel": "02-2358-6561",
				"serviceTel1": "岡山服務處：07-623-0655",
				"serviceTel2": "茄萣服務處：07-690-1234",
				"serviceTel3": "彌陀聯絡處：07-623-0655",
				"serviceTel4": "路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999",
				"serviceTel5": "路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525",
				"LabFax": "國會研究室：02-2358-6565;岡山服務處：07-623-0671;茄萣服務處：07-690-2598;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-6869;路竹區邱志偉立委與張文瑞議員聯合服務處：07-697-8588;梓官服務處：07-610-3338",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90036.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0607室;岡山服務處：高雄市岡山區華園路99號;茄萣服務處：高雄市茄萣區信義路三段138號;彌陀聯絡處：高雄市彌陀區鹽埕大路75號;路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號;路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0607室",
				"serviceAdd1": "岡山服務處：高雄市岡山區華園路99號",
				"serviceAdd2": "茄萣服務處：高雄市茄萣區信義路三段138號",
				"serviceAdd3": "彌陀聯絡處：高雄市彌陀區鹽埕大路75號",
				"serviceAdd4": "路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號",
				"serviceAdd5": "路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"facebook": "https://www.facebook.com/%E9%82%B1%E5%BF%97%E5%81%89-1588286501409955/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E5%BF%97%E5%81%89_(%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": ""
			}
		],
		"橋頭區": [
			{
				"w": 9,
				"name": "邱志偉",
				"ename": "Chiu Chih Wei",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第2選舉區",
				"district": "茄萣區、湖內區、路竹區、永安區、岡山區、彌陀區、梓官區、橋頭區",
				"Email": "hope-chiu@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡江大學俄羅斯研究所法學碩士\n ;國立臺灣大學國家發展研究所法學碩士\n ;國立中山大學大陸研究所社會科學博士",
				"profession": "經濟委員會",
				"experience": "高雄市政府民政局長\n \n 高雄縣政府民政處長\n \n 修憲國民大會代表\n \n 立陶宛維爾紐斯大學講座教授\n \n 愛沙尼亞塔圖大學講座教授\n \n 南華大學旅遊系助理教授\n \n 英國劍橋大學國際關係研究所\n \n 比利時魯汶大學歐洲研究所\n \n 中正大學國際經濟所博士班",
				"allTel": "國會研究室：02-2358-6561;岡山服務處：07-623-0655;茄萣服務處：07-690-1234;彌陀聯絡處：07-623-0655;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999;路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525;梓官服務處：07-610-3338",
				"labTel": "02-2358-6561",
				"serviceTel1": "岡山服務處：07-623-0655",
				"serviceTel2": "茄萣服務處：07-690-1234",
				"serviceTel3": "彌陀聯絡處：07-623-0655",
				"serviceTel4": "路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-1999",
				"serviceTel5": "路竹區邱志偉立委與張文瑞議員聯合服務處：07-696-0525",
				"LabFax": "國會研究室：02-2358-6565;岡山服務處：07-623-0671;茄萣服務處：07-690-2598;路竹區邱志偉立委與陳明澤議員聯合服務處：07-607-6869;路竹區邱志偉立委與張文瑞議員聯合服務處：07-697-8588;梓官服務處：07-610-3338",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90036.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0607室;岡山服務處：高雄市岡山區華園路99號;茄萣服務處：高雄市茄萣區信義路三段138號;彌陀聯絡處：高雄市彌陀區鹽埕大路75號;路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號;路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0607室",
				"serviceAdd1": "岡山服務處：高雄市岡山區華園路99號",
				"serviceAdd2": "茄萣服務處：高雄市茄萣區信義路三段138號",
				"serviceAdd3": "彌陀聯絡處：高雄市彌陀區鹽埕大路75號",
				"serviceAdd4": "路竹區邱志偉立委與陳明澤議員聯合服務處：高雄市路竹區國昌路73號",
				"serviceAdd5": "路竹區邱志偉立委與張文瑞議員聯合服務處：高雄市路竹區國昌路82號",
				"facebook": "https://www.facebook.com/%E9%82%B1%E5%BF%97%E5%81%89-1588286501409955/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E5%BF%97%E5%81%89_(%E6%94%BF%E6%B2%BB%E4%BA%BA%E7%89%A9)",
				"LineID": ""
			}
		],
		"桃源區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"那瑪夏區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"甲仙區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"六龜區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"杉林區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"內門區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"旗山區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"美濃區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"茂林區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"阿蓮區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"田寮區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"燕巢區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"大社區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"大樹區": [
			{
				"w": 9,
				"name": "邱議瑩",
				"ename": "Chiu Yi Ying",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第1選舉區",
				"district": "桃源區、那瑪夏區、甲仙區、六龜區、杉林區、內門區、旗山區、美濃區、茂林區、阿蓮區、田寮區、燕巢區、大社區、大樹區",
				"Email": "ly5c298@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "高雄市道明高中\n ;美國舊金山多明尼肯大學企管研究所碩士",
				"profession": "經濟委員會",
				"experience": "第3屆國民大會代表\n \n 第8、9屆民進黨中央常務委員\n \n 行政院客家委員會副主委\n \n 第5、7、8屆立法委員",
				"allTel": "國會研究室：02-2358-6516;美濃服務處：07-681-8755",
				"labTel": "02-2358-6516",
				"serviceTel1": "美濃服務處：07-681-8755",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6520;美濃服務處：07-681-8677",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90037.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0801室;美濃服務處：843高雄市美濃區泰安路228號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0801室",
				"serviceAdd1": "美濃服務處：843高雄市美濃區泰安路228號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E7%99%BB%E7%9C%9F-%E9%82%B1%E8%AD%B0%E7%91%A9-179828222070223/?fref=ts\nhttps://www.facebook.com/登真-邱議瑩-179828222070223",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%82%B1%E8%AD%B0%E7%91%A9",
				"LineID": "@bui8004r"
			}
		],
		"仁武區": [
			{
				"w": 9,
				"name": "林岱樺",
				"ename": "Lin Tai Hua",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第4選舉區",
				"district": "仁武區、鳥松區、大寮區、林園區",
				"Email": "LindaiHua@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "天主教輔仁大學德文系畢業;美國威斯康辛大學大眾傳播碩士",
				"profession": "經濟委員會",
				"experience": "德國卡賽爾綜合大學德語教學研究結業\n 第5、6、7、8屆立法委員\n 行政院青輔會主委\n 2009年民進黨提名參選高雄縣長；因縣市合併停選\n 立法院經濟委員會召集委員\n 民進黨（第8、9屆）全國黨代表\n 民進黨第10、11屆中央執行委員\n 民進黨第14屆中央評議委員",
				"allTel": "國會研究室：02-2358-8021;大竂服務處：07-781-8117",
				"labTel": "02-2358-8021",
				"serviceTel1": "大竂服務處：07-781-8117",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8030;大竂服務處：07-781-8167",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90028.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0706室;大竂服務處：高雄市大竂區力行路61號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0706室",
				"serviceAdd1": "大竂服務處：高雄市大竂區力行路61號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/LinDaiHua/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E5%B2%B1%E6%A8%BA",
				"LineID": "@tti3709p"
			}
		],
		"鳥松區": [
			{
				"w": 9,
				"name": "林岱樺",
				"ename": "Lin Tai Hua",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第4選舉區",
				"district": "仁武區、鳥松區、大寮區、林園區",
				"Email": "LindaiHua@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "天主教輔仁大學德文系畢業;美國威斯康辛大學大眾傳播碩士",
				"profession": "經濟委員會",
				"experience": "德國卡賽爾綜合大學德語教學研究結業\n 第5、6、7、8屆立法委員\n 行政院青輔會主委\n 2009年民進黨提名參選高雄縣長；因縣市合併停選\n 立法院經濟委員會召集委員\n 民進黨（第8、9屆）全國黨代表\n 民進黨第10、11屆中央執行委員\n 民進黨第14屆中央評議委員",
				"allTel": "國會研究室：02-2358-8021;大竂服務處：07-781-8117",
				"labTel": "02-2358-8021",
				"serviceTel1": "大竂服務處：07-781-8117",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8030;大竂服務處：07-781-8167",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90028.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0706室;大竂服務處：高雄市大竂區力行路61號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0706室",
				"serviceAdd1": "大竂服務處：高雄市大竂區力行路61號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/LinDaiHua/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E5%B2%B1%E6%A8%BA",
				"LineID": "@tti3709p"
			}
		],
		"大寮區": [
			{
				"w": 9,
				"name": "林岱樺",
				"ename": "Lin Tai Hua",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第4選舉區",
				"district": "仁武區、鳥松區、大寮區、林園區",
				"Email": "LindaiHua@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "天主教輔仁大學德文系畢業;美國威斯康辛大學大眾傳播碩士",
				"profession": "經濟委員會",
				"experience": "德國卡賽爾綜合大學德語教學研究結業\n 第5、6、7、8屆立法委員\n 行政院青輔會主委\n 2009年民進黨提名參選高雄縣長；因縣市合併停選\n 立法院經濟委員會召集委員\n 民進黨（第8、9屆）全國黨代表\n 民進黨第10、11屆中央執行委員\n 民進黨第14屆中央評議委員",
				"allTel": "國會研究室：02-2358-8021;大竂服務處：07-781-8117",
				"labTel": "02-2358-8021",
				"serviceTel1": "大竂服務處：07-781-8117",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8030;大竂服務處：07-781-8167",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90028.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0706室;大竂服務處：高雄市大竂區力行路61號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0706室",
				"serviceAdd1": "大竂服務處：高雄市大竂區力行路61號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/LinDaiHua/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E5%B2%B1%E6%A8%BA",
				"LineID": "@tti3709p"
			}
		],
		"林園區": [
			{
				"w": 9,
				"name": "林岱樺",
				"ename": "Lin Tai Hua",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第4選舉區",
				"district": "仁武區、鳥松區、大寮區、林園區",
				"Email": "LindaiHua@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "天主教輔仁大學德文系畢業;美國威斯康辛大學大眾傳播碩士",
				"profession": "經濟委員會",
				"experience": "德國卡賽爾綜合大學德語教學研究結業\n 第5、6、7、8屆立法委員\n 行政院青輔會主委\n 2009年民進黨提名參選高雄縣長；因縣市合併停選\n 立法院經濟委員會召集委員\n 民進黨（第8、9屆）全國黨代表\n 民進黨第10、11屆中央執行委員\n 民進黨第14屆中央評議委員",
				"allTel": "國會研究室：02-2358-8021;大竂服務處：07-781-8117",
				"labTel": "02-2358-8021",
				"serviceTel1": "大竂服務處：07-781-8117",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8030;大竂服務處：07-781-8167",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90028.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0706室;大竂服務處：高雄市大竂區力行路61號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0706室",
				"serviceAdd1": "大竂服務處：高雄市大竂區力行路61號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/LinDaiHua/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E5%B2%B1%E6%A8%BA",
				"LineID": "@tti3709p"
			}
		],
		"鳳山區": [
			{
				"w": 9,
				"name": "許智傑",
				"ename": "Hsu Chih Chieh",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第8選舉區",
				"district": "鳳山區",
				"Email": "skygod0303@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "國立高師大教育學系碩士;台大機械工程系;高雄中學;五甲國中;五甲國小",
				"profession": "教育及文化委員會",
				"experience": "第8屆立法委員\n 第1任鳳山區區長\n 鳳山市市長\n 高雄縣議員\n 鳳山市市民代表\n 正修科技大學助理教授\n 和春技術學院講師\n 高旗工家主任\n 鳳山市民大學主任\n 國家中山科學研究院工程師\n 國立高師大教育研究所博士班",
				"allTel": "國會研究室：02-2358-8151;鳳山服務處：07-768-2666;07-768-1899",
				"labTel": "02-2358-8151",
				"serviceTel1": "鳳山服務處：07-768-2666",
				"serviceTel2": "07-768-1899",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6625;鳳山服務處：07-768-9900",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90057.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0703室;鳳山服務處：830高雄市鳳山區保泰路96號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0703室",
				"serviceAdd1": "鳳山服務處：830高雄市鳳山區保泰路96號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/ifongshan/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%A8%B1%E6%99%BA%E5%82%91",
				"LineID": "@bqj6274m"
			}
		],
		"鼓山區": [
			{
				"w": 9,
				"name": "管碧玲",
				"ename": "Kuan Bi Ling",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第5選舉區",
				"district": "鼓山區、鹽埕區、旗津區、三民區",
				"Email": "ly11059a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學政治學博士",
				"profession": "經濟委員會",
				"experience": "哈佛大學甘迺迪政府學院國家與國際安全高階行政專班結業\n \n 國立台北大學公共行政暨政策學系副教授\n \n 台灣教授協會秘書長\n \n 高雄市新聞處處長、文化局局長\n \n 第6、7、8屆立法委員\n \n 立法院教育文化委員會、交通委員會召集委員\n \n 立法院民進黨黨團幹事長\n \n 民進黨中央黨部政策中心主任\n \n 民進黨中央常務委員、中央執行委員",
				"allTel": "國會研究室：02-2358-8146;高雄服務處：07-313-7816;內惟服務處：07-533-0227;07-521-5237",
				"labTel": "02-2358-8146",
				"serviceTel1": "高雄服務處：07-313-7816",
				"serviceTel2": "內惟服務處：07-533-0227",
				"serviceTel3": "07-521-5237",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8150;高雄服務處：07-313-5797",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90083.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0901室;高雄服務處：高雄市三民區博愛一路183號;內惟服務處：高雄市鼓山區九如四路1097號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0901室",
				"serviceAdd1": "高雄服務處：高雄市三民區博愛一路183號",
				"serviceAdd2": "內惟服務處：高雄市鼓山區九如四路1097號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/biling.kuan/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%AE%A1%E7%A2%A7%E7%8E%B2",
				"LineID": "@shf4833c\n@kuanmom"
			}
		],
		"鹽埕區": [
			{
				"w": 9,
				"name": "管碧玲",
				"ename": "Kuan Bi Ling",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第5選舉區",
				"district": "鼓山區、鹽埕區、旗津區、三民區",
				"Email": "ly11059a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學政治學博士",
				"profession": "經濟委員會",
				"experience": "哈佛大學甘迺迪政府學院國家與國際安全高階行政專班結業\n \n 國立台北大學公共行政暨政策學系副教授\n \n 台灣教授協會秘書長\n \n 高雄市新聞處處長、文化局局長\n \n 第6、7、8屆立法委員\n \n 立法院教育文化委員會、交通委員會召集委員\n \n 立法院民進黨黨團幹事長\n \n 民進黨中央黨部政策中心主任\n \n 民進黨中央常務委員、中央執行委員",
				"allTel": "國會研究室：02-2358-8146;高雄服務處：07-313-7816;內惟服務處：07-533-0227;07-521-5237",
				"labTel": "02-2358-8146",
				"serviceTel1": "高雄服務處：07-313-7816",
				"serviceTel2": "內惟服務處：07-533-0227",
				"serviceTel3": "07-521-5237",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8150;高雄服務處：07-313-5797",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90083.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0901室;高雄服務處：高雄市三民區博愛一路183號;內惟服務處：高雄市鼓山區九如四路1097號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0901室",
				"serviceAdd1": "高雄服務處：高雄市三民區博愛一路183號",
				"serviceAdd2": "內惟服務處：高雄市鼓山區九如四路1097號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/biling.kuan/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%AE%A1%E7%A2%A7%E7%8E%B2",
				"LineID": "@shf4833c\n@kuanmom"
			}
		],
		"旗津區": [
			{
				"w": 9,
				"name": "管碧玲",
				"ename": "Kuan Bi Ling",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第5選舉區",
				"district": "鼓山區、鹽埕區、旗津區、三民區",
				"Email": "ly11059a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學政治學博士",
				"profession": "經濟委員會",
				"experience": "哈佛大學甘迺迪政府學院國家與國際安全高階行政專班結業\n \n 國立台北大學公共行政暨政策學系副教授\n \n 台灣教授協會秘書長\n \n 高雄市新聞處處長、文化局局長\n \n 第6、7、8屆立法委員\n \n 立法院教育文化委員會、交通委員會召集委員\n \n 立法院民進黨黨團幹事長\n \n 民進黨中央黨部政策中心主任\n \n 民進黨中央常務委員、中央執行委員",
				"allTel": "國會研究室：02-2358-8146;高雄服務處：07-313-7816;內惟服務處：07-533-0227;07-521-5237",
				"labTel": "02-2358-8146",
				"serviceTel1": "高雄服務處：07-313-7816",
				"serviceTel2": "內惟服務處：07-533-0227",
				"serviceTel3": "07-521-5237",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8150;高雄服務處：07-313-5797",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90083.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0901室;高雄服務處：高雄市三民區博愛一路183號;內惟服務處：高雄市鼓山區九如四路1097號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0901室",
				"serviceAdd1": "高雄服務處：高雄市三民區博愛一路183號",
				"serviceAdd2": "內惟服務處：高雄市鼓山區九如四路1097號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/biling.kuan/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E7%AE%A1%E7%A2%A7%E7%8E%B2",
				"LineID": "@shf4833c\n@kuanmom"
			}
		],
		"前金區": [
			{
				"w": 9,
				"name": "趙天麟",
				"ename": "Chao Tien Lin",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第7選舉區",
				"district": "前金區、新興區、苓雅區、前鎮區",
				"Email": "skychao6238@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立中山大學公共政策碩士",
				"profession": "內政委員會",
				"experience": "國立高雄應用科技大學機械與精密工程博士班（工管組）\n \n 第8屆立法委員\n \n 第6、7屆高雄市議員\n \n 美國國務院IVLP訪問學人\n \n 日本慶應大學訪問研究員\n \n 民主進步黨中國事務部、文宣部、青年部主任\n \n 陳菊競選總部總幹事及發言人\n \n 世展望及家扶中心長期資助人\n \n 高雄世新大學、真理大學校友會理事長\n \n 前金長老教會執事",
				"allTel": "國會研究室：02-2358-6576;高雄服務處：07-333-6868",
				"labTel": "02-2358-6576",
				"serviceTel1": "高雄服務處：07-333-6868",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6580;高雄服務處：07-333-6860",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90084.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1103室;高雄服務處：80251高雄市苓雅區民權一路53號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1103室",
				"serviceAdd1": "高雄服務處：80251高雄市苓雅區民權一路53號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/skychao6238/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B6%99%E5%A4%A9%E9%BA%9F_(%E8%87%BA%E7%81%A3)",
				"LineID": "@SSY9462J\n@skychao"
			}
		],
		"新興區": [
			{
				"w": 9,
				"name": "趙天麟",
				"ename": "Chao Tien Lin",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第7選舉區",
				"district": "前金區、新興區、苓雅區、前鎮區",
				"Email": "skychao6238@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立中山大學公共政策碩士",
				"profession": "內政委員會",
				"experience": "國立高雄應用科技大學機械與精密工程博士班（工管組）\n \n 第8屆立法委員\n \n 第6、7屆高雄市議員\n \n 美國國務院IVLP訪問學人\n \n 日本慶應大學訪問研究員\n \n 民主進步黨中國事務部、文宣部、青年部主任\n \n 陳菊競選總部總幹事及發言人\n \n 世展望及家扶中心長期資助人\n \n 高雄世新大學、真理大學校友會理事長\n \n 前金長老教會執事",
				"allTel": "國會研究室：02-2358-6576;高雄服務處：07-333-6868",
				"labTel": "02-2358-6576",
				"serviceTel1": "高雄服務處：07-333-6868",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6580;高雄服務處：07-333-6860",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90084.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1103室;高雄服務處：80251高雄市苓雅區民權一路53號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1103室",
				"serviceAdd1": "高雄服務處：80251高雄市苓雅區民權一路53號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/skychao6238/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B6%99%E5%A4%A9%E9%BA%9F_(%E8%87%BA%E7%81%A3)",
				"LineID": "@SSY9462J\n@skychao"
			}
		],
		"苓雅區": [
			{
				"w": 9,
				"name": "趙天麟",
				"ename": "Chao Tien Lin",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第7選舉區",
				"district": "前金區、新興區、苓雅區、前鎮區",
				"Email": "skychao6238@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立中山大學公共政策碩士",
				"profession": "內政委員會",
				"experience": "國立高雄應用科技大學機械與精密工程博士班（工管組）\n \n 第8屆立法委員\n \n 第6、7屆高雄市議員\n \n 美國國務院IVLP訪問學人\n \n 日本慶應大學訪問研究員\n \n 民主進步黨中國事務部、文宣部、青年部主任\n \n 陳菊競選總部總幹事及發言人\n \n 世展望及家扶中心長期資助人\n \n 高雄世新大學、真理大學校友會理事長\n \n 前金長老教會執事",
				"allTel": "國會研究室：02-2358-6576;高雄服務處：07-333-6868",
				"labTel": "02-2358-6576",
				"serviceTel1": "高雄服務處：07-333-6868",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6580;高雄服務處：07-333-6860",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90084.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1103室;高雄服務處：80251高雄市苓雅區民權一路53號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1103室",
				"serviceAdd1": "高雄服務處：80251高雄市苓雅區民權一路53號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/skychao6238/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B6%99%E5%A4%A9%E9%BA%9F_(%E8%87%BA%E7%81%A3)",
				"LineID": "@SSY9462J\n@skychao"
			}
		],
		"前鎮區": [
			{
				"w": 9,
				"name": "趙天麟",
				"ename": "Chao Tien Lin",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第7選舉區",
				"district": "前金區、新興區、苓雅區、前鎮區",
				"Email": "skychao6238@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立中山大學公共政策碩士",
				"profession": "內政委員會",
				"experience": "國立高雄應用科技大學機械與精密工程博士班（工管組）\n \n 第8屆立法委員\n \n 第6、7屆高雄市議員\n \n 美國國務院IVLP訪問學人\n \n 日本慶應大學訪問研究員\n \n 民主進步黨中國事務部、文宣部、青年部主任\n \n 陳菊競選總部總幹事及發言人\n \n 世展望及家扶中心長期資助人\n \n 高雄世新大學、真理大學校友會理事長\n \n 前金長老教會執事",
				"allTel": "國會研究室：02-2358-6576;高雄服務處：07-333-6868",
				"labTel": "02-2358-6576",
				"serviceTel1": "高雄服務處：07-333-6868",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6580;高雄服務處：07-333-6860",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90084.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1103室;高雄服務處：80251高雄市苓雅區民權一路53號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1103室",
				"serviceAdd1": "高雄服務處：80251高雄市苓雅區民權一路53號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/skychao6238/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B6%99%E5%A4%A9%E9%BA%9F_(%E8%87%BA%E7%81%A3)",
				"LineID": "@SSY9462J\n@skychao"
			},
			{
				"w": 9,
				"name": "賴瑞隆",
				"ename": "Lai Jui Lung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第9選舉區",
				"district": "小港區、前鎮區",
				"Email": "zenolai2@yahoo.com.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學國家發展研究所碩士",
				"profession": "內政委員會",
				"experience": "黃色小鴨策展人\n \n 五月天代言推手\n \n 2009年高雄世運會執行秘書\n \n 高雄市政府海洋局局長\n \n 高雄市政府新聞局局長\n \n 高雄市政府觀光局主任秘書\n \n 高雄市政府建設局專門委員\n \n 行政院勞委會專員\n \n 行政院新聞局簡任秘書\n \n 十年立法院國會助理",
				"allTel": "國會研究室：02-2358-6888;小港服務處：07-806-1685;前鎮服務處：07-751-0005",
				"labTel": "02-2358-6888",
				"serviceTel1": "小港服務處：07-806-1685",
				"serviceTel2": "前鎮服務處：07-751-0005",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6280;小港服務處：07-806-0737;前鎮服務處：07-721-3391",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90102.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2108室;小港服務處：高雄市小港區宏平路577號;前鎮服務處：高雄市前鎮區永豐路106號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2108室",
				"serviceAdd1": "小港服務處：高雄市小港區宏平路577號",
				"serviceAdd2": "前鎮服務處：高雄市前鎮區永豐路106號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%B3%B4%E7%91%9E%E9%9A%86-774908905922784/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B3%B4%E7%91%9E%E9%9A%86",
				"LineID": "@myt7120g"
			}
		],
		"楠梓區": [
			{
				"w": 9,
				"name": "劉世芳",
				"ename": "Liu Shih Fang",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第3選舉區",
				"district": "楠梓區、左營區",
				"Email": "shfaliu@yahoo.com.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國奧克拉荷馬州州立大學環境工程碩士\n ;淡江大學化學工程系學士",
				"profession": "",
				"experience": "高雄市副市長\n \n 2009高雄世運組委會常務董事\n \n 國家安全會議副秘書長\n \n 總統府副秘書長\n \n 行政院秘書長\n \n 立法院(第5屆)委員\n \n 台中縣副縣長\n \n 臺北市環保局長\n \n 澎湖縣政府機要秘書",
				"allTel": "國會研究室：02-2358-6066;高雄服務處：07-343-9960",
				"labTel": "02-2358-6066",
				"serviceTel1": "高雄服務處：07-343-9960",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6070;高雄服務處：07-343-9961",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90086.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0208室;高雄服務處：高雄市左營區新社仔路85號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0208室",
				"serviceAdd1": "高雄服務處：高雄市左營區新社仔路85號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/2016newpower/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E4%B8%96%E8%8A%B3",
				"LineID": "@abc8900g"
			}
		],
		"左營區": [
			{
				"w": 9,
				"name": "劉世芳",
				"ename": "Liu Shih Fang",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第3選舉區",
				"district": "楠梓區、左營區",
				"Email": "shfaliu@yahoo.com.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國奧克拉荷馬州州立大學環境工程碩士\n ;淡江大學化學工程系學士",
				"profession": "",
				"experience": "高雄市副市長\n \n 2009高雄世運組委會常務董事\n \n 國家安全會議副秘書長\n \n 總統府副秘書長\n \n 行政院秘書長\n \n 立法院(第5屆)委員\n \n 台中縣副縣長\n \n 臺北市環保局長\n \n 澎湖縣政府機要秘書",
				"allTel": "國會研究室：02-2358-6066;高雄服務處：07-343-9960",
				"labTel": "02-2358-6066",
				"serviceTel1": "高雄服務處：07-343-9960",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6070;高雄服務處：07-343-9961",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90086.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0208室;高雄服務處：高雄市左營區新社仔路85號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0208室",
				"serviceAdd1": "高雄服務處：高雄市左營區新社仔路85號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/2016newpower/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E4%B8%96%E8%8A%B3",
				"LineID": "@abc8900g"
			}
		],
		"小港區": [
			{
				"w": 9,
				"name": "賴瑞隆",
				"ename": "Lai Jui Lung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "高雄市第9選舉區",
				"district": "小港區、前鎮區",
				"Email": "zenolai2@yahoo.com.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺灣大學國家發展研究所碩士",
				"profession": "內政委員會",
				"experience": "黃色小鴨策展人\n \n 五月天代言推手\n \n 2009年高雄世運會執行秘書\n \n 高雄市政府海洋局局長\n \n 高雄市政府新聞局局長\n \n 高雄市政府觀光局主任秘書\n \n 高雄市政府建設局專門委員\n \n 行政院勞委會專員\n \n 行政院新聞局簡任秘書\n \n 十年立法院國會助理",
				"allTel": "國會研究室：02-2358-6888;小港服務處：07-806-1685;前鎮服務處：07-751-0005",
				"labTel": "02-2358-6888",
				"serviceTel1": "小港服務處：07-806-1685",
				"serviceTel2": "前鎮服務處：07-751-0005",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6280;小港服務處：07-806-0737;前鎮服務處：07-721-3391",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90102.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2108室;小港服務處：高雄市小港區宏平路577號;前鎮服務處：高雄市前鎮區永豐路106號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2108室",
				"serviceAdd1": "小港服務處：高雄市小港區宏平路577號",
				"serviceAdd2": "前鎮服務處：高雄市前鎮區永豐路106號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%B3%B4%E7%91%9E%E9%9A%86-774908905922784/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%B3%B4%E7%91%9E%E9%9A%86",
				"LineID": "@myt7120g"
			}
		]
	},
	"嘉義市": {
		"": [
			{
				"w": 9,
				"name": "李俊俋",
				"ename": "Lee Chun Yi",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義市選舉區",
				"district": "",
				"Email": "choujude@yahoo.com.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國波士頓學院政治研究所碩士\n ;文化大學政治系學士\n ;嘉義市民族國小",
				"profession": "內政委員會",
				"experience": "總統府國策顧問兼憲改辦公室主任\n \n 考試院銓敘部政務次長\n \n 嘉義市副市長",
				"allTel": "國會研究室：02-2358-6541;嘉義服務處：05-271-9595",
				"labTel": "02-2358-6541",
				"serviceTel1": "嘉義服務處：05-271-9595",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6545;嘉義服務處：05-277-9775",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90021.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1001室;嘉義服務處：600嘉義市西區博愛路二段166號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1001室",
				"serviceAdd1": "嘉義服務處：600嘉義市西區博愛路二段166號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chunyileefans/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9D%8E%E4%BF%8A%E4%BF%8B",
				"LineID": "@LWW4351H"
			}
		]
	},
	"新竹縣": {
		"": [
			{
				"w": 9,
				"name": "林為洲",
				"ename": "Lin Wei Chou",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "新竹縣選舉區",
				"district": "",
				"Email": "(7/20 楊主任iveson29@gmail.com)電話聯繫國會研究室不提供 7/13",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立中央大學中文系畢業",
				"profession": "",
				"experience": "第6屆立法委員\n \n 第14、15、18屆新竹縣議員\n \n 第17屆新竹縣議會副議長\n \n 中國國民黨新竹縣黨部主任委員",
				"allTel": "國會研究室：02-2358-6911;新竹縣服務處：03-657-3081",
				"labTel": "02-2358-6911",
				"serviceTel1": "新竹縣服務處：03-657-3081",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6915;新竹縣服務處：03-6573082",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90031.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0202室;新竹縣服務處：新竹縣竹北市縣政二路101號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0202室",
				"serviceAdd1": "新竹縣服務處：新竹縣竹北市縣政二路101號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/weijoteam/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9E%97%E7%82%BA%E6%B4%B2",
				"LineID": ""
			}
		]
	},
	"新竹市": {
		"": [
			{
				"w": 9,
				"name": "柯建銘",
				"ename": "Ker Chien Ming",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "新竹市選舉區",
				"district": "",
				"Email": "ker@ly.gov.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "新竹國小\n ;新竹一中(建華國中)\n ;新竹中學\n ;中山醫學大學牙醫科",
				"profession": "",
				"experience": "民進黨第2、3、4、5、6、7、8屆立法委員\n \n 立法院民進黨黨團第5、6、7、8屆總召集人\n \n 民進黨中常委、財委會主任委員\n \n 民進黨政策會執行長\n \n 總統府九人決策小組成員\n \n 民進黨代理主席(2004.12~2005.01；2011.3~2011.5)",
				"allTel": "國會研究室：02-2358-6106;新竹服務處：03-526-9880",
				"labTel": "02-2358-6106",
				"serviceTel1": "新竹服務處：03-526-9880",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6110;新竹服務處：03-523-2902",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90040.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2118室;新竹服務處：新竹市四維路15號3樓",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2118室",
				"serviceAdd1": "新竹服務處：新竹市四維路15號3樓",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/kerchenming/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%9F%AF%E5%BB%BA%E9%8A%98",
				"LineID": "@kertw"
			}
		]
	},
	"苗栗縣": {
		"頭份鎮": [
			{
				"w": 9,
				"name": "徐志榮",
				"ename": "Hsu Chih Jung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第2選舉區",
				"district": "頭份鎮、三灣鄉、南庄鄉、苗栗市、頭屋鄉、獅潭鄉、公館鄉、大湖鄉、泰安鄉、卓蘭鎮",
				"Email": "ly11154a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立苗栗高中畢業 \n ;日本國立石川高等職業學校畢業",
				"profession": "外交及國防委員會",
				"experience": "第8屆立法委員 \n \n 行政院政務顧問 \n \n 苗栗縣公館鄉第13、14屆鄉長 \n \n 苗栗縣體育會理事長 \n \n 苗栗縣徐氏宗親會副理事長 \n \n 苗栗縣義消總隊總隊長 \n \n 苗栗縣後備指揮部顧問",
				"allTel": "國會研究室：02-2358-6266;公館服務處：037-223-566;苗栗服務處：037-368-811;頭份服務處：037-686-688",
				"labTel": "02-2358-6266",
				"serviceTel1": "公館服務處：037-223-566",
				"serviceTel2": "苗栗服務處：037-368-811",
				"serviceTel3": "頭份服務處：037-686-688",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6270;公館服務處：037-239-233;苗栗服務處：037-368-877;頭份服務處：037-686-611",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90045.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0802室;公館服務處：苗栗縣公館鄉玉泉村367號2樓;苗栗服務處：苗栗縣苗栗市縣府路70號;頭份服務處：苗栗縣頭份鎮中山路292號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0802室",
				"serviceAdd1": "公館服務處：苗栗縣公館鄉玉泉村367號2樓",
				"serviceAdd2": "苗栗服務處：苗栗縣苗栗市縣府路70號",
				"serviceAdd3": "頭份服務處：苗栗縣頭份鎮中山路292號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hsu0731/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%BF%97%E6%A6%AE",
				"LineID": ""
			}
		],
		"三灣鄉": [
			{
				"w": 9,
				"name": "徐志榮",
				"ename": "Hsu Chih Jung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第2選舉區",
				"district": "頭份鎮、三灣鄉、南庄鄉、苗栗市、頭屋鄉、獅潭鄉、公館鄉、大湖鄉、泰安鄉、卓蘭鎮",
				"Email": "ly11154a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立苗栗高中畢業 \n ;日本國立石川高等職業學校畢業",
				"profession": "外交及國防委員會",
				"experience": "第8屆立法委員 \n \n 行政院政務顧問 \n \n 苗栗縣公館鄉第13、14屆鄉長 \n \n 苗栗縣體育會理事長 \n \n 苗栗縣徐氏宗親會副理事長 \n \n 苗栗縣義消總隊總隊長 \n \n 苗栗縣後備指揮部顧問",
				"allTel": "國會研究室：02-2358-6266;公館服務處：037-223-566;苗栗服務處：037-368-811;頭份服務處：037-686-688",
				"labTel": "02-2358-6266",
				"serviceTel1": "公館服務處：037-223-566",
				"serviceTel2": "苗栗服務處：037-368-811",
				"serviceTel3": "頭份服務處：037-686-688",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6270;公館服務處：037-239-233;苗栗服務處：037-368-877;頭份服務處：037-686-611",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90045.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0802室;公館服務處：苗栗縣公館鄉玉泉村367號2樓;苗栗服務處：苗栗縣苗栗市縣府路70號;頭份服務處：苗栗縣頭份鎮中山路292號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0802室",
				"serviceAdd1": "公館服務處：苗栗縣公館鄉玉泉村367號2樓",
				"serviceAdd2": "苗栗服務處：苗栗縣苗栗市縣府路70號",
				"serviceAdd3": "頭份服務處：苗栗縣頭份鎮中山路292號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hsu0731/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%BF%97%E6%A6%AE",
				"LineID": ""
			}
		],
		"南庄鄉": [
			{
				"w": 9,
				"name": "徐志榮",
				"ename": "Hsu Chih Jung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第2選舉區",
				"district": "頭份鎮、三灣鄉、南庄鄉、苗栗市、頭屋鄉、獅潭鄉、公館鄉、大湖鄉、泰安鄉、卓蘭鎮",
				"Email": "ly11154a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立苗栗高中畢業 \n ;日本國立石川高等職業學校畢業",
				"profession": "外交及國防委員會",
				"experience": "第8屆立法委員 \n \n 行政院政務顧問 \n \n 苗栗縣公館鄉第13、14屆鄉長 \n \n 苗栗縣體育會理事長 \n \n 苗栗縣徐氏宗親會副理事長 \n \n 苗栗縣義消總隊總隊長 \n \n 苗栗縣後備指揮部顧問",
				"allTel": "國會研究室：02-2358-6266;公館服務處：037-223-566;苗栗服務處：037-368-811;頭份服務處：037-686-688",
				"labTel": "02-2358-6266",
				"serviceTel1": "公館服務處：037-223-566",
				"serviceTel2": "苗栗服務處：037-368-811",
				"serviceTel3": "頭份服務處：037-686-688",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6270;公館服務處：037-239-233;苗栗服務處：037-368-877;頭份服務處：037-686-611",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90045.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0802室;公館服務處：苗栗縣公館鄉玉泉村367號2樓;苗栗服務處：苗栗縣苗栗市縣府路70號;頭份服務處：苗栗縣頭份鎮中山路292號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0802室",
				"serviceAdd1": "公館服務處：苗栗縣公館鄉玉泉村367號2樓",
				"serviceAdd2": "苗栗服務處：苗栗縣苗栗市縣府路70號",
				"serviceAdd3": "頭份服務處：苗栗縣頭份鎮中山路292號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hsu0731/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%BF%97%E6%A6%AE",
				"LineID": ""
			}
		],
		"苗栗市": [
			{
				"w": 9,
				"name": "徐志榮",
				"ename": "Hsu Chih Jung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第2選舉區",
				"district": "頭份鎮、三灣鄉、南庄鄉、苗栗市、頭屋鄉、獅潭鄉、公館鄉、大湖鄉、泰安鄉、卓蘭鎮",
				"Email": "ly11154a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立苗栗高中畢業 \n ;日本國立石川高等職業學校畢業",
				"profession": "外交及國防委員會",
				"experience": "第8屆立法委員 \n \n 行政院政務顧問 \n \n 苗栗縣公館鄉第13、14屆鄉長 \n \n 苗栗縣體育會理事長 \n \n 苗栗縣徐氏宗親會副理事長 \n \n 苗栗縣義消總隊總隊長 \n \n 苗栗縣後備指揮部顧問",
				"allTel": "國會研究室：02-2358-6266;公館服務處：037-223-566;苗栗服務處：037-368-811;頭份服務處：037-686-688",
				"labTel": "02-2358-6266",
				"serviceTel1": "公館服務處：037-223-566",
				"serviceTel2": "苗栗服務處：037-368-811",
				"serviceTel3": "頭份服務處：037-686-688",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6270;公館服務處：037-239-233;苗栗服務處：037-368-877;頭份服務處：037-686-611",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90045.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0802室;公館服務處：苗栗縣公館鄉玉泉村367號2樓;苗栗服務處：苗栗縣苗栗市縣府路70號;頭份服務處：苗栗縣頭份鎮中山路292號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0802室",
				"serviceAdd1": "公館服務處：苗栗縣公館鄉玉泉村367號2樓",
				"serviceAdd2": "苗栗服務處：苗栗縣苗栗市縣府路70號",
				"serviceAdd3": "頭份服務處：苗栗縣頭份鎮中山路292號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hsu0731/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%BF%97%E6%A6%AE",
				"LineID": ""
			}
		],
		"頭屋鄉": [
			{
				"w": 9,
				"name": "徐志榮",
				"ename": "Hsu Chih Jung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第2選舉區",
				"district": "頭份鎮、三灣鄉、南庄鄉、苗栗市、頭屋鄉、獅潭鄉、公館鄉、大湖鄉、泰安鄉、卓蘭鎮",
				"Email": "ly11154a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立苗栗高中畢業 \n ;日本國立石川高等職業學校畢業",
				"profession": "外交及國防委員會",
				"experience": "第8屆立法委員 \n \n 行政院政務顧問 \n \n 苗栗縣公館鄉第13、14屆鄉長 \n \n 苗栗縣體育會理事長 \n \n 苗栗縣徐氏宗親會副理事長 \n \n 苗栗縣義消總隊總隊長 \n \n 苗栗縣後備指揮部顧問",
				"allTel": "國會研究室：02-2358-6266;公館服務處：037-223-566;苗栗服務處：037-368-811;頭份服務處：037-686-688",
				"labTel": "02-2358-6266",
				"serviceTel1": "公館服務處：037-223-566",
				"serviceTel2": "苗栗服務處：037-368-811",
				"serviceTel3": "頭份服務處：037-686-688",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6270;公館服務處：037-239-233;苗栗服務處：037-368-877;頭份服務處：037-686-611",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90045.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0802室;公館服務處：苗栗縣公館鄉玉泉村367號2樓;苗栗服務處：苗栗縣苗栗市縣府路70號;頭份服務處：苗栗縣頭份鎮中山路292號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0802室",
				"serviceAdd1": "公館服務處：苗栗縣公館鄉玉泉村367號2樓",
				"serviceAdd2": "苗栗服務處：苗栗縣苗栗市縣府路70號",
				"serviceAdd3": "頭份服務處：苗栗縣頭份鎮中山路292號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hsu0731/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%BF%97%E6%A6%AE",
				"LineID": ""
			}
		],
		"獅潭鄉": [
			{
				"w": 9,
				"name": "徐志榮",
				"ename": "Hsu Chih Jung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第2選舉區",
				"district": "頭份鎮、三灣鄉、南庄鄉、苗栗市、頭屋鄉、獅潭鄉、公館鄉、大湖鄉、泰安鄉、卓蘭鎮",
				"Email": "ly11154a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立苗栗高中畢業 \n ;日本國立石川高等職業學校畢業",
				"profession": "外交及國防委員會",
				"experience": "第8屆立法委員 \n \n 行政院政務顧問 \n \n 苗栗縣公館鄉第13、14屆鄉長 \n \n 苗栗縣體育會理事長 \n \n 苗栗縣徐氏宗親會副理事長 \n \n 苗栗縣義消總隊總隊長 \n \n 苗栗縣後備指揮部顧問",
				"allTel": "國會研究室：02-2358-6266;公館服務處：037-223-566;苗栗服務處：037-368-811;頭份服務處：037-686-688",
				"labTel": "02-2358-6266",
				"serviceTel1": "公館服務處：037-223-566",
				"serviceTel2": "苗栗服務處：037-368-811",
				"serviceTel3": "頭份服務處：037-686-688",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6270;公館服務處：037-239-233;苗栗服務處：037-368-877;頭份服務處：037-686-611",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90045.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0802室;公館服務處：苗栗縣公館鄉玉泉村367號2樓;苗栗服務處：苗栗縣苗栗市縣府路70號;頭份服務處：苗栗縣頭份鎮中山路292號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0802室",
				"serviceAdd1": "公館服務處：苗栗縣公館鄉玉泉村367號2樓",
				"serviceAdd2": "苗栗服務處：苗栗縣苗栗市縣府路70號",
				"serviceAdd3": "頭份服務處：苗栗縣頭份鎮中山路292號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hsu0731/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%BF%97%E6%A6%AE",
				"LineID": ""
			}
		],
		"公館鄉": [
			{
				"w": 9,
				"name": "徐志榮",
				"ename": "Hsu Chih Jung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第2選舉區",
				"district": "頭份鎮、三灣鄉、南庄鄉、苗栗市、頭屋鄉、獅潭鄉、公館鄉、大湖鄉、泰安鄉、卓蘭鎮",
				"Email": "ly11154a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立苗栗高中畢業 \n ;日本國立石川高等職業學校畢業",
				"profession": "外交及國防委員會",
				"experience": "第8屆立法委員 \n \n 行政院政務顧問 \n \n 苗栗縣公館鄉第13、14屆鄉長 \n \n 苗栗縣體育會理事長 \n \n 苗栗縣徐氏宗親會副理事長 \n \n 苗栗縣義消總隊總隊長 \n \n 苗栗縣後備指揮部顧問",
				"allTel": "國會研究室：02-2358-6266;公館服務處：037-223-566;苗栗服務處：037-368-811;頭份服務處：037-686-688",
				"labTel": "02-2358-6266",
				"serviceTel1": "公館服務處：037-223-566",
				"serviceTel2": "苗栗服務處：037-368-811",
				"serviceTel3": "頭份服務處：037-686-688",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6270;公館服務處：037-239-233;苗栗服務處：037-368-877;頭份服務處：037-686-611",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90045.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0802室;公館服務處：苗栗縣公館鄉玉泉村367號2樓;苗栗服務處：苗栗縣苗栗市縣府路70號;頭份服務處：苗栗縣頭份鎮中山路292號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0802室",
				"serviceAdd1": "公館服務處：苗栗縣公館鄉玉泉村367號2樓",
				"serviceAdd2": "苗栗服務處：苗栗縣苗栗市縣府路70號",
				"serviceAdd3": "頭份服務處：苗栗縣頭份鎮中山路292號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hsu0731/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%BF%97%E6%A6%AE",
				"LineID": ""
			}
		],
		"大湖鄉": [
			{
				"w": 9,
				"name": "徐志榮",
				"ename": "Hsu Chih Jung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第2選舉區",
				"district": "頭份鎮、三灣鄉、南庄鄉、苗栗市、頭屋鄉、獅潭鄉、公館鄉、大湖鄉、泰安鄉、卓蘭鎮",
				"Email": "ly11154a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立苗栗高中畢業 \n ;日本國立石川高等職業學校畢業",
				"profession": "外交及國防委員會",
				"experience": "第8屆立法委員 \n \n 行政院政務顧問 \n \n 苗栗縣公館鄉第13、14屆鄉長 \n \n 苗栗縣體育會理事長 \n \n 苗栗縣徐氏宗親會副理事長 \n \n 苗栗縣義消總隊總隊長 \n \n 苗栗縣後備指揮部顧問",
				"allTel": "國會研究室：02-2358-6266;公館服務處：037-223-566;苗栗服務處：037-368-811;頭份服務處：037-686-688",
				"labTel": "02-2358-6266",
				"serviceTel1": "公館服務處：037-223-566",
				"serviceTel2": "苗栗服務處：037-368-811",
				"serviceTel3": "頭份服務處：037-686-688",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6270;公館服務處：037-239-233;苗栗服務處：037-368-877;頭份服務處：037-686-611",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90045.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0802室;公館服務處：苗栗縣公館鄉玉泉村367號2樓;苗栗服務處：苗栗縣苗栗市縣府路70號;頭份服務處：苗栗縣頭份鎮中山路292號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0802室",
				"serviceAdd1": "公館服務處：苗栗縣公館鄉玉泉村367號2樓",
				"serviceAdd2": "苗栗服務處：苗栗縣苗栗市縣府路70號",
				"serviceAdd3": "頭份服務處：苗栗縣頭份鎮中山路292號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hsu0731/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%BF%97%E6%A6%AE",
				"LineID": ""
			}
		],
		"泰安鄉": [
			{
				"w": 9,
				"name": "徐志榮",
				"ename": "Hsu Chih Jung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第2選舉區",
				"district": "頭份鎮、三灣鄉、南庄鄉、苗栗市、頭屋鄉、獅潭鄉、公館鄉、大湖鄉、泰安鄉、卓蘭鎮",
				"Email": "ly11154a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立苗栗高中畢業 \n ;日本國立石川高等職業學校畢業",
				"profession": "外交及國防委員會",
				"experience": "第8屆立法委員 \n \n 行政院政務顧問 \n \n 苗栗縣公館鄉第13、14屆鄉長 \n \n 苗栗縣體育會理事長 \n \n 苗栗縣徐氏宗親會副理事長 \n \n 苗栗縣義消總隊總隊長 \n \n 苗栗縣後備指揮部顧問",
				"allTel": "國會研究室：02-2358-6266;公館服務處：037-223-566;苗栗服務處：037-368-811;頭份服務處：037-686-688",
				"labTel": "02-2358-6266",
				"serviceTel1": "公館服務處：037-223-566",
				"serviceTel2": "苗栗服務處：037-368-811",
				"serviceTel3": "頭份服務處：037-686-688",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6270;公館服務處：037-239-233;苗栗服務處：037-368-877;頭份服務處：037-686-611",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90045.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0802室;公館服務處：苗栗縣公館鄉玉泉村367號2樓;苗栗服務處：苗栗縣苗栗市縣府路70號;頭份服務處：苗栗縣頭份鎮中山路292號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0802室",
				"serviceAdd1": "公館服務處：苗栗縣公館鄉玉泉村367號2樓",
				"serviceAdd2": "苗栗服務處：苗栗縣苗栗市縣府路70號",
				"serviceAdd3": "頭份服務處：苗栗縣頭份鎮中山路292號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hsu0731/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%BF%97%E6%A6%AE",
				"LineID": ""
			}
		],
		"卓蘭鎮": [
			{
				"w": 9,
				"name": "徐志榮",
				"ename": "Hsu Chih Jung",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第2選舉區",
				"district": "頭份鎮、三灣鄉、南庄鄉、苗栗市、頭屋鄉、獅潭鄉、公館鄉、大湖鄉、泰安鄉、卓蘭鎮",
				"Email": "ly11154a@ly.gov.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立苗栗高中畢業 \n ;日本國立石川高等職業學校畢業",
				"profession": "外交及國防委員會",
				"experience": "第8屆立法委員 \n \n 行政院政務顧問 \n \n 苗栗縣公館鄉第13、14屆鄉長 \n \n 苗栗縣體育會理事長 \n \n 苗栗縣徐氏宗親會副理事長 \n \n 苗栗縣義消總隊總隊長 \n \n 苗栗縣後備指揮部顧問",
				"allTel": "國會研究室：02-2358-6266;公館服務處：037-223-566;苗栗服務處：037-368-811;頭份服務處：037-686-688",
				"labTel": "02-2358-6266",
				"serviceTel1": "公館服務處：037-223-566",
				"serviceTel2": "苗栗服務處：037-368-811",
				"serviceTel3": "頭份服務處：037-686-688",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6270;公館服務處：037-239-233;苗栗服務處：037-368-877;頭份服務處：037-686-611",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90045.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0802室;公館服務處：苗栗縣公館鄉玉泉村367號2樓;苗栗服務處：苗栗縣苗栗市縣府路70號;頭份服務處：苗栗縣頭份鎮中山路292號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0802室",
				"serviceAdd1": "公館服務處：苗栗縣公館鄉玉泉村367號2樓",
				"serviceAdd2": "苗栗服務處：苗栗縣苗栗市縣府路70號",
				"serviceAdd3": "頭份服務處：苗栗縣頭份鎮中山路292號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/hsu0731/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%BE%90%E5%BF%97%E6%A6%AE",
				"LineID": ""
			}
		],
		"竹南鎮": [
			{
				"w": 9,
				"name": "陳超明",
				"ename": "Chen Chao Ming",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第1選舉區",
				"district": "竹南鎮、造橋鄉、後龍鎮、西湖鄉、通霄鎮、銅鑼鄉、苑裡鎮、三義鄉",
				"Email": "ly10837b@ly.gov.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "新竹縣竹東高中 ;國立政治大學公共行政學系",
				"profession": "內政委員會",
				"experience": "苗栗縣第12、13屆縣議員 \n 第10屆省議員 \n 第4、8屆立法委員 \n 總統府顧問 \n 行政院顧問",
				"allTel": "國會研究室：02-2358-6611;竹南服務處：037-468-448",
				"labTel": "02-2358-6611",
				"serviceTel1": "竹南服務處：037-468-448",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6615;竹南服務處：037-478-508",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90067.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1003室;竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1003室",
				"serviceAdd1": "竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%99%B3%E8%B6%85%E6%98%8E-%E9%98%BF%E6%98%8E%E5%93%A5%E7%B2%89%E7%B5%B2%E5%9C%98-1621835121361449/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B6%85%E6%98%8E",
				"LineID": ""
			}
		],
		"造橋鄉": [
			{
				"w": 9,
				"name": "陳超明",
				"ename": "Chen Chao Ming",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第1選舉區",
				"district": "竹南鎮、造橋鄉、後龍鎮、西湖鄉、通霄鎮、銅鑼鄉、苑裡鎮、三義鄉",
				"Email": "ly10837b@ly.gov.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "新竹縣竹東高中 ;國立政治大學公共行政學系",
				"profession": "內政委員會",
				"experience": "苗栗縣第12、13屆縣議員 \n 第10屆省議員 \n 第4、8屆立法委員 \n 總統府顧問 \n 行政院顧問",
				"allTel": "國會研究室：02-2358-6611;竹南服務處：037-468-448",
				"labTel": "02-2358-6611",
				"serviceTel1": "竹南服務處：037-468-448",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6615;竹南服務處：037-478-508",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90067.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1003室;竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1003室",
				"serviceAdd1": "竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%99%B3%E8%B6%85%E6%98%8E-%E9%98%BF%E6%98%8E%E5%93%A5%E7%B2%89%E7%B5%B2%E5%9C%98-1621835121361449/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B6%85%E6%98%8E",
				"LineID": ""
			}
		],
		"後龍鎮": [
			{
				"w": 9,
				"name": "陳超明",
				"ename": "Chen Chao Ming",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第1選舉區",
				"district": "竹南鎮、造橋鄉、後龍鎮、西湖鄉、通霄鎮、銅鑼鄉、苑裡鎮、三義鄉",
				"Email": "ly10837b@ly.gov.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "新竹縣竹東高中 ;國立政治大學公共行政學系",
				"profession": "內政委員會",
				"experience": "苗栗縣第12、13屆縣議員 \n 第10屆省議員 \n 第4、8屆立法委員 \n 總統府顧問 \n 行政院顧問",
				"allTel": "國會研究室：02-2358-6611;竹南服務處：037-468-448",
				"labTel": "02-2358-6611",
				"serviceTel1": "竹南服務處：037-468-448",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6615;竹南服務處：037-478-508",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90067.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1003室;竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1003室",
				"serviceAdd1": "竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%99%B3%E8%B6%85%E6%98%8E-%E9%98%BF%E6%98%8E%E5%93%A5%E7%B2%89%E7%B5%B2%E5%9C%98-1621835121361449/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B6%85%E6%98%8E",
				"LineID": ""
			}
		],
		"西湖鄉": [
			{
				"w": 9,
				"name": "陳超明",
				"ename": "Chen Chao Ming",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第1選舉區",
				"district": "竹南鎮、造橋鄉、後龍鎮、西湖鄉、通霄鎮、銅鑼鄉、苑裡鎮、三義鄉",
				"Email": "ly10837b@ly.gov.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "新竹縣竹東高中 ;國立政治大學公共行政學系",
				"profession": "內政委員會",
				"experience": "苗栗縣第12、13屆縣議員 \n 第10屆省議員 \n 第4、8屆立法委員 \n 總統府顧問 \n 行政院顧問",
				"allTel": "國會研究室：02-2358-6611;竹南服務處：037-468-448",
				"labTel": "02-2358-6611",
				"serviceTel1": "竹南服務處：037-468-448",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6615;竹南服務處：037-478-508",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90067.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1003室;竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1003室",
				"serviceAdd1": "竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%99%B3%E8%B6%85%E6%98%8E-%E9%98%BF%E6%98%8E%E5%93%A5%E7%B2%89%E7%B5%B2%E5%9C%98-1621835121361449/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B6%85%E6%98%8E",
				"LineID": ""
			}
		],
		"通霄鎮": [
			{
				"w": 9,
				"name": "陳超明",
				"ename": "Chen Chao Ming",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第1選舉區",
				"district": "竹南鎮、造橋鄉、後龍鎮、西湖鄉、通霄鎮、銅鑼鄉、苑裡鎮、三義鄉",
				"Email": "ly10837b@ly.gov.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "新竹縣竹東高中 ;國立政治大學公共行政學系",
				"profession": "內政委員會",
				"experience": "苗栗縣第12、13屆縣議員 \n 第10屆省議員 \n 第4、8屆立法委員 \n 總統府顧問 \n 行政院顧問",
				"allTel": "國會研究室：02-2358-6611;竹南服務處：037-468-448",
				"labTel": "02-2358-6611",
				"serviceTel1": "竹南服務處：037-468-448",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6615;竹南服務處：037-478-508",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90067.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1003室;竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1003室",
				"serviceAdd1": "竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%99%B3%E8%B6%85%E6%98%8E-%E9%98%BF%E6%98%8E%E5%93%A5%E7%B2%89%E7%B5%B2%E5%9C%98-1621835121361449/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B6%85%E6%98%8E",
				"LineID": ""
			}
		],
		"銅鑼鄉": [
			{
				"w": 9,
				"name": "陳超明",
				"ename": "Chen Chao Ming",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第1選舉區",
				"district": "竹南鎮、造橋鄉、後龍鎮、西湖鄉、通霄鎮、銅鑼鄉、苑裡鎮、三義鄉",
				"Email": "ly10837b@ly.gov.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "新竹縣竹東高中 ;國立政治大學公共行政學系",
				"profession": "內政委員會",
				"experience": "苗栗縣第12、13屆縣議員 \n 第10屆省議員 \n 第4、8屆立法委員 \n 總統府顧問 \n 行政院顧問",
				"allTel": "國會研究室：02-2358-6611;竹南服務處：037-468-448",
				"labTel": "02-2358-6611",
				"serviceTel1": "竹南服務處：037-468-448",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6615;竹南服務處：037-478-508",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90067.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1003室;竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1003室",
				"serviceAdd1": "竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%99%B3%E8%B6%85%E6%98%8E-%E9%98%BF%E6%98%8E%E5%93%A5%E7%B2%89%E7%B5%B2%E5%9C%98-1621835121361449/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B6%85%E6%98%8E",
				"LineID": ""
			}
		],
		"苑裡鎮": [
			{
				"w": 9,
				"name": "陳超明",
				"ename": "Chen Chao Ming",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第1選舉區",
				"district": "竹南鎮、造橋鄉、後龍鎮、西湖鄉、通霄鎮、銅鑼鄉、苑裡鎮、三義鄉",
				"Email": "ly10837b@ly.gov.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "新竹縣竹東高中 ;國立政治大學公共行政學系",
				"profession": "內政委員會",
				"experience": "苗栗縣第12、13屆縣議員 \n 第10屆省議員 \n 第4、8屆立法委員 \n 總統府顧問 \n 行政院顧問",
				"allTel": "國會研究室：02-2358-6611;竹南服務處：037-468-448",
				"labTel": "02-2358-6611",
				"serviceTel1": "竹南服務處：037-468-448",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6615;竹南服務處：037-478-508",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90067.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1003室;竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1003室",
				"serviceAdd1": "竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%99%B3%E8%B6%85%E6%98%8E-%E9%98%BF%E6%98%8E%E5%93%A5%E7%B2%89%E7%B5%B2%E5%9C%98-1621835121361449/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B6%85%E6%98%8E",
				"LineID": ""
			}
		],
		"三義鄉": [
			{
				"w": 9,
				"name": "陳超明",
				"ename": "Chen Chao Ming",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "苗栗縣第1選舉區",
				"district": "竹南鎮、造橋鄉、後龍鎮、西湖鄉、通霄鎮、銅鑼鄉、苑裡鎮、三義鄉",
				"Email": "ly10837b@ly.gov.tw",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "新竹縣竹東高中 ;國立政治大學公共行政學系",
				"profession": "內政委員會",
				"experience": "苗栗縣第12、13屆縣議員 \n 第10屆省議員 \n 第4、8屆立法委員 \n 總統府顧問 \n 行政院顧問",
				"allTel": "國會研究室：02-2358-6611;竹南服務處：037-468-448",
				"labTel": "02-2358-6611",
				"serviceTel1": "竹南服務處：037-468-448",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6615;竹南服務處：037-478-508",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90067.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號1003室;竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號1003室",
				"serviceAdd1": "竹南服務處：350苗栗縣竹南鎮環市路二段139號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E9%99%B3%E8%B6%85%E6%98%8E-%E9%98%BF%E6%98%8E%E5%93%A5%E7%B2%89%E7%B5%B2%E5%9C%98-1621835121361449/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E8%B6%85%E6%98%8E",
				"LineID": ""
			}
		]
	},
	"屏東縣": {
		"新園鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"崁頂鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"南州鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"新埤鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"來義鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"東港鎮": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"林邊鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"佳冬鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"枋寮鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"春日鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"枋山鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"獅子鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"牡丹鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"車城鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"滿州鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"恆春鎮": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"琉球鄉": [
			{
				"w": 9,
				"name": "莊瑞雄",
				"ename": "Chuang Jui Hsiung",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第3選舉區",
				"district": "新園鄉、崁頂鄉、南州鄉、新埤鄉、來義鄉、東港鎮、林邊鄉、佳冬鄉、枋寮鄉、春日鄉、枋山鄉、獅子鄉、牡丹鄉、車城鄉、滿州鄉、恆春鎮、琉球鄉",
				"Email": "green.bear@msa.hinet.net",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立臺灣大學農業經濟學系碩士 \n ;國立臺北大學企業管理學系碩士 \n ;國立臺灣大學法律學系學士",
				"profession": "內政委員會",
				"experience": "第8屆立法委員\n \n 公民監督國會聯盟評鑑最優秀立法委員\n \n 律師\n \n 民進黨發言人\n \n 民進黨中央執行委員\n \n 第13、14屆民進黨臺北市黨部主委\n \n 第10、11屆臺北市議員\n \n 全民監督黨產聯盟執行長\n \n 中選會巡迴監察員\n \n 綠色和平電台主持人\n \n 台灣國家山岳協會理事長",
				"allTel": "國會研究室：02-2358-6368;東港服務處：08-833-7893",
				"labTel": "02-2358-6368",
				"serviceTel1": "東港服務處：08-833-7893",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6366;東港服務處：08-833-9316",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90055.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0702室;東港服務處：900屏東縣東港鎮光復路一段379號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0702室",
				"serviceAdd1": "東港服務處：900屏東縣東港鎮光復路一段379號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/lawyer0420?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%8E%8A%E7%91%9E%E9%9B%84",
				"LineID": ""
			}
		],
		"屏東市": [
			{
				"w": 9,
				"name": "鍾佳濱",
				"ename": "Chung Chia Pin",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第2選舉區",
				"district": "屏東市、麟洛鄉、萬丹鄉",
				"Email": "cafe2016116@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "國立屏東科技大學研究所\n ;國立臺灣大學歷史系\n ;屏東高中\n ;明正國中\n ;仁愛國小",
				"profession": "教育及文化委員會",
				"experience": "屏東縣副縣長\n \n 第3屆國民大會代表\n \n 行政院文化建設委員會參事\n \n 紙風車劇團顧問\n \n 萬年溪保育協會\n \n 屏東縣台大校友會理事長\n \n 廢除刑法100行動聯盟\n \n 野百合世代學運領袖\n \n 核四公投千里苦行執行秘書",
				"allTel": "國會研究室：02-2358-6626;屏東服務處：08-733-6599",
				"labTel": "02-2358-6626",
				"serviceTel1": "屏東服務處：08-733-6599",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6630;屏東服務處：08-733-6988",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90104.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0401室;屏東服務處：90071屏東縣屏東市博愛路358號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0401室",
				"serviceAdd1": "屏東服務處：90071屏東縣屏東市博愛路358號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/cafe1965/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%8D%BE%E4%BD%B3%E6%BF%B1",
				"LineID": "@rdz7246d"
			}
		],
		"麟洛鄉": [
			{
				"w": 9,
				"name": "鍾佳濱",
				"ename": "Chung Chia Pin",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第2選舉區",
				"district": "屏東市、麟洛鄉、萬丹鄉",
				"Email": "cafe2016116@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "國立屏東科技大學研究所\n ;國立臺灣大學歷史系\n ;屏東高中\n ;明正國中\n ;仁愛國小",
				"profession": "教育及文化委員會",
				"experience": "屏東縣副縣長\n \n 第3屆國民大會代表\n \n 行政院文化建設委員會參事\n \n 紙風車劇團顧問\n \n 萬年溪保育協會\n \n 屏東縣台大校友會理事長\n \n 廢除刑法100行動聯盟\n \n 野百合世代學運領袖\n \n 核四公投千里苦行執行秘書",
				"allTel": "國會研究室：02-2358-6626;屏東服務處：08-733-6599",
				"labTel": "02-2358-6626",
				"serviceTel1": "屏東服務處：08-733-6599",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6630;屏東服務處：08-733-6988",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90104.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0401室;屏東服務處：90071屏東縣屏東市博愛路358號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0401室",
				"serviceAdd1": "屏東服務處：90071屏東縣屏東市博愛路358號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/cafe1965/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%8D%BE%E4%BD%B3%E6%BF%B1",
				"LineID": "@rdz7246d"
			}
		],
		"萬丹鄉": [
			{
				"w": 9,
				"name": "鍾佳濱",
				"ename": "Chung Chia Pin",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第2選舉區",
				"district": "屏東市、麟洛鄉、萬丹鄉",
				"Email": "cafe2016116@gmail.com",
				"committee": "",
				"onboardDate": "2016/2/1",
				"degree": "國立屏東科技大學研究所\n ;國立臺灣大學歷史系\n ;屏東高中\n ;明正國中\n ;仁愛國小",
				"profession": "教育及文化委員會",
				"experience": "屏東縣副縣長\n \n 第3屆國民大會代表\n \n 行政院文化建設委員會參事\n \n 紙風車劇團顧問\n \n 萬年溪保育協會\n \n 屏東縣台大校友會理事長\n \n 廢除刑法100行動聯盟\n \n 野百合世代學運領袖\n \n 核四公投千里苦行執行秘書",
				"allTel": "國會研究室：02-2358-6626;屏東服務處：08-733-6599",
				"labTel": "02-2358-6626",
				"serviceTel1": "屏東服務處：08-733-6599",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6630;屏東服務處：08-733-6988",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90104.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0401室;屏東服務處：90071屏東縣屏東市博愛路358號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0401室",
				"serviceAdd1": "屏東服務處：90071屏東縣屏東市博愛路358號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/cafe1965/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%8D%BE%E4%BD%B3%E6%BF%B1",
				"LineID": "@rdz7246d"
			}
		],
		"里港鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"高樹鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"三地門鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"霧臺鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"九如鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"鹽埔鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"長治鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"內埔鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"瑪家鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"泰武鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"竹田鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"萬巒鄉": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		],
		"潮州鎮": [
			{
				"w": 9,
				"name": "中國",
				"ename": "Su Chen Ching",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "屏東縣第1選舉區",
				"district": "里港鄉、高樹鄉、三地門鄉、霧臺鄉、九如鄉、鹽埔鄉、長治鄉、內埔鄉、瑪家鄉、泰武鄉、竹田鄉、萬巒鄉、潮州鎮",
				"Email": "su7666636@yahoo.com.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "屏東科技大學農業企業管理碩士專班畢",
				"profession": "",
				"experience": "民進黨第7屆全國黨代表\n \n 民進黨第14屆中央執行委員\n \n 蘇嘉全立委辦公室主任\n \n 屏東縣中央獅子會理事\n \n 屏東縣議員第15屆、16屆\n \n 立法委員第7屆\n \n 立法委員第8屆",
				"allTel": "國會研究室：02-2358-6636;屏東服務處：08-766-6636",
				"labTel": "02-2358-6636",
				"serviceTel1": "屏東服務處：08-766-6636",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6640;屏東服務處：08-766-6262",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90112.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0708室;屏東服務處：屏東縣屏東市自由路586號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0708室",
				"serviceAdd1": "屏東服務處：屏東縣屏東市自由路586號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/su7666636/?fref=ts\nhttps://www.facebook.com/people/蘇震清/100000445699070",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E9%9C%87%E6%B8%85",
				"LineID": ""
			}
		]
	},
	"嘉義縣": {
		"溪口鄉": [
			{
				"w": 9,
				"name": "陳明文",
				"ename": "Chen Ming Wen",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第2選舉區",
				"district": "溪口鄉、大林鎮、梅山鄉、新港鄉、民雄鄉、竹崎鄉、中埔鄉、番路鄉、阿里山鄉、大埔鄉",
				"Email": "ly10832a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "私立東海大學哲學系畢業",
				"profession": "經濟委員會",
				"experience": "嘉義縣議會第9屆議員、第10屆議長\n 臺灣省議會第8、9、10屆議員\n 第4屆立法委員\n 嘉義縣第14、15屆縣長\n 第7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8101;嘉義服務處：05-225-5589",
				"labTel": "02-2358-8101",
				"serviceTel1": "嘉義服務處：05-225-5589",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8105;嘉義服務處：05-225-1641",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90062.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3101室;嘉義服務處：600嘉義市力行街72號",
				"labAddr": "10051臺北市中正區青島東路1-3號3101室",
				"serviceAdd1": "嘉義服務處：600嘉義市力行街72號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chenminwen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%98%8E%E6%96%87",
				"LineID": ""
			}
		],
		"大林鎮": [
			{
				"w": 9,
				"name": "陳明文",
				"ename": "Chen Ming Wen",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第2選舉區",
				"district": "溪口鄉、大林鎮、梅山鄉、新港鄉、民雄鄉、竹崎鄉、中埔鄉、番路鄉、阿里山鄉、大埔鄉",
				"Email": "ly10832a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "私立東海大學哲學系畢業",
				"profession": "經濟委員會",
				"experience": "嘉義縣議會第9屆議員、第10屆議長\n 臺灣省議會第8、9、10屆議員\n 第4屆立法委員\n 嘉義縣第14、15屆縣長\n 第7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8101;嘉義服務處：05-225-5589",
				"labTel": "02-2358-8101",
				"serviceTel1": "嘉義服務處：05-225-5589",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8105;嘉義服務處：05-225-1641",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90062.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3101室;嘉義服務處：600嘉義市力行街72號",
				"labAddr": "10051臺北市中正區青島東路1-3號3101室",
				"serviceAdd1": "嘉義服務處：600嘉義市力行街72號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chenminwen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%98%8E%E6%96%87",
				"LineID": ""
			}
		],
		"梅山鄉": [
			{
				"w": 9,
				"name": "陳明文",
				"ename": "Chen Ming Wen",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第2選舉區",
				"district": "溪口鄉、大林鎮、梅山鄉、新港鄉、民雄鄉、竹崎鄉、中埔鄉、番路鄉、阿里山鄉、大埔鄉",
				"Email": "ly10832a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "私立東海大學哲學系畢業",
				"profession": "經濟委員會",
				"experience": "嘉義縣議會第9屆議員、第10屆議長\n 臺灣省議會第8、9、10屆議員\n 第4屆立法委員\n 嘉義縣第14、15屆縣長\n 第7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8101;嘉義服務處：05-225-5589",
				"labTel": "02-2358-8101",
				"serviceTel1": "嘉義服務處：05-225-5589",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8105;嘉義服務處：05-225-1641",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90062.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3101室;嘉義服務處：600嘉義市力行街72號",
				"labAddr": "10051臺北市中正區青島東路1-3號3101室",
				"serviceAdd1": "嘉義服務處：600嘉義市力行街72號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chenminwen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%98%8E%E6%96%87",
				"LineID": ""
			}
		],
		"新港鄉": [
			{
				"w": 9,
				"name": "陳明文",
				"ename": "Chen Ming Wen",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第2選舉區",
				"district": "溪口鄉、大林鎮、梅山鄉、新港鄉、民雄鄉、竹崎鄉、中埔鄉、番路鄉、阿里山鄉、大埔鄉",
				"Email": "ly10832a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "私立東海大學哲學系畢業",
				"profession": "經濟委員會",
				"experience": "嘉義縣議會第9屆議員、第10屆議長\n 臺灣省議會第8、9、10屆議員\n 第4屆立法委員\n 嘉義縣第14、15屆縣長\n 第7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8101;嘉義服務處：05-225-5589",
				"labTel": "02-2358-8101",
				"serviceTel1": "嘉義服務處：05-225-5589",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8105;嘉義服務處：05-225-1641",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90062.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3101室;嘉義服務處：600嘉義市力行街72號",
				"labAddr": "10051臺北市中正區青島東路1-3號3101室",
				"serviceAdd1": "嘉義服務處：600嘉義市力行街72號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chenminwen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%98%8E%E6%96%87",
				"LineID": ""
			}
		],
		"民雄鄉": [
			{
				"w": 9,
				"name": "陳明文",
				"ename": "Chen Ming Wen",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第2選舉區",
				"district": "溪口鄉、大林鎮、梅山鄉、新港鄉、民雄鄉、竹崎鄉、中埔鄉、番路鄉、阿里山鄉、大埔鄉",
				"Email": "ly10832a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "私立東海大學哲學系畢業",
				"profession": "經濟委員會",
				"experience": "嘉義縣議會第9屆議員、第10屆議長\n 臺灣省議會第8、9、10屆議員\n 第4屆立法委員\n 嘉義縣第14、15屆縣長\n 第7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8101;嘉義服務處：05-225-5589",
				"labTel": "02-2358-8101",
				"serviceTel1": "嘉義服務處：05-225-5589",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8105;嘉義服務處：05-225-1641",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90062.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3101室;嘉義服務處：600嘉義市力行街72號",
				"labAddr": "10051臺北市中正區青島東路1-3號3101室",
				"serviceAdd1": "嘉義服務處：600嘉義市力行街72號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chenminwen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%98%8E%E6%96%87",
				"LineID": ""
			}
		],
		"竹崎鄉": [
			{
				"w": 9,
				"name": "陳明文",
				"ename": "Chen Ming Wen",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第2選舉區",
				"district": "溪口鄉、大林鎮、梅山鄉、新港鄉、民雄鄉、竹崎鄉、中埔鄉、番路鄉、阿里山鄉、大埔鄉",
				"Email": "ly10832a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "私立東海大學哲學系畢業",
				"profession": "經濟委員會",
				"experience": "嘉義縣議會第9屆議員、第10屆議長\n 臺灣省議會第8、9、10屆議員\n 第4屆立法委員\n 嘉義縣第14、15屆縣長\n 第7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8101;嘉義服務處：05-225-5589",
				"labTel": "02-2358-8101",
				"serviceTel1": "嘉義服務處：05-225-5589",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8105;嘉義服務處：05-225-1641",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90062.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3101室;嘉義服務處：600嘉義市力行街72號",
				"labAddr": "10051臺北市中正區青島東路1-3號3101室",
				"serviceAdd1": "嘉義服務處：600嘉義市力行街72號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chenminwen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%98%8E%E6%96%87",
				"LineID": ""
			}
		],
		"中埔鄉": [
			{
				"w": 9,
				"name": "陳明文",
				"ename": "Chen Ming Wen",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第2選舉區",
				"district": "溪口鄉、大林鎮、梅山鄉、新港鄉、民雄鄉、竹崎鄉、中埔鄉、番路鄉、阿里山鄉、大埔鄉",
				"Email": "ly10832a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "私立東海大學哲學系畢業",
				"profession": "經濟委員會",
				"experience": "嘉義縣議會第9屆議員、第10屆議長\n 臺灣省議會第8、9、10屆議員\n 第4屆立法委員\n 嘉義縣第14、15屆縣長\n 第7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8101;嘉義服務處：05-225-5589",
				"labTel": "02-2358-8101",
				"serviceTel1": "嘉義服務處：05-225-5589",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8105;嘉義服務處：05-225-1641",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90062.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3101室;嘉義服務處：600嘉義市力行街72號",
				"labAddr": "10051臺北市中正區青島東路1-3號3101室",
				"serviceAdd1": "嘉義服務處：600嘉義市力行街72號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chenminwen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%98%8E%E6%96%87",
				"LineID": ""
			}
		],
		"番路鄉": [
			{
				"w": 9,
				"name": "陳明文",
				"ename": "Chen Ming Wen",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第2選舉區",
				"district": "溪口鄉、大林鎮、梅山鄉、新港鄉、民雄鄉、竹崎鄉、中埔鄉、番路鄉、阿里山鄉、大埔鄉",
				"Email": "ly10832a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "私立東海大學哲學系畢業",
				"profession": "經濟委員會",
				"experience": "嘉義縣議會第9屆議員、第10屆議長\n 臺灣省議會第8、9、10屆議員\n 第4屆立法委員\n 嘉義縣第14、15屆縣長\n 第7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8101;嘉義服務處：05-225-5589",
				"labTel": "02-2358-8101",
				"serviceTel1": "嘉義服務處：05-225-5589",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8105;嘉義服務處：05-225-1641",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90062.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3101室;嘉義服務處：600嘉義市力行街72號",
				"labAddr": "10051臺北市中正區青島東路1-3號3101室",
				"serviceAdd1": "嘉義服務處：600嘉義市力行街72號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chenminwen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%98%8E%E6%96%87",
				"LineID": ""
			}
		],
		"阿里山鄉": [
			{
				"w": 9,
				"name": "陳明文",
				"ename": "Chen Ming Wen",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第2選舉區",
				"district": "溪口鄉、大林鎮、梅山鄉、新港鄉、民雄鄉、竹崎鄉、中埔鄉、番路鄉、阿里山鄉、大埔鄉",
				"Email": "ly10832a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "私立東海大學哲學系畢業",
				"profession": "經濟委員會",
				"experience": "嘉義縣議會第9屆議員、第10屆議長\n 臺灣省議會第8、9、10屆議員\n 第4屆立法委員\n 嘉義縣第14、15屆縣長\n 第7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8101;嘉義服務處：05-225-5589",
				"labTel": "02-2358-8101",
				"serviceTel1": "嘉義服務處：05-225-5589",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8105;嘉義服務處：05-225-1641",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90062.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3101室;嘉義服務處：600嘉義市力行街72號",
				"labAddr": "10051臺北市中正區青島東路1-3號3101室",
				"serviceAdd1": "嘉義服務處：600嘉義市力行街72號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chenminwen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%98%8E%E6%96%87",
				"LineID": ""
			}
		],
		"大埔鄉": [
			{
				"w": 9,
				"name": "陳明文",
				"ename": "Chen Ming Wen",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第2選舉區",
				"district": "溪口鄉、大林鎮、梅山鄉、新港鄉、民雄鄉、竹崎鄉、中埔鄉、番路鄉、阿里山鄉、大埔鄉",
				"Email": "ly10832a@ly.gov.tw",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "私立東海大學哲學系畢業",
				"profession": "經濟委員會",
				"experience": "嘉義縣議會第9屆議員、第10屆議長\n 臺灣省議會第8、9、10屆議員\n 第4屆立法委員\n 嘉義縣第14、15屆縣長\n 第7、8屆立法委員",
				"allTel": "國會研究室：02-2358-8101;嘉義服務處：05-225-5589",
				"labTel": "02-2358-8101",
				"serviceTel1": "嘉義服務處：05-225-5589",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8105;嘉義服務處：05-225-1641",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90062.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3101室;嘉義服務處：600嘉義市力行街72號",
				"labAddr": "10051臺北市中正區青島東路1-3號3101室",
				"serviceAdd1": "嘉義服務處：600嘉義市力行街72號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/chenminwen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%98%8E%E6%96%87",
				"LineID": ""
			}
		],
		"六腳鄉": [
			{
				"w": 9,
				"name": "蔡易餘",
				"ename": "Tsai Yi Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第1選舉區",
				"district": "六腳鄉、東石鄉、朴子市、太保市、布袋鎮、義竹鄉、鹿草鄉、水上鄉",
				"Email": "chiayionefish@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "嘉義市崇文國小\n ;水上鄉忠和國中\n ;嘉義高中\n ;臺灣大學財經法律系",
				"profession": "",
				"experience": "萬國法律事務所律師\n \n 民主進步黨中央執行委員\n \n 2014年張花冠縣長競選總幹事\n \n 台灣陪審團協會理事\n \n 凱達格蘭基金會理事\n \n 小英教育基金會顧問\n \n 民主進步黨嘉義縣黨部主委",
				"allTel": "國會研究室：02-2358-6388;朴子服務處：05-370-8518;布袋服務處：05-347-6822",
				"labTel": "02-2358-6388",
				"serviceTel1": "朴子服務處：05-370-8518",
				"serviceTel2": "布袋服務處：05-347-6822",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6385;朴子服務處：05-370-8519",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90090.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0705室;朴子服務處：嘉義縣朴子市安福里文明路1-11號;水上服務處：嘉義縣水上鄉中正路192號;布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0705室",
				"serviceAdd1": "朴子服務處：嘉義縣朴子市安福里文明路1-11號",
				"serviceAdd2": "水上服務處：嘉義縣水上鄉中正路192號",
				"serviceAdd3": "布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/clbundlaw?fref=ts\nhttps://www.facebook.com/bundlaw",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E6%98%93%E9%A4%98",
				"LineID": "@xyx4958e"
			}
		],
		"東石鄉": [
			{
				"w": 9,
				"name": "蔡易餘",
				"ename": "Tsai Yi Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第1選舉區",
				"district": "六腳鄉、東石鄉、朴子市、太保市、布袋鎮、義竹鄉、鹿草鄉、水上鄉",
				"Email": "chiayionefish@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "嘉義市崇文國小\n ;水上鄉忠和國中\n ;嘉義高中\n ;臺灣大學財經法律系",
				"profession": "",
				"experience": "萬國法律事務所律師\n \n 民主進步黨中央執行委員\n \n 2014年張花冠縣長競選總幹事\n \n 台灣陪審團協會理事\n \n 凱達格蘭基金會理事\n \n 小英教育基金會顧問\n \n 民主進步黨嘉義縣黨部主委",
				"allTel": "國會研究室：02-2358-6388;朴子服務處：05-370-8518;布袋服務處：05-347-6822",
				"labTel": "02-2358-6388",
				"serviceTel1": "朴子服務處：05-370-8518",
				"serviceTel2": "布袋服務處：05-347-6822",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6385;朴子服務處：05-370-8519",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90090.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0705室;朴子服務處：嘉義縣朴子市安福里文明路1-11號;水上服務處：嘉義縣水上鄉中正路192號;布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0705室",
				"serviceAdd1": "朴子服務處：嘉義縣朴子市安福里文明路1-11號",
				"serviceAdd2": "水上服務處：嘉義縣水上鄉中正路192號",
				"serviceAdd3": "布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/clbundlaw?fref=ts\nhttps://www.facebook.com/bundlaw",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E6%98%93%E9%A4%98",
				"LineID": "@xyx4958e"
			}
		],
		"朴子市": [
			{
				"w": 9,
				"name": "蔡易餘",
				"ename": "Tsai Yi Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第1選舉區",
				"district": "六腳鄉、東石鄉、朴子市、太保市、布袋鎮、義竹鄉、鹿草鄉、水上鄉",
				"Email": "chiayionefish@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "嘉義市崇文國小\n ;水上鄉忠和國中\n ;嘉義高中\n ;臺灣大學財經法律系",
				"profession": "",
				"experience": "萬國法律事務所律師\n \n 民主進步黨中央執行委員\n \n 2014年張花冠縣長競選總幹事\n \n 台灣陪審團協會理事\n \n 凱達格蘭基金會理事\n \n 小英教育基金會顧問\n \n 民主進步黨嘉義縣黨部主委",
				"allTel": "國會研究室：02-2358-6388;朴子服務處：05-370-8518;布袋服務處：05-347-6822",
				"labTel": "02-2358-6388",
				"serviceTel1": "朴子服務處：05-370-8518",
				"serviceTel2": "布袋服務處：05-347-6822",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6385;朴子服務處：05-370-8519",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90090.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0705室;朴子服務處：嘉義縣朴子市安福里文明路1-11號;水上服務處：嘉義縣水上鄉中正路192號;布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0705室",
				"serviceAdd1": "朴子服務處：嘉義縣朴子市安福里文明路1-11號",
				"serviceAdd2": "水上服務處：嘉義縣水上鄉中正路192號",
				"serviceAdd3": "布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/clbundlaw?fref=ts\nhttps://www.facebook.com/bundlaw",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E6%98%93%E9%A4%98",
				"LineID": "@xyx4958e"
			}
		],
		"太保市": [
			{
				"w": 9,
				"name": "蔡易餘",
				"ename": "Tsai Yi Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第1選舉區",
				"district": "六腳鄉、東石鄉、朴子市、太保市、布袋鎮、義竹鄉、鹿草鄉、水上鄉",
				"Email": "chiayionefish@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "嘉義市崇文國小\n ;水上鄉忠和國中\n ;嘉義高中\n ;臺灣大學財經法律系",
				"profession": "",
				"experience": "萬國法律事務所律師\n \n 民主進步黨中央執行委員\n \n 2014年張花冠縣長競選總幹事\n \n 台灣陪審團協會理事\n \n 凱達格蘭基金會理事\n \n 小英教育基金會顧問\n \n 民主進步黨嘉義縣黨部主委",
				"allTel": "國會研究室：02-2358-6388;朴子服務處：05-370-8518;布袋服務處：05-347-6822",
				"labTel": "02-2358-6388",
				"serviceTel1": "朴子服務處：05-370-8518",
				"serviceTel2": "布袋服務處：05-347-6822",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6385;朴子服務處：05-370-8519",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90090.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0705室;朴子服務處：嘉義縣朴子市安福里文明路1-11號;水上服務處：嘉義縣水上鄉中正路192號;布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0705室",
				"serviceAdd1": "朴子服務處：嘉義縣朴子市安福里文明路1-11號",
				"serviceAdd2": "水上服務處：嘉義縣水上鄉中正路192號",
				"serviceAdd3": "布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/clbundlaw?fref=ts\nhttps://www.facebook.com/bundlaw",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E6%98%93%E9%A4%98",
				"LineID": "@xyx4958e"
			}
		],
		"布袋鎮": [
			{
				"w": 9,
				"name": "蔡易餘",
				"ename": "Tsai Yi Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第1選舉區",
				"district": "六腳鄉、東石鄉、朴子市、太保市、布袋鎮、義竹鄉、鹿草鄉、水上鄉",
				"Email": "chiayionefish@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "嘉義市崇文國小\n ;水上鄉忠和國中\n ;嘉義高中\n ;臺灣大學財經法律系",
				"profession": "",
				"experience": "萬國法律事務所律師\n \n 民主進步黨中央執行委員\n \n 2014年張花冠縣長競選總幹事\n \n 台灣陪審團協會理事\n \n 凱達格蘭基金會理事\n \n 小英教育基金會顧問\n \n 民主進步黨嘉義縣黨部主委",
				"allTel": "國會研究室：02-2358-6388;朴子服務處：05-370-8518;布袋服務處：05-347-6822",
				"labTel": "02-2358-6388",
				"serviceTel1": "朴子服務處：05-370-8518",
				"serviceTel2": "布袋服務處：05-347-6822",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6385;朴子服務處：05-370-8519",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90090.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0705室;朴子服務處：嘉義縣朴子市安福里文明路1-11號;水上服務處：嘉義縣水上鄉中正路192號;布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0705室",
				"serviceAdd1": "朴子服務處：嘉義縣朴子市安福里文明路1-11號",
				"serviceAdd2": "水上服務處：嘉義縣水上鄉中正路192號",
				"serviceAdd3": "布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/clbundlaw?fref=ts\nhttps://www.facebook.com/bundlaw",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E6%98%93%E9%A4%98",
				"LineID": "@xyx4958e"
			}
		],
		"義竹鄉": [
			{
				"w": 9,
				"name": "蔡易餘",
				"ename": "Tsai Yi Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第1選舉區",
				"district": "六腳鄉、東石鄉、朴子市、太保市、布袋鎮、義竹鄉、鹿草鄉、水上鄉",
				"Email": "chiayionefish@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "嘉義市崇文國小\n ;水上鄉忠和國中\n ;嘉義高中\n ;臺灣大學財經法律系",
				"profession": "",
				"experience": "萬國法律事務所律師\n \n 民主進步黨中央執行委員\n \n 2014年張花冠縣長競選總幹事\n \n 台灣陪審團協會理事\n \n 凱達格蘭基金會理事\n \n 小英教育基金會顧問\n \n 民主進步黨嘉義縣黨部主委",
				"allTel": "國會研究室：02-2358-6388;朴子服務處：05-370-8518;布袋服務處：05-347-6822",
				"labTel": "02-2358-6388",
				"serviceTel1": "朴子服務處：05-370-8518",
				"serviceTel2": "布袋服務處：05-347-6822",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6385;朴子服務處：05-370-8519",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90090.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0705室;朴子服務處：嘉義縣朴子市安福里文明路1-11號;水上服務處：嘉義縣水上鄉中正路192號;布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0705室",
				"serviceAdd1": "朴子服務處：嘉義縣朴子市安福里文明路1-11號",
				"serviceAdd2": "水上服務處：嘉義縣水上鄉中正路192號",
				"serviceAdd3": "布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/clbundlaw?fref=ts\nhttps://www.facebook.com/bundlaw",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E6%98%93%E9%A4%98",
				"LineID": "@xyx4958e"
			}
		],
		"鹿草鄉": [
			{
				"w": 9,
				"name": "蔡易餘",
				"ename": "Tsai Yi Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第1選舉區",
				"district": "六腳鄉、東石鄉、朴子市、太保市、布袋鎮、義竹鄉、鹿草鄉、水上鄉",
				"Email": "chiayionefish@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "嘉義市崇文國小\n ;水上鄉忠和國中\n ;嘉義高中\n ;臺灣大學財經法律系",
				"profession": "",
				"experience": "萬國法律事務所律師\n \n 民主進步黨中央執行委員\n \n 2014年張花冠縣長競選總幹事\n \n 台灣陪審團協會理事\n \n 凱達格蘭基金會理事\n \n 小英教育基金會顧問\n \n 民主進步黨嘉義縣黨部主委",
				"allTel": "國會研究室：02-2358-6388;朴子服務處：05-370-8518;布袋服務處：05-347-6822",
				"labTel": "02-2358-6388",
				"serviceTel1": "朴子服務處：05-370-8518",
				"serviceTel2": "布袋服務處：05-347-6822",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6385;朴子服務處：05-370-8519",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90090.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0705室;朴子服務處：嘉義縣朴子市安福里文明路1-11號;水上服務處：嘉義縣水上鄉中正路192號;布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0705室",
				"serviceAdd1": "朴子服務處：嘉義縣朴子市安福里文明路1-11號",
				"serviceAdd2": "水上服務處：嘉義縣水上鄉中正路192號",
				"serviceAdd3": "布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/clbundlaw?fref=ts\nhttps://www.facebook.com/bundlaw",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E6%98%93%E9%A4%98",
				"LineID": "@xyx4958e"
			}
		],
		"水上鄉": [
			{
				"w": 9,
				"name": "蔡易餘",
				"ename": "Tsai Yi Yu",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "嘉義縣第1選舉區",
				"district": "六腳鄉、東石鄉、朴子市、太保市、布袋鎮、義竹鄉、鹿草鄉、水上鄉",
				"Email": "chiayionefish@gmail.com",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "嘉義市崇文國小\n ;水上鄉忠和國中\n ;嘉義高中\n ;臺灣大學財經法律系",
				"profession": "",
				"experience": "萬國法律事務所律師\n \n 民主進步黨中央執行委員\n \n 2014年張花冠縣長競選總幹事\n \n 台灣陪審團協會理事\n \n 凱達格蘭基金會理事\n \n 小英教育基金會顧問\n \n 民主進步黨嘉義縣黨部主委",
				"allTel": "國會研究室：02-2358-6388;朴子服務處：05-370-8518;布袋服務處：05-347-6822",
				"labTel": "02-2358-6388",
				"serviceTel1": "朴子服務處：05-370-8518",
				"serviceTel2": "布袋服務處：05-347-6822",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6385;朴子服務處：05-370-8519",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90090.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0705室;朴子服務處：嘉義縣朴子市安福里文明路1-11號;水上服務處：嘉義縣水上鄉中正路192號;布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0705室",
				"serviceAdd1": "朴子服務處：嘉義縣朴子市安福里文明路1-11號",
				"serviceAdd2": "水上服務處：嘉義縣水上鄉中正路192號",
				"serviceAdd3": "布袋服務處：嘉義縣布袋鎮上海路331-1號",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/clbundlaw?fref=ts\nhttps://www.facebook.com/bundlaw",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E6%98%93%E9%A4%98",
				"LineID": "@xyx4958e"
			}
		]
	},
	"連江縣": {
		"": [
			{
				"w": 9,
				"name": "陳雪生",
				"ename": "Chen Hsuen Sheng",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "連江縣選舉區",
				"district": "",
				"Email": "lionheart209@yahoo.com.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "省立豐原商職畢業",
				"profession": "",
				"experience": "第3屆國大代表\n 第3、4屆連江縣縣長\n 雪源文教基金會董事長\n 馬祖馬尾經貿交流協會理事長\n 國立馬祖高中校友會理事長 \n 連江縣體育會理事長\n 第8屆連江縣立法委員",
				"allTel": "國會研究室：02-2358-6631;南竿服務處：0836-25016",
				"labTel": "02-2358-6631",
				"serviceTel1": "南竿服務處：0836-25016",
				"serviceTel2": 919919191,
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6635;南竿服務處：0836-25018",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90066.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號2107室;南竿服務處：209連江縣南竿鄉介壽村237號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號2107室",
				"serviceAdd1": "南竿服務處：209連江縣南竿鄉介壽村237號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/profile.php?id=100002730369711&fref=ts\nhttps://www.facebook.com/matsuchenlionheart/",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E9%9B%AA%E7%94%9F",
				"LineID": ""
			}
		]
	},
	"宜蘭縣": {
		"": [
			{
				"w": 9,
				"name": "陳歐珀",
				"ename": "Chen Ou Po",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "宜蘭縣選舉區",
				"district": "",
				"Email": "ly11136a@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "國立中興大學森林研究所碩士\n ;國立中興大學森林所學士\n ;省立宜蘭高級中學",
				"profession": "交通委員會",
				"experience": "第8屆立法委員\n \n 國立臺灣大學環工所博士生\n \n 宜蘭縣政府機要秘書\n \n 勞委會羅東、新店就業服務站站長\n \n 國民大會代表\n \n 民進黨宜蘭縣黨部主任委員\n \n 臺灣省第10屆臺灣省議會議員\n \n 三星鄉代理鄉長（創辦蔥蒜節）\n \n 國立宜蘭大學兼任講師\n \n 林業科高考及格",
				"allTel": "國會研究室：02-2358-6220;宜蘭服務處：03-936-6299;羅東服務處：03-957-2099;03-957-2788",
				"labTel": "02-2358-6220",
				"serviceTel1": "宜蘭服務處：03-936-6299",
				"serviceTel2": "羅東服務處：03-957-2099",
				"serviceTel3": "03-957-2788",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6170;宜蘭服務處：03-936-6189",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90068.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0406室;宜蘭服務處：宜蘭市民族路593號;羅東服務處：羅東鎮興東南路152號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0406室",
				"serviceAdd1": "宜蘭服務處：宜蘭市民族路593號",
				"serviceAdd2": "羅東服務處：羅東鎮興東南路152號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/oupchen?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%99%B3%E6%AD%90%E7%8F%80",
				"LineID": ""
			}
		]
	},
	"南投縣": {
		"埔里鎮": [
			{
				"w": 9,
				"name": "馬文君",
				"ename": "Ma Wen Chun",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第1選舉區",
				"district": "埔里鎮、草屯鎮、中寮鄉、魚池鄉、國姓鄉、仁愛鄉",
				"Email": "mawenchun1201@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士 \n ;嘉南藥專(嘉南藥理科技大學)藥理科畢業 \n ;大成國中\n ;育英國小",
				"profession": "外交及國防委員會",
				"experience": "第7、8屆立法委員\n \n 立法院外交及國防委員會召集委員\n \n 南投縣婦工會總會長\n \n 南投縣民防總隊義警大隊大隊長\n \n 第14、15屆埔里鎮長\n \n 南投縣第13屆縣議員\n \n 弘道老人福利基金會助老委員\n \n 南投縣家扶中心委員",
				"allTel": "國會研究室：02-2358-6816;埔里服務處：049-242-3248;草屯服務處：049-235-5807;049-235-5023",
				"labTel": "02-2358-6816",
				"serviceTel1": "埔里服務處：049-242-3248",
				"serviceTel2": "草屯服務處：049-235-5807",
				"serviceTel3": "049-235-5023",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6820;埔里服務處：049-290-1626",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90048.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3113室;埔里服務處：南投縣埔里鎮西寧路36號;草屯服務處：南投縣草屯鎮新生路209號",
				"labAddr": "10051臺北市中正區青島東路1-3號3113室",
				"serviceAdd1": "埔里服務處：南投縣埔里鎮西寧路36號",
				"serviceAdd2": "草屯服務處：南投縣草屯鎮新生路209號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mawenchun?fref=ts\nhttps://www.facebook.com/nantou.go",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A6%AC%E6%96%87%E5%90%9B",
				"LineID": "@mawenchun"
			}
		],
		"草屯鎮": [
			{
				"w": 9,
				"name": "馬文君",
				"ename": "Ma Wen Chun",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第1選舉區",
				"district": "埔里鎮、草屯鎮、中寮鄉、魚池鄉、國姓鄉、仁愛鄉",
				"Email": "mawenchun1201@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士 \n ;嘉南藥專(嘉南藥理科技大學)藥理科畢業 \n ;大成國中\n ;育英國小",
				"profession": "外交及國防委員會",
				"experience": "第7、8屆立法委員\n \n 立法院外交及國防委員會召集委員\n \n 南投縣婦工會總會長\n \n 南投縣民防總隊義警大隊大隊長\n \n 第14、15屆埔里鎮長\n \n 南投縣第13屆縣議員\n \n 弘道老人福利基金會助老委員\n \n 南投縣家扶中心委員",
				"allTel": "國會研究室：02-2358-6816;埔里服務處：049-242-3248;草屯服務處：049-235-5807;049-235-5023",
				"labTel": "02-2358-6816",
				"serviceTel1": "埔里服務處：049-242-3248",
				"serviceTel2": "草屯服務處：049-235-5807",
				"serviceTel3": "049-235-5023",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6820;埔里服務處：049-290-1626",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90048.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3113室;埔里服務處：南投縣埔里鎮西寧路36號;草屯服務處：南投縣草屯鎮新生路209號",
				"labAddr": "10051臺北市中正區青島東路1-3號3113室",
				"serviceAdd1": "埔里服務處：南投縣埔里鎮西寧路36號",
				"serviceAdd2": "草屯服務處：南投縣草屯鎮新生路209號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mawenchun?fref=ts\nhttps://www.facebook.com/nantou.go",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A6%AC%E6%96%87%E5%90%9B",
				"LineID": "@mawenchun"
			}
		],
		"中寮鄉": [
			{
				"w": 9,
				"name": "馬文君",
				"ename": "Ma Wen Chun",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第1選舉區",
				"district": "埔里鎮、草屯鎮、中寮鄉、魚池鄉、國姓鄉、仁愛鄉",
				"Email": "mawenchun1201@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士 \n ;嘉南藥專(嘉南藥理科技大學)藥理科畢業 \n ;大成國中\n ;育英國小",
				"profession": "外交及國防委員會",
				"experience": "第7、8屆立法委員\n \n 立法院外交及國防委員會召集委員\n \n 南投縣婦工會總會長\n \n 南投縣民防總隊義警大隊大隊長\n \n 第14、15屆埔里鎮長\n \n 南投縣第13屆縣議員\n \n 弘道老人福利基金會助老委員\n \n 南投縣家扶中心委員",
				"allTel": "國會研究室：02-2358-6816;埔里服務處：049-242-3248;草屯服務處：049-235-5807;049-235-5023",
				"labTel": "02-2358-6816",
				"serviceTel1": "埔里服務處：049-242-3248",
				"serviceTel2": "草屯服務處：049-235-5807",
				"serviceTel3": "049-235-5023",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6820;埔里服務處：049-290-1626",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90048.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3113室;埔里服務處：南投縣埔里鎮西寧路36號;草屯服務處：南投縣草屯鎮新生路209號",
				"labAddr": "10051臺北市中正區青島東路1-3號3113室",
				"serviceAdd1": "埔里服務處：南投縣埔里鎮西寧路36號",
				"serviceAdd2": "草屯服務處：南投縣草屯鎮新生路209號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mawenchun?fref=ts\nhttps://www.facebook.com/nantou.go",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A6%AC%E6%96%87%E5%90%9B",
				"LineID": "@mawenchun"
			}
		],
		"魚池鄉": [
			{
				"w": 9,
				"name": "馬文君",
				"ename": "Ma Wen Chun",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第1選舉區",
				"district": "埔里鎮、草屯鎮、中寮鄉、魚池鄉、國姓鄉、仁愛鄉",
				"Email": "mawenchun1201@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士 \n ;嘉南藥專(嘉南藥理科技大學)藥理科畢業 \n ;大成國中\n ;育英國小",
				"profession": "外交及國防委員會",
				"experience": "第7、8屆立法委員\n \n 立法院外交及國防委員會召集委員\n \n 南投縣婦工會總會長\n \n 南投縣民防總隊義警大隊大隊長\n \n 第14、15屆埔里鎮長\n \n 南投縣第13屆縣議員\n \n 弘道老人福利基金會助老委員\n \n 南投縣家扶中心委員",
				"allTel": "國會研究室：02-2358-6816;埔里服務處：049-242-3248;草屯服務處：049-235-5807;049-235-5023",
				"labTel": "02-2358-6816",
				"serviceTel1": "埔里服務處：049-242-3248",
				"serviceTel2": "草屯服務處：049-235-5807",
				"serviceTel3": "049-235-5023",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6820;埔里服務處：049-290-1626",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90048.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3113室;埔里服務處：南投縣埔里鎮西寧路36號;草屯服務處：南投縣草屯鎮新生路209號",
				"labAddr": "10051臺北市中正區青島東路1-3號3113室",
				"serviceAdd1": "埔里服務處：南投縣埔里鎮西寧路36號",
				"serviceAdd2": "草屯服務處：南投縣草屯鎮新生路209號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mawenchun?fref=ts\nhttps://www.facebook.com/nantou.go",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A6%AC%E6%96%87%E5%90%9B",
				"LineID": "@mawenchun"
			}
		],
		"國姓鄉": [
			{
				"w": 9,
				"name": "馬文君",
				"ename": "Ma Wen Chun",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第1選舉區",
				"district": "埔里鎮、草屯鎮、中寮鄉、魚池鄉、國姓鄉、仁愛鄉",
				"Email": "mawenchun1201@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士 \n ;嘉南藥專(嘉南藥理科技大學)藥理科畢業 \n ;大成國中\n ;育英國小",
				"profession": "外交及國防委員會",
				"experience": "第7、8屆立法委員\n \n 立法院外交及國防委員會召集委員\n \n 南投縣婦工會總會長\n \n 南投縣民防總隊義警大隊大隊長\n \n 第14、15屆埔里鎮長\n \n 南投縣第13屆縣議員\n \n 弘道老人福利基金會助老委員\n \n 南投縣家扶中心委員",
				"allTel": "國會研究室：02-2358-6816;埔里服務處：049-242-3248;草屯服務處：049-235-5807;049-235-5023",
				"labTel": "02-2358-6816",
				"serviceTel1": "埔里服務處：049-242-3248",
				"serviceTel2": "草屯服務處：049-235-5807",
				"serviceTel3": "049-235-5023",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6820;埔里服務處：049-290-1626",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90048.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3113室;埔里服務處：南投縣埔里鎮西寧路36號;草屯服務處：南投縣草屯鎮新生路209號",
				"labAddr": "10051臺北市中正區青島東路1-3號3113室",
				"serviceAdd1": "埔里服務處：南投縣埔里鎮西寧路36號",
				"serviceAdd2": "草屯服務處：南投縣草屯鎮新生路209號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mawenchun?fref=ts\nhttps://www.facebook.com/nantou.go",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A6%AC%E6%96%87%E5%90%9B",
				"LineID": "@mawenchun"
			}
		],
		"仁愛鄉": [
			{
				"w": 9,
				"name": "馬文君",
				"ename": "Ma Wen Chun",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第1選舉區",
				"district": "埔里鎮、草屯鎮、中寮鄉、魚池鄉、國姓鄉、仁愛鄉",
				"Email": "mawenchun1201@gmail.com",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士 \n ;嘉南藥專(嘉南藥理科技大學)藥理科畢業 \n ;大成國中\n ;育英國小",
				"profession": "外交及國防委員會",
				"experience": "第7、8屆立法委員\n \n 立法院外交及國防委員會召集委員\n \n 南投縣婦工會總會長\n \n 南投縣民防總隊義警大隊大隊長\n \n 第14、15屆埔里鎮長\n \n 南投縣第13屆縣議員\n \n 弘道老人福利基金會助老委員\n \n 南投縣家扶中心委員",
				"allTel": "國會研究室：02-2358-6816;埔里服務處：049-242-3248;草屯服務處：049-235-5807;049-235-5023",
				"labTel": "02-2358-6816",
				"serviceTel1": "埔里服務處：049-242-3248",
				"serviceTel2": "草屯服務處：049-235-5807",
				"serviceTel3": "049-235-5023",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6820;埔里服務處：049-290-1626",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90048.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3113室;埔里服務處：南投縣埔里鎮西寧路36號;草屯服務處：南投縣草屯鎮新生路209號",
				"labAddr": "10051臺北市中正區青島東路1-3號3113室",
				"serviceAdd1": "埔里服務處：南投縣埔里鎮西寧路36號",
				"serviceAdd2": "草屯服務處：南投縣草屯鎮新生路209號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/mawenchun?fref=ts\nhttps://www.facebook.com/nantou.go",
				"wiki": "https://zh.wikipedia.org/wiki/%E9%A6%AC%E6%96%87%E5%90%9B",
				"LineID": "@mawenchun"
			}
		],
		"南投市": [
			{
				"w": 9,
				"name": "許淑華",
				"ename": "Hsu Shu Hua",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第2選舉區",
				"district": "南投市、名間鄉、集集鎮、竹山鎮、鹿谷鄉、水里鄉、信義鄉",
				"Email": "ntc6499@yahoo.com.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士畢",
				"profession": "",
				"experience": "南投縣議員南投縣商業會理事長\n \n 南開科技大學校友會會長\n \n 南投市長\n \n 立法委員",
				"allTel": "國會研究室：02-2358-8356;南投服務處：049-2226-116",
				"labTel": "02-2358-8356",
				"serviceTel1": "南投服務處：049-2226-116",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-3572;南投服務處：049-2226-117",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90056.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0206室;南投服務處：南投縣南投市玉井街51號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0206室",
				"serviceAdd1": "南投服務處：南投縣南投市玉井街51號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%A8%B1%E6%B7%91%E8%8F%AF-130771133668155/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%A8%B1%E6%B7%91%E8%8F%AF_(%E5%8D%97%E6%8A%95%E7%B8%A3)",
				"LineID": ""
			}
		],
		"名間鄉": [
			{
				"w": 9,
				"name": "許淑華",
				"ename": "Hsu Shu Hua",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第2選舉區",
				"district": "南投市、名間鄉、集集鎮、竹山鎮、鹿谷鄉、水里鄉、信義鄉",
				"Email": "ntc6499@yahoo.com.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士畢",
				"profession": "",
				"experience": "南投縣議員南投縣商業會理事長\n \n 南開科技大學校友會會長\n \n 南投市長\n \n 立法委員",
				"allTel": "國會研究室：02-2358-8356;南投服務處：049-2226-116",
				"labTel": "02-2358-8356",
				"serviceTel1": "南投服務處：049-2226-116",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-3572;南投服務處：049-2226-117",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90056.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0206室;南投服務處：南投縣南投市玉井街51號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0206室",
				"serviceAdd1": "南投服務處：南投縣南投市玉井街51號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%A8%B1%E6%B7%91%E8%8F%AF-130771133668155/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%A8%B1%E6%B7%91%E8%8F%AF_(%E5%8D%97%E6%8A%95%E7%B8%A3)",
				"LineID": ""
			}
		],
		"集集鎮": [
			{
				"w": 9,
				"name": "許淑華",
				"ename": "Hsu Shu Hua",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第2選舉區",
				"district": "南投市、名間鄉、集集鎮、竹山鎮、鹿谷鄉、水里鄉、信義鄉",
				"Email": "ntc6499@yahoo.com.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士畢",
				"profession": "",
				"experience": "南投縣議員南投縣商業會理事長\n \n 南開科技大學校友會會長\n \n 南投市長\n \n 立法委員",
				"allTel": "國會研究室：02-2358-8356;南投服務處：049-2226-116",
				"labTel": "02-2358-8356",
				"serviceTel1": "南投服務處：049-2226-116",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-3572;南投服務處：049-2226-117",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90056.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0206室;南投服務處：南投縣南投市玉井街51號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0206室",
				"serviceAdd1": "南投服務處：南投縣南投市玉井街51號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%A8%B1%E6%B7%91%E8%8F%AF-130771133668155/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%A8%B1%E6%B7%91%E8%8F%AF_(%E5%8D%97%E6%8A%95%E7%B8%A3)",
				"LineID": ""
			}
		],
		"竹山鎮": [
			{
				"w": 9,
				"name": "許淑華",
				"ename": "Hsu Shu Hua",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第2選舉區",
				"district": "南投市、名間鄉、集集鎮、竹山鎮、鹿谷鄉、水里鄉、信義鄉",
				"Email": "ntc6499@yahoo.com.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士畢",
				"profession": "",
				"experience": "南投縣議員南投縣商業會理事長\n \n 南開科技大學校友會會長\n \n 南投市長\n \n 立法委員",
				"allTel": "國會研究室：02-2358-8356;南投服務處：049-2226-116",
				"labTel": "02-2358-8356",
				"serviceTel1": "南投服務處：049-2226-116",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-3572;南投服務處：049-2226-117",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90056.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0206室;南投服務處：南投縣南投市玉井街51號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0206室",
				"serviceAdd1": "南投服務處：南投縣南投市玉井街51號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%A8%B1%E6%B7%91%E8%8F%AF-130771133668155/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%A8%B1%E6%B7%91%E8%8F%AF_(%E5%8D%97%E6%8A%95%E7%B8%A3)",
				"LineID": ""
			}
		],
		"鹿谷鄉": [
			{
				"w": 9,
				"name": "許淑華",
				"ename": "Hsu Shu Hua",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第2選舉區",
				"district": "南投市、名間鄉、集集鎮、竹山鎮、鹿谷鄉、水里鄉、信義鄉",
				"Email": "ntc6499@yahoo.com.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士畢",
				"profession": "",
				"experience": "南投縣議員南投縣商業會理事長\n \n 南開科技大學校友會會長\n \n 南投市長\n \n 立法委員",
				"allTel": "國會研究室：02-2358-8356;南投服務處：049-2226-116",
				"labTel": "02-2358-8356",
				"serviceTel1": "南投服務處：049-2226-116",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-3572;南投服務處：049-2226-117",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90056.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0206室;南投服務處：南投縣南投市玉井街51號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0206室",
				"serviceAdd1": "南投服務處：南投縣南投市玉井街51號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%A8%B1%E6%B7%91%E8%8F%AF-130771133668155/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%A8%B1%E6%B7%91%E8%8F%AF_(%E5%8D%97%E6%8A%95%E7%B8%A3)",
				"LineID": ""
			}
		],
		"水里鄉": [
			{
				"w": 9,
				"name": "許淑華",
				"ename": "Hsu Shu Hua",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第2選舉區",
				"district": "南投市、名間鄉、集集鎮、竹山鎮、鹿谷鄉、水里鄉、信義鄉",
				"Email": "ntc6499@yahoo.com.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士畢",
				"profession": "",
				"experience": "南投縣議員南投縣商業會理事長\n \n 南開科技大學校友會會長\n \n 南投市長\n \n 立法委員",
				"allTel": "國會研究室：02-2358-8356;南投服務處：049-2226-116",
				"labTel": "02-2358-8356",
				"serviceTel1": "南投服務處：049-2226-116",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-3572;南投服務處：049-2226-117",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90056.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0206室;南投服務處：南投縣南投市玉井街51號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0206室",
				"serviceAdd1": "南投服務處：南投縣南投市玉井街51號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%A8%B1%E6%B7%91%E8%8F%AF-130771133668155/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%A8%B1%E6%B7%91%E8%8F%AF_(%E5%8D%97%E6%8A%95%E7%B8%A3)",
				"LineID": ""
			}
		],
		"信義鄉": [
			{
				"w": 9,
				"name": "許淑華",
				"ename": "Hsu Shu Hua",
				"sex": "女",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "南投縣第2選舉區",
				"district": "南投市、名間鄉、集集鎮、竹山鎮、鹿谷鄉、水里鄉、信義鄉",
				"Email": "ntc6499@yahoo.com.tw",
				"committee": "第9屆第1會期：司法及法制委員會;第9屆第2會期：司法及法制委員會",
				"onboardDate": "2016/2/1",
				"degree": "逢甲大學經營管理碩士畢",
				"profession": "",
				"experience": "南投縣議員南投縣商業會理事長\n \n 南開科技大學校友會會長\n \n 南投市長\n \n 立法委員",
				"allTel": "國會研究室：02-2358-8356;南投服務處：049-2226-116",
				"labTel": "02-2358-8356",
				"serviceTel1": "南投服務處：049-2226-116",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-3572;南投服務處：049-2226-117",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90056.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0206室;南投服務處：南投縣南投市玉井街51號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0206室",
				"serviceAdd1": "南投服務處：南投縣南投市玉井街51號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E8%A8%B1%E6%B7%91%E8%8F%AF-130771133668155/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%A8%B1%E6%B7%91%E8%8F%AF_(%E5%8D%97%E6%8A%95%E7%B8%A3)",
				"LineID": ""
			}
		]
	},
	"澎湖縣": {
		"": [
			{
				"w": 9,
				"name": "楊曜",
				"ename": "Yang Yao",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "澎湖縣選舉區",
				"district": "",
				"Email": "yangyao126@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "東海大學法律系",
				"profession": "",
				"experience": "民進黨澎湖縣黨部主任委員\n \n 澎湖縣議員\n \n 立法委員",
				"allTel": "國會研究室：02-2358-6736;澎湖服務處：06-921-8678",
				"labTel": "02-2358-6736",
				"serviceTel1": "澎湖服務處：06-921-8678",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6740;澎湖服務處：06-921-1317",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90079.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0205室;澎湖服務處：澎湖縣馬公市新店路473號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0205室",
				"serviceAdd1": "澎湖服務處：澎湖縣馬公市新店路473號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/penghu.yao?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%A5%8A%E6%9B%9C",
				"LineID": "@qbp5104w"
			}
		]
	},
	"金門縣": {
		"": [
			{
				"w": 9,
				"name": "楊鎮浯",
				"ename": "Yang Cheng Wu",
				"sex": "男",
				"party": "中國國民黨",
				"partyGroup": "中國國民黨",
				"areaName": "金門縣選舉區",
				"district": "",
				"Email": "afficeboys@gmail.com",
				"committee": "第9屆第1會期：內政委員會;第9屆第2會期：內政委員會",
				"onboardDate": "2016/2/1",
				"degree": "金門高中\n ;文化大學經濟系\n ;英國西敏大學企管碩士",
				"profession": "內政委員會",
				"experience": "金控公司襄理\n \n 金門縣政府機要秘書\n \n 金門縣政府交通旅遊局專員\n \n 金門縣政府交通旅遊局局長\n \n 金門縣政府觀光處處長\n \n 中國國民黨大陸事務部副主任",
				"allTel": "國會研究室：02-2358-6099;金門服務處：082-375-230;臺南服務處：06-233-5927",
				"labTel": "02-2358-6099",
				"serviceTel1": "金門服務處：082-375-230",
				"serviceTel2": "臺南服務處：06-233-5927",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6100;金門服務處：082-375-155",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90080.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區青島東路1-3號3103室;金門服務處：金門縣金城鎮民生路69號;臺南服務處：臺南市永康區復國一路500號",
				"labAddr": "10051臺北市中正區青島東路1-3號3103室",
				"serviceAdd1": "金門服務處：金門縣金城鎮民生路69號",
				"serviceAdd2": "臺南服務處：臺南市永康區復國一路500號",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/yang.chengwu/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E6%A5%8A%E9%8E%AE%E6%B5%AF",
				"LineID": ""
			}
		]
	},
	"基隆市": {
		"": [
			{
				"w": 9,
				"name": "蔡適應",
				"ename": "Tsai Shih Ying",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "基隆市選舉區",
				"district": "",
				"Email": "coopertsai@mail2000.com.tw",
				"committee": "第9屆第1會期：外交及國防委員會;第9屆第2會期：外交及國防委員會",
				"onboardDate": "2016/2/1",
				"degree": "淡江大學國際事務與戰略研究所碩士\n ;東海大學政治系學士",
				"profession": "外交及國防委員會",
				"experience": "基隆市第16、17、18屆市議員\n \n 民進黨基隆市黨部主委\n \n 臺北大學都市計劃研究所博士候選人\n \n 比利時魯汶大學歐洲空間發展規劃（ESDP）訪問學人\n \n 經國管理學院憲法學講師\n \n 基隆柔術委員會主委、家扶中心助養人、社會公益團體幹部顧問\n \n 陸軍指職軍官班第一期\n \n 前基隆觀光協會理事長\n \n 前王拓立委服務處副主任",
				"allTel": "國會研究室：02-2358-6686",
				"labTel": "02-2358-6686",
				"serviceTel1": "",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6690",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90092.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0505室",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0505室",
				"serviceAdd1": "",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/%E5%9F%BA%E9%9A%86%E8%94%A1%E9%81%A9%E6%87%89-114129008623973\nhttps://www.facebook.com/tsai.shihying",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%94%A1%E9%81%A9%E6%87%89",
				"LineID": "@dxc1882b"
			}
		]
	},
	"雲林縣": {
		"崙背鄉": [
			{
				"w": 9,
				"name": "劉建國",
				"ename": "Liu Chien Kuo",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第2選舉區",
				"district": "崙背鄉、二崙鄉、西螺鎮、莿桐鄉、林內鄉、斗六市、大埤鄉、斗南鎮、古坑鄉",
				"Email": "liucnko@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "稻江科技暨管理學院老人福祉與社會工作學系",
				"profession": "",
				"experience": "立法院第7、8屆立法委員\n \n 立法院社會福利及衛生環境委員會召委\n \n 立法院厚生會會長\n \n 民進黨議會黨團召集人暨第15、16屆議員\n \n 第6屆斗六市民代表\n \n 雲林縣體育會副理事長\n \n 雲林縣棒球委員會主委\n \n 雲林縣社會關懷協會創會理事長",
				"allTel": "國會研究室：02-2358-8088;斗六服務處：05-534-2586;西螺服務處：05-587-3586",
				"labTel": "02-2358-8088",
				"serviceTel1": "斗六服務處：05-534-2586",
				"serviceTel2": "西螺服務處：05-587-3586",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8089;斗六服務處：05-532-2270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90087.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0602室;斗六服務處：640雲林縣斗六市公明路3號;西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0602室",
				"serviceAdd1": "斗六服務處：640雲林縣斗六市公明路3號",
				"serviceAdd2": "西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/liucnko.fans\nhttp://www.facebook.com/liucnko ",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E5%BB%BA%E5%9C%8B",
				"LineID": "@tmv4141f"
			}
		],
		"二崙鄉": [
			{
				"w": 9,
				"name": "劉建國",
				"ename": "Liu Chien Kuo",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第2選舉區",
				"district": "崙背鄉、二崙鄉、西螺鎮、莿桐鄉、林內鄉、斗六市、大埤鄉、斗南鎮、古坑鄉",
				"Email": "liucnko@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "稻江科技暨管理學院老人福祉與社會工作學系",
				"profession": "",
				"experience": "立法院第7、8屆立法委員\n \n 立法院社會福利及衛生環境委員會召委\n \n 立法院厚生會會長\n \n 民進黨議會黨團召集人暨第15、16屆議員\n \n 第6屆斗六市民代表\n \n 雲林縣體育會副理事長\n \n 雲林縣棒球委員會主委\n \n 雲林縣社會關懷協會創會理事長",
				"allTel": "國會研究室：02-2358-8088;斗六服務處：05-534-2586;西螺服務處：05-587-3586",
				"labTel": "02-2358-8088",
				"serviceTel1": "斗六服務處：05-534-2586",
				"serviceTel2": "西螺服務處：05-587-3586",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8089;斗六服務處：05-532-2270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90087.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0602室;斗六服務處：640雲林縣斗六市公明路3號;西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0602室",
				"serviceAdd1": "斗六服務處：640雲林縣斗六市公明路3號",
				"serviceAdd2": "西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/liucnko.fans\nhttp://www.facebook.com/liucnko ",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E5%BB%BA%E5%9C%8B",
				"LineID": "@tmv4141f"
			}
		],
		"西螺鎮": [
			{
				"w": 9,
				"name": "劉建國",
				"ename": "Liu Chien Kuo",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第2選舉區",
				"district": "崙背鄉、二崙鄉、西螺鎮、莿桐鄉、林內鄉、斗六市、大埤鄉、斗南鎮、古坑鄉",
				"Email": "liucnko@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "稻江科技暨管理學院老人福祉與社會工作學系",
				"profession": "",
				"experience": "立法院第7、8屆立法委員\n \n 立法院社會福利及衛生環境委員會召委\n \n 立法院厚生會會長\n \n 民進黨議會黨團召集人暨第15、16屆議員\n \n 第6屆斗六市民代表\n \n 雲林縣體育會副理事長\n \n 雲林縣棒球委員會主委\n \n 雲林縣社會關懷協會創會理事長",
				"allTel": "國會研究室：02-2358-8088;斗六服務處：05-534-2586;西螺服務處：05-587-3586",
				"labTel": "02-2358-8088",
				"serviceTel1": "斗六服務處：05-534-2586",
				"serviceTel2": "西螺服務處：05-587-3586",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8089;斗六服務處：05-532-2270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90087.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0602室;斗六服務處：640雲林縣斗六市公明路3號;西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0602室",
				"serviceAdd1": "斗六服務處：640雲林縣斗六市公明路3號",
				"serviceAdd2": "西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/liucnko.fans\nhttp://www.facebook.com/liucnko ",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E5%BB%BA%E5%9C%8B",
				"LineID": "@tmv4141f"
			}
		],
		"莿桐鄉": [
			{
				"w": 9,
				"name": "劉建國",
				"ename": "Liu Chien Kuo",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第2選舉區",
				"district": "崙背鄉、二崙鄉、西螺鎮、莿桐鄉、林內鄉、斗六市、大埤鄉、斗南鎮、古坑鄉",
				"Email": "liucnko@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "稻江科技暨管理學院老人福祉與社會工作學系",
				"profession": "",
				"experience": "立法院第7、8屆立法委員\n \n 立法院社會福利及衛生環境委員會召委\n \n 立法院厚生會會長\n \n 民進黨議會黨團召集人暨第15、16屆議員\n \n 第6屆斗六市民代表\n \n 雲林縣體育會副理事長\n \n 雲林縣棒球委員會主委\n \n 雲林縣社會關懷協會創會理事長",
				"allTel": "國會研究室：02-2358-8088;斗六服務處：05-534-2586;西螺服務處：05-587-3586",
				"labTel": "02-2358-8088",
				"serviceTel1": "斗六服務處：05-534-2586",
				"serviceTel2": "西螺服務處：05-587-3586",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8089;斗六服務處：05-532-2270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90087.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0602室;斗六服務處：640雲林縣斗六市公明路3號;西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0602室",
				"serviceAdd1": "斗六服務處：640雲林縣斗六市公明路3號",
				"serviceAdd2": "西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/liucnko.fans\nhttp://www.facebook.com/liucnko ",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E5%BB%BA%E5%9C%8B",
				"LineID": "@tmv4141f"
			}
		],
		"林內鄉": [
			{
				"w": 9,
				"name": "劉建國",
				"ename": "Liu Chien Kuo",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第2選舉區",
				"district": "崙背鄉、二崙鄉、西螺鎮、莿桐鄉、林內鄉、斗六市、大埤鄉、斗南鎮、古坑鄉",
				"Email": "liucnko@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "稻江科技暨管理學院老人福祉與社會工作學系",
				"profession": "",
				"experience": "立法院第7、8屆立法委員\n \n 立法院社會福利及衛生環境委員會召委\n \n 立法院厚生會會長\n \n 民進黨議會黨團召集人暨第15、16屆議員\n \n 第6屆斗六市民代表\n \n 雲林縣體育會副理事長\n \n 雲林縣棒球委員會主委\n \n 雲林縣社會關懷協會創會理事長",
				"allTel": "國會研究室：02-2358-8088;斗六服務處：05-534-2586;西螺服務處：05-587-3586",
				"labTel": "02-2358-8088",
				"serviceTel1": "斗六服務處：05-534-2586",
				"serviceTel2": "西螺服務處：05-587-3586",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8089;斗六服務處：05-532-2270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90087.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0602室;斗六服務處：640雲林縣斗六市公明路3號;西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0602室",
				"serviceAdd1": "斗六服務處：640雲林縣斗六市公明路3號",
				"serviceAdd2": "西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/liucnko.fans\nhttp://www.facebook.com/liucnko ",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E5%BB%BA%E5%9C%8B",
				"LineID": "@tmv4141f"
			}
		],
		"斗六市": [
			{
				"w": 9,
				"name": "劉建國",
				"ename": "Liu Chien Kuo",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第2選舉區",
				"district": "崙背鄉、二崙鄉、西螺鎮、莿桐鄉、林內鄉、斗六市、大埤鄉、斗南鎮、古坑鄉",
				"Email": "liucnko@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "稻江科技暨管理學院老人福祉與社會工作學系",
				"profession": "",
				"experience": "立法院第7、8屆立法委員\n \n 立法院社會福利及衛生環境委員會召委\n \n 立法院厚生會會長\n \n 民進黨議會黨團召集人暨第15、16屆議員\n \n 第6屆斗六市民代表\n \n 雲林縣體育會副理事長\n \n 雲林縣棒球委員會主委\n \n 雲林縣社會關懷協會創會理事長",
				"allTel": "國會研究室：02-2358-8088;斗六服務處：05-534-2586;西螺服務處：05-587-3586",
				"labTel": "02-2358-8088",
				"serviceTel1": "斗六服務處：05-534-2586",
				"serviceTel2": "西螺服務處：05-587-3586",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8089;斗六服務處：05-532-2270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90087.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0602室;斗六服務處：640雲林縣斗六市公明路3號;西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0602室",
				"serviceAdd1": "斗六服務處：640雲林縣斗六市公明路3號",
				"serviceAdd2": "西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/liucnko.fans\nhttp://www.facebook.com/liucnko ",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E5%BB%BA%E5%9C%8B",
				"LineID": "@tmv4141f"
			}
		],
		"大埤鄉": [
			{
				"w": 9,
				"name": "劉建國",
				"ename": "Liu Chien Kuo",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第2選舉區",
				"district": "崙背鄉、二崙鄉、西螺鎮、莿桐鄉、林內鄉、斗六市、大埤鄉、斗南鎮、古坑鄉",
				"Email": "liucnko@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "稻江科技暨管理學院老人福祉與社會工作學系",
				"profession": "",
				"experience": "立法院第7、8屆立法委員\n \n 立法院社會福利及衛生環境委員會召委\n \n 立法院厚生會會長\n \n 民進黨議會黨團召集人暨第15、16屆議員\n \n 第6屆斗六市民代表\n \n 雲林縣體育會副理事長\n \n 雲林縣棒球委員會主委\n \n 雲林縣社會關懷協會創會理事長",
				"allTel": "國會研究室：02-2358-8088;斗六服務處：05-534-2586;西螺服務處：05-587-3586",
				"labTel": "02-2358-8088",
				"serviceTel1": "斗六服務處：05-534-2586",
				"serviceTel2": "西螺服務處：05-587-3586",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8089;斗六服務處：05-532-2270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90087.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0602室;斗六服務處：640雲林縣斗六市公明路3號;西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0602室",
				"serviceAdd1": "斗六服務處：640雲林縣斗六市公明路3號",
				"serviceAdd2": "西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/liucnko.fans\nhttp://www.facebook.com/liucnko ",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E5%BB%BA%E5%9C%8B",
				"LineID": "@tmv4141f"
			}
		],
		"斗南鎮": [
			{
				"w": 9,
				"name": "劉建國",
				"ename": "Liu Chien Kuo",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第2選舉區",
				"district": "崙背鄉、二崙鄉、西螺鎮、莿桐鄉、林內鄉、斗六市、大埤鄉、斗南鎮、古坑鄉",
				"Email": "liucnko@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "稻江科技暨管理學院老人福祉與社會工作學系",
				"profession": "",
				"experience": "立法院第7、8屆立法委員\n \n 立法院社會福利及衛生環境委員會召委\n \n 立法院厚生會會長\n \n 民進黨議會黨團召集人暨第15、16屆議員\n \n 第6屆斗六市民代表\n \n 雲林縣體育會副理事長\n \n 雲林縣棒球委員會主委\n \n 雲林縣社會關懷協會創會理事長",
				"allTel": "國會研究室：02-2358-8088;斗六服務處：05-534-2586;西螺服務處：05-587-3586",
				"labTel": "02-2358-8088",
				"serviceTel1": "斗六服務處：05-534-2586",
				"serviceTel2": "西螺服務處：05-587-3586",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8089;斗六服務處：05-532-2270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90087.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0602室;斗六服務處：640雲林縣斗六市公明路3號;西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0602室",
				"serviceAdd1": "斗六服務處：640雲林縣斗六市公明路3號",
				"serviceAdd2": "西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/liucnko.fans\nhttp://www.facebook.com/liucnko ",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E5%BB%BA%E5%9C%8B",
				"LineID": "@tmv4141f"
			}
		],
		"古坑鄉": [
			{
				"w": 9,
				"name": "劉建國",
				"ename": "Liu Chien Kuo",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第2選舉區",
				"district": "崙背鄉、二崙鄉、西螺鎮、莿桐鄉、林內鄉、斗六市、大埤鄉、斗南鎮、古坑鄉",
				"Email": "liucnko@gmail.com",
				"committee": "第9屆第1會期：社會福利及衛生環境委員會;第9屆第2會期：社會福利及衛生環境委員會",
				"onboardDate": "2016/2/1",
				"degree": "稻江科技暨管理學院老人福祉與社會工作學系",
				"profession": "",
				"experience": "立法院第7、8屆立法委員\n \n 立法院社會福利及衛生環境委員會召委\n \n 立法院厚生會會長\n \n 民進黨議會黨團召集人暨第15、16屆議員\n \n 第6屆斗六市民代表\n \n 雲林縣體育會副理事長\n \n 雲林縣棒球委員會主委\n \n 雲林縣社會關懷協會創會理事長",
				"allTel": "國會研究室：02-2358-8088;斗六服務處：05-534-2586;西螺服務處：05-587-3586",
				"labTel": "02-2358-8088",
				"serviceTel1": "斗六服務處：05-534-2586",
				"serviceTel2": "西螺服務處：05-587-3586",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-8089;斗六服務處：05-532-2270",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90087.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0602室;斗六服務處：640雲林縣斗六市公明路3號;西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0602室",
				"serviceAdd1": "斗六服務處：640雲林縣斗六市公明路3號",
				"serviceAdd2": "西螺服務處：640雲林縣西螺鎮建興路365號之1",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/liucnko.fans\nhttp://www.facebook.com/liucnko ",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E5%BB%BA%E5%9C%8B",
				"LineID": "@tmv4141f"
			}
		],
		"麥寮鄉": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		],
		"臺西鄉": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		],
		"東勢鄉": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		],
		"褒忠鄉": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		],
		"土庫鎮": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		],
		"虎尾鎮": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		],
		"四湖鄉": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		],
		"元長鄉": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		],
		"口湖鄉": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		],
		"水林鄉": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		],
		"北港鎮": [
			{
				"w": 9,
				"name": "蘇治芬",
				"ename": "Su Chih Feng",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "雲林縣第1選舉區",
				"district": "麥寮鄉、臺西鄉、東勢鄉、褒忠鄉、土庫鎮、虎尾鎮、四湖鄉、元長鄉、口湖鄉、水林鄉、北港鎮",
				"Email": "lysuano@gmail.com",
				"committee": "第9屆第1會期：經濟委員會;第9屆第2會期：經濟委員會",
				"onboardDate": "2016/2/1",
				"degree": "雲林縣北港鎮南陽國小;雲林縣北港鎮北港初中;臺北市立士林商業職業學校畢業",
				"profession": "經濟委員會",
				"experience": "國民大會代表(1996-2000)\n 立法委員(2002-2005)\n 雲林縣長(2005-2014)\n 立法委員(2016-)",
				"allTel": "國會研究室：02-2358-6876;虎尾服務處：05-633-0021",
				"labTel": "02-2358-6876",
				"serviceTel1": "虎尾服務處：05-633-0021",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6880;虎尾服務處：05-632-5505",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90110.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0405室;虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0405室",
				"serviceAdd1": "虎尾服務處：632雲林縣虎尾鎮公安里水源路9巷11號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/suchihfen/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%98%87%E6%B2%BB%E8%8A%AC",
				"LineID": "@ofc4686k"
			}
		]
	},
	"臺東縣": {
		"": [
			{
				"w": 9,
				"name": "劉櫂豪",
				"ename": "Liu Chao Hao",
				"sex": "男",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "臺東縣選舉區",
				"district": "",
				"Email": "ly11145a@ly.gov.tw",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "臺東仁愛國小\n ;臺東新生國中\n ;臺東高中\n ;國立政治大學法律學系",
				"profession": "交通委員會",
				"experience": "法官\n \n 副縣長\n \n 律師\n \n 民進黨中央黨部組織推廣部主任\n \n 立法委員",
				"allTel": "國會研究室：02-2358-6286;臺東服務處：089-310-979",
				"labTel": "02-2358-6286",
				"serviceTel1": "臺東服務處：089-310-979",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6290;臺東服務處：089-310-879",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90088.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0303;臺東服務處：臺東市傳廣路18號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0303",
				"serviceAdd1": "臺東服務處：臺東市傳廣路18號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/ZhaoHaoLiu/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E5%8A%89%E6%AB%82%E8%B1%AA",
				"LineID": "@pss4210h"
			}
		]
	},
	"花蓮縣": {
		"": [
			{
				"w": 9,
				"name": "蕭美琴",
				"ename": "Hsiao Bi Khim",
				"sex": "女",
				"party": "民主進步黨",
				"partyGroup": "民主進步黨",
				"areaName": "花蓮縣選舉區",
				"district": "",
				"Email": "bikhim@bikhim.org",
				"committee": "第9屆第1會期：交通委員會;第9屆第2會期：交通委員會",
				"onboardDate": "2016/2/1",
				"degree": "美國哥倫比亞大學政治學碩士",
				"profession": "交通委員會",
				"experience": "第5、6、8屆立法委員\n \n 民進黨國際事務部主任\n \n 總統府顧問\n \n 亞洲民主自由聯盟(CALD)秘書長\n \n 行政院大陸委員會諮詢委員\n \n 新境界文教基金會副執行長\n \n 臺灣民主基金會董事\n \n 國際自由政黨聯盟(LI)副主席\n \n 海基會董事\n \n 美琴之友會名譽理事長",
				"allTel": "國會研究室：02-2358-6176;花蓮服務處：03-834-5353",
				"labTel": "02-2358-6176",
				"serviceTel1": "花蓮服務處：03-834-5353",
				"serviceTel2": "",
				"serviceTel3": "",
				"serviceTel4": "",
				"serviceTel5": "",
				"LabFax": "國會研究室：02-2358-6180;花蓮服務處：03-832-5008",
				"serviceFax1": "",
				"serviceFax2": "",
				"serviceFax3": "",
				"serviceFax4": "",
				"serviceFax5": "",
				"picUrl": "http://www.ly.gov.tw/upload/01_introduce/0103_leg/LGpicture/90100.jpg",
				"leaveDate": "",
				"allAddr": "國會研究室：10051臺北市中正區濟南路1段3-1號0305室;花蓮服務處：花蓮縣花蓮市中山路123號",
				"labAddr": "10051臺北市中正區濟南路1段3-1號0305室",
				"serviceAdd1": "花蓮服務處：花蓮縣花蓮市中山路123號",
				"serviceAdd2": "",
				"serviceAdd3": "",
				"serviceAdd4": "",
				"serviceAdd5": "",
				"facebook": "https://www.facebook.com/Bikhim/?fref=ts",
				"wiki": "https://zh.wikipedia.org/wiki/%E8%95%AD%E7%BE%8E%E7%90%B4",
				"LineID": "@ent1686l"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/legislators.json
// module id = 41
// module chunks = 2